var $b34bd66f0aa7fdf3$var$t = self;
function $b34bd66f0aa7fdf3$var$e() {
    throw Error("Invalid UTF8");
}
function $b34bd66f0aa7fdf3$var$n(t, e) {
    return e = String.fromCharCode.apply(null, e), null == t ? e : t + e;
}
let $b34bd66f0aa7fdf3$var$r, $b34bd66f0aa7fdf3$var$s;
const $b34bd66f0aa7fdf3$var$i = "undefined" != typeof TextDecoder;
let $b34bd66f0aa7fdf3$var$o;
const $b34bd66f0aa7fdf3$var$a = "undefined" != typeof TextEncoder;
function $b34bd66f0aa7fdf3$var$h(t) {
    if ($b34bd66f0aa7fdf3$var$a) t = ($b34bd66f0aa7fdf3$var$o ||= new TextEncoder).encode(t);
    else {
        let n = 0;
        const r = new Uint8Array(3 * t.length);
        for(let s = 0; s < t.length; s++){
            var e = t.charCodeAt(s);
            if (128 > e) r[n++] = e;
            else {
                if (2048 > e) r[n++] = e >> 6 | 192;
                else {
                    if (55296 <= e && 57343 >= e) {
                        if (56319 >= e && s < t.length) {
                            const i = t.charCodeAt(++s);
                            if (56320 <= i && 57343 >= i) {
                                e = 1024 * (e - 55296) + i - 56320 + 65536, r[n++] = e >> 18 | 240, r[n++] = e >> 12 & 63 | 128, r[n++] = e >> 6 & 63 | 128, r[n++] = 63 & e | 128;
                                continue;
                            }
                            s--;
                        }
                        e = 65533;
                    }
                    r[n++] = e >> 12 | 224, r[n++] = e >> 6 & 63 | 128;
                }
                r[n++] = 63 & e | 128;
            }
        }
        t = n === r.length ? r : r.subarray(0, n);
    }
    return t;
}
var $b34bd66f0aa7fdf3$var$c, $b34bd66f0aa7fdf3$var$u;
t: {
    for(var $b34bd66f0aa7fdf3$var$l = [
        "CLOSURE_FLAGS"
    ], $b34bd66f0aa7fdf3$var$f = $b34bd66f0aa7fdf3$var$t, $b34bd66f0aa7fdf3$var$d = 0; $b34bd66f0aa7fdf3$var$d < $b34bd66f0aa7fdf3$var$l.length; $b34bd66f0aa7fdf3$var$d++)if (null == ($b34bd66f0aa7fdf3$var$f = $b34bd66f0aa7fdf3$var$f[$b34bd66f0aa7fdf3$var$l[$b34bd66f0aa7fdf3$var$d]])) {
        $b34bd66f0aa7fdf3$var$u = null;
        break t;
    }
    $b34bd66f0aa7fdf3$var$u = $b34bd66f0aa7fdf3$var$f;
}
var $b34bd66f0aa7fdf3$var$p, $b34bd66f0aa7fdf3$var$g = $b34bd66f0aa7fdf3$var$u && $b34bd66f0aa7fdf3$var$u[610401301];
$b34bd66f0aa7fdf3$var$c = null != $b34bd66f0aa7fdf3$var$g && $b34bd66f0aa7fdf3$var$g;
const $b34bd66f0aa7fdf3$var$m = $b34bd66f0aa7fdf3$var$t.navigator;
function $b34bd66f0aa7fdf3$var$y(t) {
    return !!$b34bd66f0aa7fdf3$var$c && !!$b34bd66f0aa7fdf3$var$p && $b34bd66f0aa7fdf3$var$p.brands.some(({ brand: e })=>e && -1 != e.indexOf(t));
}
function $b34bd66f0aa7fdf3$var$v(e) {
    var n;
    return (n = $b34bd66f0aa7fdf3$var$t.navigator) && (n = n.userAgent) || (n = ""), -1 != n.indexOf(e);
}
function $b34bd66f0aa7fdf3$var$_() {
    return !!$b34bd66f0aa7fdf3$var$c && !!$b34bd66f0aa7fdf3$var$p && 0 < $b34bd66f0aa7fdf3$var$p.brands.length;
}
function $b34bd66f0aa7fdf3$var$w() {
    return $b34bd66f0aa7fdf3$var$_() ? $b34bd66f0aa7fdf3$var$y("Chromium") : ($b34bd66f0aa7fdf3$var$v("Chrome") || $b34bd66f0aa7fdf3$var$v("CriOS")) && !(!$b34bd66f0aa7fdf3$var$_() && $b34bd66f0aa7fdf3$var$v("Edge")) || $b34bd66f0aa7fdf3$var$v("Silk");
}
$b34bd66f0aa7fdf3$var$p = $b34bd66f0aa7fdf3$var$m && $b34bd66f0aa7fdf3$var$m.userAgentData || null;
var $b34bd66f0aa7fdf3$var$A = !$b34bd66f0aa7fdf3$var$_() && ($b34bd66f0aa7fdf3$var$v("Trident") || $b34bd66f0aa7fdf3$var$v("MSIE"));
!$b34bd66f0aa7fdf3$var$v("Android") || $b34bd66f0aa7fdf3$var$w(), $b34bd66f0aa7fdf3$var$w(), $b34bd66f0aa7fdf3$var$v("Safari") && ($b34bd66f0aa7fdf3$var$w() || !$b34bd66f0aa7fdf3$var$_() && $b34bd66f0aa7fdf3$var$v("Coast") || !$b34bd66f0aa7fdf3$var$_() && $b34bd66f0aa7fdf3$var$v("Opera") || !$b34bd66f0aa7fdf3$var$_() && $b34bd66f0aa7fdf3$var$v("Edge") || ($b34bd66f0aa7fdf3$var$_() ? $b34bd66f0aa7fdf3$var$y("Microsoft Edge") : $b34bd66f0aa7fdf3$var$v("Edg/")) || $b34bd66f0aa7fdf3$var$_() && $b34bd66f0aa7fdf3$var$y("Opera"));
var $b34bd66f0aa7fdf3$var$b = {}, $b34bd66f0aa7fdf3$var$E = null;
function $b34bd66f0aa7fdf3$var$T(t) {
    var e = t.length, n = 3 * e / 4;
    n % 3 ? n = Math.floor(n) : -1 != "=.".indexOf(t[e - 1]) && (n = -1 != "=.".indexOf(t[e - 2]) ? n - 2 : n - 1);
    var r = new Uint8Array(n), s = 0;
    return function(t, e) {
        function n(e) {
            for(; r < t.length;){
                var n = t.charAt(r++), s = $b34bd66f0aa7fdf3$var$E[n];
                if (null != s) return s;
                if (!/^[\s\xa0]*$/.test(n)) throw Error("Unknown base64 encoding at char: " + n);
            }
            return e;
        }
        $b34bd66f0aa7fdf3$var$k();
        for(var r = 0;;){
            var s = n(-1), i = n(0), o = n(64), a = n(64);
            if (64 === a && -1 === s) break;
            e(s << 2 | i >> 4), 64 != o && (e(i << 4 & 240 | o >> 2), 64 != a && e(o << 6 & 192 | a));
        }
    }(t, function(t) {
        r[s++] = t;
    }), s !== n ? r.subarray(0, s) : r;
}
function $b34bd66f0aa7fdf3$var$k() {
    if (!$b34bd66f0aa7fdf3$var$E) {
        $b34bd66f0aa7fdf3$var$E = {};
        for(var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), e = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], n = 0; 5 > n; n++){
            var r = t.concat(e[n].split(""));
            $b34bd66f0aa7fdf3$var$b[n] = r;
            for(var s = 0; s < r.length; s++){
                var i = r[s];
                void 0 === $b34bd66f0aa7fdf3$var$E[i] && ($b34bd66f0aa7fdf3$var$E[i] = s);
            }
        }
    }
}
var $b34bd66f0aa7fdf3$var$x = "undefined" != typeof Uint8Array, $b34bd66f0aa7fdf3$var$L = !$b34bd66f0aa7fdf3$var$A && "function" == typeof btoa;
function $b34bd66f0aa7fdf3$var$F(t) {
    if (!$b34bd66f0aa7fdf3$var$L) {
        var e;
        void 0 === e && (e = 0), $b34bd66f0aa7fdf3$var$k(), e = $b34bd66f0aa7fdf3$var$b[e];
        var n = Array(Math.floor(t.length / 3)), r = e[64] || "";
        let h = 0, c = 0;
        for(; h < t.length - 2; h += 3){
            var s = t[h], i = t[h + 1], o = t[h + 2], a = e[s >> 2];
            s = e[(3 & s) << 4 | i >> 4], i = e[(15 & i) << 2 | o >> 6], o = e[63 & o], n[c++] = a + s + i + o;
        }
        switch(a = 0, o = r, t.length - h){
            case 2:
                o = e[(15 & (a = t[h + 1])) << 2] || r;
            case 1:
                t = t[h], n[c] = e[t >> 2] + e[(3 & t) << 4 | a >> 4] + o + r;
        }
        return n.join("");
    }
    for(e = "", n = 0, r = t.length - 10240; n < r;)e += String.fromCharCode.apply(null, t.subarray(n, n += 10240));
    return e += String.fromCharCode.apply(null, n ? t.subarray(n) : t), btoa(e);
}
const $b34bd66f0aa7fdf3$var$S = /[-_.]/g, $b34bd66f0aa7fdf3$var$O = {
    "-": "+",
    _: "/",
    ".": "="
};
function $b34bd66f0aa7fdf3$var$M(t) {
    return $b34bd66f0aa7fdf3$var$O[t] || "";
}
function $b34bd66f0aa7fdf3$var$P(t) {
    if (!$b34bd66f0aa7fdf3$var$L) return $b34bd66f0aa7fdf3$var$T(t);
    $b34bd66f0aa7fdf3$var$S.test(t) && (t = t.replace($b34bd66f0aa7fdf3$var$S, $b34bd66f0aa7fdf3$var$M)), t = atob(t);
    const e = new Uint8Array(t.length);
    for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
    return e;
}
function $b34bd66f0aa7fdf3$var$R(t) {
    return $b34bd66f0aa7fdf3$var$x && null != t && t instanceof Uint8Array;
}
let $b34bd66f0aa7fdf3$var$C;
function $b34bd66f0aa7fdf3$var$I() {
    return $b34bd66f0aa7fdf3$var$C ||= new Uint8Array(0);
}
var $b34bd66f0aa7fdf3$var$D = {};
let $b34bd66f0aa7fdf3$var$B;
function $b34bd66f0aa7fdf3$var$U(t) {
    if (t !== $b34bd66f0aa7fdf3$var$D) throw Error("illegal external caller");
}
function $b34bd66f0aa7fdf3$var$N() {
    return $b34bd66f0aa7fdf3$var$B ||= new $b34bd66f0aa7fdf3$var$j(null, $b34bd66f0aa7fdf3$var$D);
}
function $b34bd66f0aa7fdf3$var$G(t) {
    $b34bd66f0aa7fdf3$var$U($b34bd66f0aa7fdf3$var$D);
    var e = t.N;
    return null == (e = null == e || $b34bd66f0aa7fdf3$var$R(e) ? e : "string" == typeof e ? $b34bd66f0aa7fdf3$var$P(e) : null) ? e : t.N = e;
}
var $b34bd66f0aa7fdf3$var$j = class {
    constructor(t, e){
        if ($b34bd66f0aa7fdf3$var$U(e), this.N = t, null != t && 0 === t.length) throw Error("ByteString should be constructed with non-empty values");
    }
    ha() {
        const t = $b34bd66f0aa7fdf3$var$G(this);
        return t ? new Uint8Array(t) : $b34bd66f0aa7fdf3$var$I();
    }
};
function $b34bd66f0aa7fdf3$var$V(t, e) {
    return Error(`Invalid wire type: ${t} (at position ${e})`);
}
function $b34bd66f0aa7fdf3$var$z() {
    return Error("Failed to read varint, encoding is invalid.");
}
function $b34bd66f0aa7fdf3$var$W(t, e) {
    return Error(`Tried to read past the end of the data ${e} > ${t}`);
}
function $b34bd66f0aa7fdf3$var$X(t) {
    return 0 == t.length ? $b34bd66f0aa7fdf3$var$N() : new $b34bd66f0aa7fdf3$var$j(t, $b34bd66f0aa7fdf3$var$D);
}
function $b34bd66f0aa7fdf3$var$H(t) {
    if ("string" == typeof t) return {
        buffer: $b34bd66f0aa7fdf3$var$P(t),
        H: !1
    };
    if (Array.isArray(t)) return {
        buffer: new Uint8Array(t),
        H: !1
    };
    if (t.constructor === Uint8Array) return {
        buffer: t,
        H: !1
    };
    if (t.constructor === ArrayBuffer) return {
        buffer: new Uint8Array(t),
        H: !1
    };
    if (t.constructor === $b34bd66f0aa7fdf3$var$j) return {
        buffer: $b34bd66f0aa7fdf3$var$G(t) || $b34bd66f0aa7fdf3$var$I(),
        H: !0
    };
    if (t instanceof Uint8Array) return {
        buffer: new Uint8Array(t.buffer, t.byteOffset, t.byteLength),
        H: !1
    };
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
}
const $b34bd66f0aa7fdf3$var$Y = "function" == typeof Uint8Array.prototype.slice;
let $b34bd66f0aa7fdf3$var$$, $b34bd66f0aa7fdf3$var$q = 0, $b34bd66f0aa7fdf3$var$K = 0;
function $b34bd66f0aa7fdf3$var$J(t) {
    const e = 0 > t;
    let n = (t = Math.abs(t)) >>> 0;
    if (t = Math.floor((t - n) / 4294967296), e) {
        const [e, r] = $b34bd66f0aa7fdf3$var$nt(n, t);
        t = r, n = e;
    }
    $b34bd66f0aa7fdf3$var$q = n >>> 0, $b34bd66f0aa7fdf3$var$K = t >>> 0;
}
function $b34bd66f0aa7fdf3$var$Z(t) {
    const e = $b34bd66f0aa7fdf3$var$$ ||= new DataView(new ArrayBuffer(8));
    e.setFloat32(0, +t, !0), $b34bd66f0aa7fdf3$var$K = 0, $b34bd66f0aa7fdf3$var$q = e.getUint32(0, !0);
}
function $b34bd66f0aa7fdf3$var$Q(t, e) {
    return 4294967296 * e + (t >>> 0);
}
function $b34bd66f0aa7fdf3$var$tt(t, e) {
    const n = 2147483648 & e;
    return n && (e = ~e >>> 0, 0 == (t = 1 + ~t >>> 0) && (e = e + 1 >>> 0)), t = $b34bd66f0aa7fdf3$var$Q(t, e), n ? -t : t;
}
function $b34bd66f0aa7fdf3$var$et(t) {
    if (16 > t.length) $b34bd66f0aa7fdf3$var$J(Number(t));
    else if ("function" == typeof BigInt) t = BigInt(t), $b34bd66f0aa7fdf3$var$q = Number(t & BigInt(4294967295)) >>> 0, $b34bd66f0aa7fdf3$var$K = Number(t >> BigInt(32) & BigInt(4294967295));
    else {
        const e = +("-" === t[0]);
        $b34bd66f0aa7fdf3$var$K = $b34bd66f0aa7fdf3$var$q = 0;
        const n = t.length;
        for(let r = e, s = (n - e) % 6 + e; s <= n; r = s, s += 6){
            const e = Number(t.slice(r, s));
            $b34bd66f0aa7fdf3$var$K *= 1e6, $b34bd66f0aa7fdf3$var$q = 1e6 * $b34bd66f0aa7fdf3$var$q + e, 4294967296 <= $b34bd66f0aa7fdf3$var$q && ($b34bd66f0aa7fdf3$var$K += Math.trunc($b34bd66f0aa7fdf3$var$q / 4294967296), $b34bd66f0aa7fdf3$var$K >>>= 0, $b34bd66f0aa7fdf3$var$q >>>= 0);
        }
        if (e) {
            const [t, e] = $b34bd66f0aa7fdf3$var$nt($b34bd66f0aa7fdf3$var$q, $b34bd66f0aa7fdf3$var$K);
            $b34bd66f0aa7fdf3$var$q = t, $b34bd66f0aa7fdf3$var$K = e;
        }
    }
}
function $b34bd66f0aa7fdf3$var$nt(t, e) {
    return e = ~e, t ? t = 1 + ~t : e += 1, [
        t,
        e
    ];
}
function $b34bd66f0aa7fdf3$var$rt(t, e, { R: n = !1 } = {}) {
    t.R = n, e && (e = $b34bd66f0aa7fdf3$var$H(e), t.h = e.buffer, t.s = e.H, t.v = 0, t.l = t.h.length, t.g = t.v);
}
function $b34bd66f0aa7fdf3$var$st(t, e) {
    if (t.g = e, e > t.l) throw $b34bd66f0aa7fdf3$var$W(t.l, e);
}
function $b34bd66f0aa7fdf3$var$it(t, e) {
    let n, r = 0, s = 0, i = 0;
    const o = t.h;
    let a = t.g;
    do n = o[a++], r |= (127 & n) << i, i += 7;
    while (32 > i && 128 & n);
    for(32 < i && (s |= (127 & n) >> 4), i = 3; 32 > i && 128 & n; i += 7)n = o[a++], s |= (127 & n) << i;
    if ($b34bd66f0aa7fdf3$var$st(t, a), 128 > n) return e(r >>> 0, s >>> 0);
    throw $b34bd66f0aa7fdf3$var$z();
}
function $b34bd66f0aa7fdf3$var$ot(t) {
    let e = 0, n = t.g;
    const r = n + 10, s = t.h;
    for(; n < r;){
        const r = s[n++];
        if (e |= r, 0 == (128 & r)) return $b34bd66f0aa7fdf3$var$st(t, n), !!(127 & e);
    }
    throw $b34bd66f0aa7fdf3$var$z();
}
function $b34bd66f0aa7fdf3$var$at(t) {
    var e = t.h;
    const n = t.g, r = e[n], s = e[n + 1], i = e[n + 2];
    return e = e[n + 3], $b34bd66f0aa7fdf3$var$st(t, t.g + 4), (r << 0 | s << 8 | i << 16 | e << 24) >>> 0;
}
function $b34bd66f0aa7fdf3$var$ht(t, e) {
    if (0 > e) throw Error(`Tried to read a negative byte length: ${e}`);
    const n = t.g, r = n + e;
    if (r > t.l) throw $b34bd66f0aa7fdf3$var$W(e, t.l - n);
    return t.g = r, n;
}
function $b34bd66f0aa7fdf3$var$ct(t, e) {
    if (0 == e) return $b34bd66f0aa7fdf3$var$N();
    var n = $b34bd66f0aa7fdf3$var$ht(t, e);
    return t.R && t.s ? n = t.h.subarray(n, n + e) : (t = t.h, n = n === (e = n + e) ? $b34bd66f0aa7fdf3$var$I() : $b34bd66f0aa7fdf3$var$Y ? t.slice(n, e) : new Uint8Array(t.subarray(n, e))), $b34bd66f0aa7fdf3$var$X(n);
}
var $b34bd66f0aa7fdf3$var$ut = class {
    constructor(t, e){
        this.h = null, this.s = !1, this.g = this.l = this.v = 0, $b34bd66f0aa7fdf3$var$rt(this, t, e);
    }
    m() {
        const t = this.h;
        let e = this.g, n = t[e++], r = 127 & n;
        if (128 & n && (n = t[e++], r |= (127 & n) << 7, 128 & n && (n = t[e++], r |= (127 & n) << 14, 128 & n && (n = t[e++], r |= (127 & n) << 21, 128 & n && (n = t[e++], r |= n << 28, 128 & n && 128 & t[e++] && 128 & t[e++] && 128 & t[e++] && 128 & t[e++] && 128 & t[e++]))))) throw $b34bd66f0aa7fdf3$var$z();
        return $b34bd66f0aa7fdf3$var$st(this, e), r;
    }
    j() {
        return this.m() >>> 0;
    }
    A() {
        var t = $b34bd66f0aa7fdf3$var$at(this);
        const e = 2 * (t >> 31) + 1, n = t >>> 23 & 255;
        return t &= 8388607, 255 == n ? t ? NaN : 1 / 0 * e : 0 == n ? e * Math.pow(2, -149) * t : e * Math.pow(2, n - 150) * (t + Math.pow(2, 23));
    }
    C() {
        return this.m();
    }
}, $b34bd66f0aa7fdf3$var$lt = [];
function $b34bd66f0aa7fdf3$var$ft(t) {
    var e = t.g;
    if (e.g == e.l) return !1;
    t.l = t.g.g;
    var n = t.g.j();
    if (e = n >>> 3, !(0 <= (n &= 7) && 5 >= n)) throw $b34bd66f0aa7fdf3$var$V(n, t.l);
    if (1 > e) throw Error(`Invalid field number: ${e} (at position ${t.l})`);
    return t.m = e, t.h = n, !0;
}
function $b34bd66f0aa7fdf3$var$dt(t) {
    switch(t.h){
        case 0:
            0 != t.h ? $b34bd66f0aa7fdf3$var$dt(t) : $b34bd66f0aa7fdf3$var$ot(t.g);
            break;
        case 1:
            $b34bd66f0aa7fdf3$var$st(t = t.g, t.g + 8);
            break;
        case 2:
            if (2 != t.h) $b34bd66f0aa7fdf3$var$dt(t);
            else {
                var e = t.g.j();
                $b34bd66f0aa7fdf3$var$st(t = t.g, t.g + e);
            }
            break;
        case 5:
            $b34bd66f0aa7fdf3$var$st(t = t.g, t.g + 4);
            break;
        case 3:
            for(e = t.m;;){
                if (!$b34bd66f0aa7fdf3$var$ft(t)) throw Error("Unmatched start-group tag: stream EOF");
                if (4 == t.h) {
                    if (t.m != e) throw Error("Unmatched end-group tag");
                    break;
                }
                $b34bd66f0aa7fdf3$var$dt(t);
            }
            break;
        default:
            throw $b34bd66f0aa7fdf3$var$V(t.h, t.l);
    }
}
function $b34bd66f0aa7fdf3$var$pt(t, e, n) {
    const r = t.g.l, s = t.g.j(), i = t.g.g + s;
    let o = i - r;
    if (0 >= o && (t.g.l = i, n(e, t, void 0, void 0, void 0), o = i - t.g.g), o) throw Error(`Message parsing ended unexpectedly. Expected to read ${s} bytes, instead read ${s - o} bytes, either the data ended unexpectedly or the message misreported its own length`);
    return t.g.g = i, t.g.l = r, e;
}
function $b34bd66f0aa7fdf3$var$gt(t) {
    var o = t.g.j(), a = $b34bd66f0aa7fdf3$var$ht(t = t.g, o);
    if (t = t.h, $b34bd66f0aa7fdf3$var$i) {
        var h, c = t;
        (h = $b34bd66f0aa7fdf3$var$s) || (h = $b34bd66f0aa7fdf3$var$s = new TextDecoder("utf-8", {
            fatal: !0
        })), t = a + o, c = 0 === a && t === c.length ? c : c.subarray(a, t);
        try {
            var u = h.decode(c);
        } catch (t) {
            if (void 0 === $b34bd66f0aa7fdf3$var$r) {
                try {
                    h.decode(new Uint8Array([
                        128
                    ]));
                } catch (t) {}
                try {
                    h.decode(new Uint8Array([
                        97
                    ])), $b34bd66f0aa7fdf3$var$r = !0;
                } catch (t) {
                    $b34bd66f0aa7fdf3$var$r = !1;
                }
            }
            throw !$b34bd66f0aa7fdf3$var$r && ($b34bd66f0aa7fdf3$var$s = void 0), t;
        }
    } else {
        o = (u = a) + o, a = [];
        let r, s = null;
        for(; u < o;){
            var l = t[u++];
            128 > l ? a.push(l) : 224 > l ? u >= o ? $b34bd66f0aa7fdf3$var$e() : (r = t[u++], 194 > l || 128 != (192 & r) ? (u--, $b34bd66f0aa7fdf3$var$e()) : a.push((31 & l) << 6 | 63 & r)) : 240 > l ? u >= o - 1 ? $b34bd66f0aa7fdf3$var$e() : (r = t[u++], 128 != (192 & r) || 224 === l && 160 > r || 237 === l && 160 <= r || 128 != (192 & (c = t[u++])) ? (u--, $b34bd66f0aa7fdf3$var$e()) : a.push((15 & l) << 12 | (63 & r) << 6 | 63 & c)) : 244 >= l ? u >= o - 2 ? $b34bd66f0aa7fdf3$var$e() : (r = t[u++], 128 != (192 & r) || 0 != r - 144 + (l << 28) >> 30 || 128 != (192 & (c = t[u++])) || 128 != (192 & (h = t[u++])) ? (u--, $b34bd66f0aa7fdf3$var$e()) : (l = (7 & l) << 18 | (63 & r) << 12 | (63 & c) << 6 | 63 & h, l -= 65536, a.push(55296 + (l >> 10 & 1023), 56320 + (1023 & l)))) : $b34bd66f0aa7fdf3$var$e(), 8192 <= a.length && (s = $b34bd66f0aa7fdf3$var$n(s, a), a.length = 0);
        }
        u = $b34bd66f0aa7fdf3$var$n(s, a);
    }
    return u;
}
function $b34bd66f0aa7fdf3$var$mt(t) {
    const e = t.g.j();
    return $b34bd66f0aa7fdf3$var$ct(t.g, e);
}
function $b34bd66f0aa7fdf3$var$yt(t, e, n) {
    var r = t.g.j();
    for(r = t.g.g + r; t.g.g < r;)n.push(e.call(t.g));
}
var $b34bd66f0aa7fdf3$var$vt = [];
function $b34bd66f0aa7fdf3$var$_t(t) {
    return t ? /^\d+$/.test(t) ? ($b34bd66f0aa7fdf3$var$et(t), new $b34bd66f0aa7fdf3$var$wt($b34bd66f0aa7fdf3$var$q, $b34bd66f0aa7fdf3$var$K)) : null : $b34bd66f0aa7fdf3$var$At ||= new $b34bd66f0aa7fdf3$var$wt(0, 0);
}
var $b34bd66f0aa7fdf3$var$wt = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
let $b34bd66f0aa7fdf3$var$At;
function $b34bd66f0aa7fdf3$var$bt(t) {
    return t ? /^-?\d+$/.test(t) ? ($b34bd66f0aa7fdf3$var$et(t), new $b34bd66f0aa7fdf3$var$Et($b34bd66f0aa7fdf3$var$q, $b34bd66f0aa7fdf3$var$K)) : null : $b34bd66f0aa7fdf3$var$Tt ||= new $b34bd66f0aa7fdf3$var$Et(0, 0);
}
var $b34bd66f0aa7fdf3$var$Et = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
let $b34bd66f0aa7fdf3$var$Tt;
function $b34bd66f0aa7fdf3$var$kt(t, e, n) {
    for(; 0 < n || 127 < e;)t.g.push(127 & e | 128), e = (e >>> 7 | n << 25) >>> 0, n >>>= 7;
    t.g.push(e);
}
function $b34bd66f0aa7fdf3$var$xt(t, e) {
    for(; 127 < e;)t.g.push(127 & e | 128), e >>>= 7;
    t.g.push(e);
}
function $b34bd66f0aa7fdf3$var$Lt(t, e) {
    if (0 <= e) $b34bd66f0aa7fdf3$var$xt(t, e);
    else {
        for(let n = 0; 9 > n; n++)t.g.push(127 & e | 128), e >>= 7;
        t.g.push(1);
    }
}
function $b34bd66f0aa7fdf3$var$Ft(t, e) {
    t.g.push(e >>> 0 & 255), t.g.push(e >>> 8 & 255), t.g.push(e >>> 16 & 255), t.g.push(e >>> 24 & 255);
}
function $b34bd66f0aa7fdf3$var$St(t, e) {
    0 !== e.length && (t.l.push(e), t.h += e.length);
}
function $b34bd66f0aa7fdf3$var$Ot(t, e, n) {
    $b34bd66f0aa7fdf3$var$xt(t.g, 8 * e + n);
}
function $b34bd66f0aa7fdf3$var$Mt(t, e) {
    return $b34bd66f0aa7fdf3$var$Ot(t, e, 2), e = t.g.end(), $b34bd66f0aa7fdf3$var$St(t, e), e.push(t.h), e;
}
function $b34bd66f0aa7fdf3$var$Pt(t, e) {
    var n = e.pop();
    for(n = t.h + t.g.length() - n; 127 < n;)e.push(127 & n | 128), n >>>= 7, t.h++;
    e.push(n), t.h++;
}
function $b34bd66f0aa7fdf3$var$Rt(t, e, n) {
    $b34bd66f0aa7fdf3$var$Ot(t, e, 2), $b34bd66f0aa7fdf3$var$xt(t.g, n.length), $b34bd66f0aa7fdf3$var$St(t, t.g.end()), $b34bd66f0aa7fdf3$var$St(t, n);
}
function $b34bd66f0aa7fdf3$var$Ct(t, e, n, r) {
    null != n && (e = $b34bd66f0aa7fdf3$var$Mt(t, e), r(n, t), $b34bd66f0aa7fdf3$var$Pt(t, e));
}
class $b34bd66f0aa7fdf3$var$It {
    constructor(t, e, n){
        this.g = t, this.h = e, this.l = n;
    }
}
function $b34bd66f0aa7fdf3$var$Dt(t) {
    return Array.prototype.slice.call(t);
}
const $b34bd66f0aa7fdf3$var$Bt = "function" == typeof Symbol && "symbol" == typeof Symbol() ? Symbol() : void 0;
var $b34bd66f0aa7fdf3$var$Ut = $b34bd66f0aa7fdf3$var$Bt ? (t, e)=>{
    t[$b34bd66f0aa7fdf3$var$Bt] |= e;
} : (t, e)=>{
    void 0 !== t.D ? t.D |= e : Object.defineProperties(t, {
        D: {
            value: e,
            configurable: !0,
            writable: !0,
            enumerable: !1
        }
    });
};
function $b34bd66f0aa7fdf3$var$Nt(t) {
    const e = $b34bd66f0aa7fdf3$var$jt(t);
    1 != (1 & e) && (Object.isFrozen(t) && (t = $b34bd66f0aa7fdf3$var$Dt(t)), $b34bd66f0aa7fdf3$var$zt(t, 1 | e));
}
var $b34bd66f0aa7fdf3$var$Gt = $b34bd66f0aa7fdf3$var$Bt ? (t, e)=>{
    t[$b34bd66f0aa7fdf3$var$Bt] &= ~e;
} : (t, e)=>{
    void 0 !== t.D && (t.D &= ~e);
}, $b34bd66f0aa7fdf3$var$jt = $b34bd66f0aa7fdf3$var$Bt ? (t)=>0 | t[$b34bd66f0aa7fdf3$var$Bt] : (t)=>0 | t.D, $b34bd66f0aa7fdf3$var$Vt = $b34bd66f0aa7fdf3$var$Bt ? (t)=>t[$b34bd66f0aa7fdf3$var$Bt] : (t)=>t.D, $b34bd66f0aa7fdf3$var$zt = $b34bd66f0aa7fdf3$var$Bt ? (t, e)=>{
    t[$b34bd66f0aa7fdf3$var$Bt] = e;
} : (t, e)=>{
    void 0 !== t.D ? t.D = e : Object.defineProperties(t, {
        D: {
            value: e,
            configurable: !0,
            writable: !0,
            enumerable: !1
        }
    });
};
function $b34bd66f0aa7fdf3$var$Wt() {
    var t = [];
    return $b34bd66f0aa7fdf3$var$Ut(t, 1), t;
}
function $b34bd66f0aa7fdf3$var$Xt(t) {
    return $b34bd66f0aa7fdf3$var$Ut(t, 34), t;
}
function $b34bd66f0aa7fdf3$var$Ht(t, e) {
    $b34bd66f0aa7fdf3$var$zt(e, -255 & (0 | t));
}
function $b34bd66f0aa7fdf3$var$Yt(t, e) {
    $b34bd66f0aa7fdf3$var$zt(e, -221 & (34 | t));
}
function $b34bd66f0aa7fdf3$var$$t(t) {
    return 0 === (t = t >> 11 & 1023) ? 536870912 : t;
}
var $b34bd66f0aa7fdf3$var$qt, $b34bd66f0aa7fdf3$var$Kt = {};
function $b34bd66f0aa7fdf3$var$Jt(t) {
    return null !== t && "object" == typeof t && !Array.isArray(t) && t.constructor === Object;
}
function $b34bd66f0aa7fdf3$var$Zt(t, e, n) {
    if (null != t) {
        if ("string" == typeof t) t = t ? new $b34bd66f0aa7fdf3$var$j(t, $b34bd66f0aa7fdf3$var$D) : $b34bd66f0aa7fdf3$var$N();
        else if (t.constructor !== $b34bd66f0aa7fdf3$var$j) {
            if ($b34bd66f0aa7fdf3$var$R(t)) t = n ? $b34bd66f0aa7fdf3$var$X(t) : t.length ? new $b34bd66f0aa7fdf3$var$j(new Uint8Array(t), $b34bd66f0aa7fdf3$var$D) : $b34bd66f0aa7fdf3$var$N();
            else {
                if (!e) throw Error();
                t = void 0;
            }
        }
    }
    return t;
}
const $b34bd66f0aa7fdf3$var$Qt = [];
function $b34bd66f0aa7fdf3$var$te(t) {
    if (2 & t) throw Error();
}
$b34bd66f0aa7fdf3$var$zt($b34bd66f0aa7fdf3$var$Qt, 55), $b34bd66f0aa7fdf3$var$qt = Object.freeze($b34bd66f0aa7fdf3$var$Qt);
class $b34bd66f0aa7fdf3$var$ee {
    constructor(t, e, n){
        this.l = 0, this.g = t, this.h = e, this.m = n;
    }
    next() {
        if (this.l < this.g.length) {
            const t = this.g[this.l++];
            return {
                done: !1,
                value: this.h ? this.h.call(this.m, t) : t
            };
        }
        return {
            done: !0,
            value: void 0
        };
    }
    [Symbol.iterator]() {
        return new $b34bd66f0aa7fdf3$var$ee(this.g, this.h, this.m);
    }
}
var $b34bd66f0aa7fdf3$var$ne = {};
let $b34bd66f0aa7fdf3$var$re, $b34bd66f0aa7fdf3$var$se;
function $b34bd66f0aa7fdf3$var$ie(t, e) {
    (e = $b34bd66f0aa7fdf3$var$re ? e[$b34bd66f0aa7fdf3$var$re] : void 0) && (t[$b34bd66f0aa7fdf3$var$re] = $b34bd66f0aa7fdf3$var$Dt(e));
}
function $b34bd66f0aa7fdf3$var$oe(t, e) {
    t.__closure__error__context__984382 || (t.__closure__error__context__984382 = {}), t.__closure__error__context__984382.severity = e;
}
function $b34bd66f0aa7fdf3$var$ae(t) {
    return null == t ? t : "number" == typeof t || "NaN" === t || "Infinity" === t || "-Infinity" === t ? Number(t) : void 0;
}
function $b34bd66f0aa7fdf3$var$he(t) {
    return null == t ? t : "boolean" == typeof t || "number" == typeof t ? !!t : void 0;
}
function $b34bd66f0aa7fdf3$var$ce(t) {
    return "number" == typeof t && Number.isFinite(t) || !!t && "string" == typeof t && isFinite(t);
}
function $b34bd66f0aa7fdf3$var$ue(t) {
    if (null == t) return t;
    if ("string" == typeof t) {
        if (!t) return;
        t = +t;
    }
    return "number" == typeof t ? t : void 0;
}
function $b34bd66f0aa7fdf3$var$le(t) {
    if (null == t) return t;
    if ("string" == typeof t) {
        if (!t) return;
        t = +t;
    }
    return "number" == typeof t ? t : void 0;
}
function $b34bd66f0aa7fdf3$var$fe(t) {
    if ("string" != typeof t) throw Error();
    return t;
}
function $b34bd66f0aa7fdf3$var$de(t) {
    if (null != t && "string" != typeof t) throw Error();
    return t;
}
function $b34bd66f0aa7fdf3$var$pe(t) {
    return null == t || "string" == typeof t ? t : void 0;
}
function $b34bd66f0aa7fdf3$var$ge(t, e, n, r) {
    var s = !1;
    return null == t || "object" != typeof t || (s = Array.isArray(t)) || t.M !== $b34bd66f0aa7fdf3$var$Kt ? s ? (0 === (s = n = $b34bd66f0aa7fdf3$var$jt(t)) && (s |= 32 & r), (s |= 2 & r) !== n && $b34bd66f0aa7fdf3$var$zt(t, s), new e(t)) : (n ? 2 & r ? (t = e[$b34bd66f0aa7fdf3$var$me]) ? e = t : ($b34bd66f0aa7fdf3$var$Xt((t = new e).u), e = e[$b34bd66f0aa7fdf3$var$me] = t) : e = new e : e = void 0, e) : t;
}
const $b34bd66f0aa7fdf3$var$me = "function" == typeof Symbol && "symbol" == typeof Symbol() ? Symbol() : "di";
function $b34bd66f0aa7fdf3$var$ye(t) {
    return t;
}
function $b34bd66f0aa7fdf3$var$ve(t, e, n) {
    return "string" == typeof (t = "number" === (e = typeof t) || "string" === e ? t : n ? 0 : void 0) && (n = +t, Number.isSafeInteger(n)) ? n : t;
}
let $b34bd66f0aa7fdf3$var$_e, $b34bd66f0aa7fdf3$var$we, $b34bd66f0aa7fdf3$var$Ae;
function $b34bd66f0aa7fdf3$var$be(t) {
    switch(typeof t){
        case "boolean":
            return $b34bd66f0aa7fdf3$var$we ||= [
                0,
                void 0,
                !0
            ];
        case "number":
            return 0 < t ? void 0 : 0 === t ? $b34bd66f0aa7fdf3$var$Ae ||= [
                0,
                void 0
            ] : [
                -t,
                void 0
            ];
        case "string":
            return [
                0,
                t
            ];
        case "object":
            return t;
    }
}
function $b34bd66f0aa7fdf3$var$Ee(t, e) {
    return $b34bd66f0aa7fdf3$var$Te(t, e[0], e[1]);
}
function $b34bd66f0aa7fdf3$var$Te(t, e, n) {
    if (null == t && (t = $b34bd66f0aa7fdf3$var$_e), $b34bd66f0aa7fdf3$var$_e = void 0, null == t) {
        var r = 96;
        n ? (t = [
            n
        ], r |= 512) : t = [], e && (r = -2095105 & r | (1023 & e) << 11);
    } else {
        if (!Array.isArray(t)) throw Error();
        if (64 & (r = $b34bd66f0aa7fdf3$var$jt(t))) return $b34bd66f0aa7fdf3$var$se && delete t[$b34bd66f0aa7fdf3$var$se], t;
        if (r |= 64, n && (r |= 512, n !== t[0])) throw Error();
        t: {
            var s = (n = t).length;
            if (s) {
                const t = s - 1;
                var i = n[t];
                if ($b34bd66f0aa7fdf3$var$Jt(i)) {
                    1024 <= (s = t - (e = +!!(512 & (r |= 256)) - 1)) && ($b34bd66f0aa7fdf3$var$ke(n, e, i), s = 1023), r = -2095105 & r | (1023 & s) << 11;
                    break t;
                }
            }
            e && (i = +!!(512 & r) - 1, 1024 < (e = Math.max(e, s - i)) && ($b34bd66f0aa7fdf3$var$ke(n, i, {}), r |= 256, e = 1023), r = -2095105 & r | (1023 & e) << 11);
        }
    }
    return $b34bd66f0aa7fdf3$var$zt(t, r), t;
}
function $b34bd66f0aa7fdf3$var$ke(t, e, n) {
    const r = 1023 + e, s = t.length;
    for(let i = r; i < s; i++){
        const r = t[i];
        null != r && r !== n && (n[i - e] = r);
    }
    t.length = r + 1, t[r] = n;
}
function $b34bd66f0aa7fdf3$var$xe(t) {
    if (2 & t.g) throw Error("Cannot mutate an immutable Map");
}
var $b34bd66f0aa7fdf3$var$Le = class extends Map {
    constructor(t, e, n = $b34bd66f0aa7fdf3$var$ye, r = $b34bd66f0aa7fdf3$var$ye){
        super();
        let s = $b34bd66f0aa7fdf3$var$jt(t);
        s |= 64, $b34bd66f0aa7fdf3$var$zt(t, s), this.g = s, this.l = e, this.h = n || $b34bd66f0aa7fdf3$var$ye, this.j = this.l ? $b34bd66f0aa7fdf3$var$Fe : r || $b34bd66f0aa7fdf3$var$ye;
        for(let i = 0; i < t.length; i++){
            const o = t[i], a = n(o[0], !1, !0);
            let h = o[1];
            e ? void 0 === h && (h = null) : h = r(o[1], !1, !0, void 0, void 0, s), super.set(a, h);
        }
    }
    s(t = $b34bd66f0aa7fdf3$var$Se) {
        return this.m(t);
    }
    m(t = $b34bd66f0aa7fdf3$var$Se) {
        const e = [], n = super.entries();
        for(var r; !(r = n.next()).done;)(r = r.value)[0] = t(r[0]), r[1] = t(r[1]), e.push(r);
        return e;
    }
    clear() {
        $b34bd66f0aa7fdf3$var$xe(this), super.clear();
    }
    delete(t) {
        return $b34bd66f0aa7fdf3$var$xe(this), super.delete(this.h(t, !0, !1));
    }
    entries() {
        var t = this.A();
        return new $b34bd66f0aa7fdf3$var$ee(t, $b34bd66f0aa7fdf3$var$Oe, this);
    }
    keys() {
        return this.C();
    }
    values() {
        var t = this.A();
        return new $b34bd66f0aa7fdf3$var$ee(t, $b34bd66f0aa7fdf3$var$Le.prototype.get, this);
    }
    forEach(t, e) {
        super.forEach((n, r)=>{
            t.call(e, this.get(r), r, this);
        });
    }
    set(t, e) {
        return $b34bd66f0aa7fdf3$var$xe(this), null == (t = this.h(t, !0, !1)) ? this : null == e ? (super.delete(t), this) : super.set(t, this.j(e, !0, !0, this.l, !1, this.g));
    }
    I(t) {
        const e = this.h(t[0], !1, !0);
        t = t[1], t = this.l ? void 0 === t ? null : t : this.j(t, !1, !0, void 0, !1, this.g), super.set(e, t);
    }
    has(t) {
        return super.has(this.h(t, !1, !1));
    }
    get(t) {
        t = this.h(t, !1, !1);
        const e = super.get(t);
        if (void 0 !== e) {
            var n = this.l;
            return n ? ((n = this.j(e, !1, !0, n, this.v, this.g)) !== e && super.set(t, n), n) : e;
        }
    }
    A() {
        return Array.from(super.keys());
    }
    C() {
        return super.keys();
    }
    [Symbol.iterator]() {
        return this.entries();
    }
};
function $b34bd66f0aa7fdf3$var$Fe(t, e, n, r, s, i) {
    return t = $b34bd66f0aa7fdf3$var$ge(t, r, n, i), s && (t = $b34bd66f0aa7fdf3$var$Ue(t)), t;
}
function $b34bd66f0aa7fdf3$var$Se(t) {
    return t;
}
function $b34bd66f0aa7fdf3$var$Oe(t) {
    return [
        t,
        this.get(t)
    ];
}
function $b34bd66f0aa7fdf3$var$Me(t, e, n, r, s, i) {
    if (null != t) {
        if (Array.isArray(t)) t = s && 0 == t.length && 1 & $b34bd66f0aa7fdf3$var$jt(t) ? void 0 : i && 2 & $b34bd66f0aa7fdf3$var$jt(t) ? t : $b34bd66f0aa7fdf3$var$Pe(t, e, n, void 0 !== r, s, i);
        else if ($b34bd66f0aa7fdf3$var$Jt(t)) {
            const o = {};
            for(let a in t)o[a] = $b34bd66f0aa7fdf3$var$Me(t[a], e, n, r, s, i);
            t = o;
        } else t = e(t, r);
        return t;
    }
}
function $b34bd66f0aa7fdf3$var$Pe(t, e, n, r, s, i) {
    const o = r || n ? $b34bd66f0aa7fdf3$var$jt(t) : 0;
    r = r ? !!(32 & o) : void 0;
    const a = $b34bd66f0aa7fdf3$var$Dt(t);
    for(let t = 0; t < a.length; t++)a[t] = $b34bd66f0aa7fdf3$var$Me(a[t], e, n, r, s, i);
    return n && ($b34bd66f0aa7fdf3$var$ie(a, t), n(o, a)), a;
}
function $b34bd66f0aa7fdf3$var$Re(t) {
    return $b34bd66f0aa7fdf3$var$Me(t, $b34bd66f0aa7fdf3$var$Ce, void 0, void 0, !1, !1);
}
function $b34bd66f0aa7fdf3$var$Ce(t) {
    return t.M === $b34bd66f0aa7fdf3$var$Kt ? t.toJSON() : t instanceof $b34bd66f0aa7fdf3$var$Le ? t.s($b34bd66f0aa7fdf3$var$Re) : function(t) {
        switch(typeof t){
            case "number":
                return isFinite(t) ? t : String(t);
            case "boolean":
                return t ? 1 : 0;
            case "object":
                if (t && !Array.isArray(t)) {
                    if ($b34bd66f0aa7fdf3$var$R(t)) return $b34bd66f0aa7fdf3$var$F(t);
                    if (t instanceof $b34bd66f0aa7fdf3$var$j) {
                        const e = t.N;
                        return null == e ? "" : "string" == typeof e ? e : t.N = $b34bd66f0aa7fdf3$var$F(e);
                    }
                    if (t instanceof $b34bd66f0aa7fdf3$var$Le) return t.s();
                }
        }
        return t;
    }(t);
}
function $b34bd66f0aa7fdf3$var$Ie(t, e, n = $b34bd66f0aa7fdf3$var$Yt) {
    if (null != t) {
        if ($b34bd66f0aa7fdf3$var$x && t instanceof Uint8Array) return e ? t : new Uint8Array(t);
        if (Array.isArray(t)) {
            var r = $b34bd66f0aa7fdf3$var$jt(t);
            return 2 & r ? t : (e &&= 0 === r || !!(32 & r) && !(64 & r || !(16 & r)), e ? ($b34bd66f0aa7fdf3$var$zt(t, 34 | r), 4 & r && Object.freeze(t), t) : $b34bd66f0aa7fdf3$var$Pe(t, $b34bd66f0aa7fdf3$var$Ie, 4 & r ? $b34bd66f0aa7fdf3$var$Yt : n, !0, !1, !0));
        }
        return t.M === $b34bd66f0aa7fdf3$var$Kt ? (n = t.u, t = 2 & (r = $b34bd66f0aa7fdf3$var$Vt(n)) ? t : $b34bd66f0aa7fdf3$var$De(t, n, r, !0)) : t instanceof $b34bd66f0aa7fdf3$var$Le && (n = $b34bd66f0aa7fdf3$var$Xt(t.m($b34bd66f0aa7fdf3$var$Ie)), t = new $b34bd66f0aa7fdf3$var$Le(n, t.l, t.h, t.j)), t;
    }
}
function $b34bd66f0aa7fdf3$var$De(t, e, n, r) {
    return t = t.constructor, $b34bd66f0aa7fdf3$var$_e = e = $b34bd66f0aa7fdf3$var$Be(e, n, r), e = new t(e), $b34bd66f0aa7fdf3$var$_e = void 0, e;
}
function $b34bd66f0aa7fdf3$var$Be(t, e, n) {
    const r = n || 2 & e ? $b34bd66f0aa7fdf3$var$Yt : $b34bd66f0aa7fdf3$var$Ht, s = !!(32 & e);
    return t = function(t, e, n) {
        const r = $b34bd66f0aa7fdf3$var$Dt(t);
        var s = r.length;
        const i = 256 & e ? r[s - 1] : void 0;
        for(s += i ? -1 : 0, e = 512 & e ? 1 : 0; e < s; e++)r[e] = n(r[e]);
        if (i) {
            e = r[e] = {};
            for(const t in i)e[t] = n(i[t]);
        }
        return $b34bd66f0aa7fdf3$var$ie(r, t), r;
    }(t, e, (t)=>$b34bd66f0aa7fdf3$var$Ie(t, s, r)), $b34bd66f0aa7fdf3$var$Ut(t, 32 | (n ? 2 : 0)), t;
}
function $b34bd66f0aa7fdf3$var$Ue(t) {
    const e = t.u, n = $b34bd66f0aa7fdf3$var$Vt(e);
    return 2 & n ? $b34bd66f0aa7fdf3$var$De(t, e, n, !1) : t;
}
function $b34bd66f0aa7fdf3$var$Ne(t, e) {
    return $b34bd66f0aa7fdf3$var$Ge(t = t.u, $b34bd66f0aa7fdf3$var$Vt(t), e);
}
function $b34bd66f0aa7fdf3$var$Ge(t, e, n, r) {
    if (-1 === n) return null;
    if (n >= $b34bd66f0aa7fdf3$var$$t(e)) {
        if (256 & e) return t[t.length - 1][n];
    } else {
        var s = t.length;
        if (r && 256 & e && null != (r = t[s - 1][n])) return r;
        if ((e = n + (+!!(512 & e) - 1)) < s) return t[e];
    }
}
function $b34bd66f0aa7fdf3$var$je(t, e, n, r) {
    const s = t.u, i = $b34bd66f0aa7fdf3$var$Vt(s);
    return $b34bd66f0aa7fdf3$var$te(i), $b34bd66f0aa7fdf3$var$Ve(s, i, e, n, r), t;
}
function $b34bd66f0aa7fdf3$var$Ve(t, e, n, r, s) {
    var i = $b34bd66f0aa7fdf3$var$$t(e);
    if (n >= i || s) {
        if (s = e, 256 & e) i = t[t.length - 1];
        else {
            if (null == r) return;
            i = t[i + (+!!(512 & e) - 1)] = {}, s |= 256;
        }
        i[n] = r, s !== e && $b34bd66f0aa7fdf3$var$zt(t, s);
    } else t[n + (+!!(512 & e) - 1)] = r, 256 & e && n in (t = t[t.length - 1]) && delete t[n];
}
function $b34bd66f0aa7fdf3$var$ze(t, e, n, r, s) {
    var i = 2 & e;
    let o = $b34bd66f0aa7fdf3$var$Ge(t, e, n, s);
    Array.isArray(o) || (o = $b34bd66f0aa7fdf3$var$qt);
    const a = !(2 & r), h = !(1 & r);
    r = !!(32 & e);
    let c = $b34bd66f0aa7fdf3$var$jt(o);
    return 0 !== c || !r || i || a ? 1 & c || (c |= 1, $b34bd66f0aa7fdf3$var$zt(o, c)) : (c |= 33, $b34bd66f0aa7fdf3$var$zt(o, c)), i ? (2 & c || $b34bd66f0aa7fdf3$var$Xt(o), h && Object.freeze(o)) : (i = 2 & c, h && i ? (o = $b34bd66f0aa7fdf3$var$Dt(o), i = 1, r && !a && (i |= 32), $b34bd66f0aa7fdf3$var$zt(o, i), $b34bd66f0aa7fdf3$var$Ve(t, e, n, o, s)) : a && 32 & c && !i && $b34bd66f0aa7fdf3$var$Gt(o, 32)), o;
}
function $b34bd66f0aa7fdf3$var$We(t, e) {
    t = t.u;
    const n = $b34bd66f0aa7fdf3$var$Vt(t), r = $b34bd66f0aa7fdf3$var$Ge(t, n, e), s = $b34bd66f0aa7fdf3$var$ae(r);
    return null != s && s !== r && $b34bd66f0aa7fdf3$var$Ve(t, n, e, s), s;
}
function $b34bd66f0aa7fdf3$var$Xe(t) {
    t = t.u;
    const e = $b34bd66f0aa7fdf3$var$Vt(t), n = $b34bd66f0aa7fdf3$var$Ge(t, e, 1), r = $b34bd66f0aa7fdf3$var$Zt(n, !0, !!(34 & e));
    return null != r && r !== n && $b34bd66f0aa7fdf3$var$Ve(t, e, 1, r), r;
}
function $b34bd66f0aa7fdf3$var$He(t, e, n) {
    t = t.u;
    const r = $b34bd66f0aa7fdf3$var$Vt(t), s = 2 & r;
    let i = $b34bd66f0aa7fdf3$var$ze(t, r, e, 1), o = $b34bd66f0aa7fdf3$var$jt(i);
    if (!(4 & o)) {
        Object.isFrozen(i) && (i = $b34bd66f0aa7fdf3$var$Dt(i), $b34bd66f0aa7fdf3$var$zt(i, o = -3 & o | 32), $b34bd66f0aa7fdf3$var$Ve(t, r, e, i));
        let a = 0, h = 0;
        for(; a < i.length; a++){
            const t = n(i[a]);
            null != t && (i[h++] = t);
        }
        h < a && (i.length = h), o |= 21, s ? o |= 34 : o &= -33, $b34bd66f0aa7fdf3$var$zt(i, o), 2 & o && Object.freeze(i);
    }
    return !s && (2 & o || Object.isFrozen(i)) && (i = $b34bd66f0aa7fdf3$var$Dt(i), $b34bd66f0aa7fdf3$var$zt(i, -35 & o), $b34bd66f0aa7fdf3$var$Ve(t, r, e, i)), i;
}
let $b34bd66f0aa7fdf3$var$Ye;
function $b34bd66f0aa7fdf3$var$$e() {
    return $b34bd66f0aa7fdf3$var$Ye ??= new $b34bd66f0aa7fdf3$var$Le($b34bd66f0aa7fdf3$var$Xt([]), void 0, void 0, void 0, $b34bd66f0aa7fdf3$var$ne);
}
function $b34bd66f0aa7fdf3$var$qe(t) {
    t = $b34bd66f0aa7fdf3$var$Dt(t);
    for(let e = 0; e < t.length; e++){
        const n = t[e] = $b34bd66f0aa7fdf3$var$Dt(t[e]);
        Array.isArray(n[1]) && (n[1] = $b34bd66f0aa7fdf3$var$Xt(n[1]));
    }
    return t;
}
function $b34bd66f0aa7fdf3$var$Ke(t, e, n) {
    {
        t = t.u;
        const r = $b34bd66f0aa7fdf3$var$Vt(t);
        if ($b34bd66f0aa7fdf3$var$te(r), null == n) $b34bd66f0aa7fdf3$var$Ve(t, r, e);
        else {
            if (!(4 & $b34bd66f0aa7fdf3$var$jt(n))) {
                Object.isFrozen(n) && (n = $b34bd66f0aa7fdf3$var$Dt(n));
                for(let t = 0; t < n.length; t++)n[t] = $b34bd66f0aa7fdf3$var$fe(n[t]);
                $b34bd66f0aa7fdf3$var$zt(n, 5);
            }
            $b34bd66f0aa7fdf3$var$Ve(t, r, e, n);
        }
    }
}
function $b34bd66f0aa7fdf3$var$Je(t, e) {
    return $b34bd66f0aa7fdf3$var$Ze(t = t.u, $b34bd66f0aa7fdf3$var$Vt(t), $b34bd66f0aa7fdf3$var$Vs) === e ? e : -1;
}
function $b34bd66f0aa7fdf3$var$Ze(t, e, n) {
    let r = 0;
    for(let s = 0; s < n.length; s++){
        const i = n[s];
        null != $b34bd66f0aa7fdf3$var$Ge(t, e, i) && (0 !== r && $b34bd66f0aa7fdf3$var$Ve(t, e, r), r = i);
    }
    return r;
}
function $b34bd66f0aa7fdf3$var$Qe(t, e, n, r) {
    const s = $b34bd66f0aa7fdf3$var$Vt(t);
    $b34bd66f0aa7fdf3$var$te(s);
    const i = $b34bd66f0aa7fdf3$var$Ge(t, s, n, r);
    let o;
    if (null != i && i.M === $b34bd66f0aa7fdf3$var$Kt) return (e = $b34bd66f0aa7fdf3$var$Ue(i)) !== i && $b34bd66f0aa7fdf3$var$Ve(t, s, n, e, r), e.u;
    if (Array.isArray(i)) {
        const t = $b34bd66f0aa7fdf3$var$jt(i);
        o = 2 & t ? $b34bd66f0aa7fdf3$var$Be(i, t, !1) : i, o = $b34bd66f0aa7fdf3$var$Ee(o, e);
    } else o = $b34bd66f0aa7fdf3$var$Ee(void 0, e);
    return o !== i && $b34bd66f0aa7fdf3$var$Ve(t, s, n, o, r), o;
}
function $b34bd66f0aa7fdf3$var$tn(t, e, n, r) {
    t = t.u;
    const s = $b34bd66f0aa7fdf3$var$Vt(t), i = $b34bd66f0aa7fdf3$var$Ge(t, s, n, r);
    return (e = $b34bd66f0aa7fdf3$var$ge(i, e, !1, s)) !== i && null != e && $b34bd66f0aa7fdf3$var$Ve(t, s, n, e, r), e;
}
function $b34bd66f0aa7fdf3$var$en(t, e, n, r = !1) {
    if (null == (e = $b34bd66f0aa7fdf3$var$tn(t, e, n, r))) return e;
    t = t.u;
    const s = $b34bd66f0aa7fdf3$var$Vt(t);
    if (!(2 & s)) {
        const i = $b34bd66f0aa7fdf3$var$Ue(e);
        i !== e && $b34bd66f0aa7fdf3$var$Ve(t, s, n, e = i, r);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$nn(t, e, n, r, s) {
    var i = !!(2 & e), o = $b34bd66f0aa7fdf3$var$ze(t, e, r, 1), a = o === $b34bd66f0aa7fdf3$var$qt;
    if (a && 2 !== s) return o;
    if (a || !(4 & $b34bd66f0aa7fdf3$var$jt(o))) {
        var h = o;
        o = !!(2 & e), a = !!(2 & $b34bd66f0aa7fdf3$var$jt(h)), i = h, !o && a && (h = $b34bd66f0aa7fdf3$var$Dt(h));
        var c = e | ((a = a || void 0) ? 2 : 0), u = a;
        a = !1;
        let l = 0, f = 0;
        for(; l < h.length; l++){
            const t = $b34bd66f0aa7fdf3$var$ge(h[l], n, !1, c);
            if (null == t) continue;
            const e = !!(2 & $b34bd66f0aa7fdf3$var$jt(t.u));
            u = u || e, a = a || !e, h[f++] = t;
        }
        return f < l && (h.length = f), c = 5 | (h = $b34bd66f0aa7fdf3$var$jt(n = h)), u = u ? -9 & c : 8 | c, h != (u = a ? -17 & u : 16 | u) && (Object.isFrozen(n) && (n = $b34bd66f0aa7fdf3$var$Dt(n)), $b34bd66f0aa7fdf3$var$zt(n, u)), i !== (h = n) && $b34bd66f0aa7fdf3$var$Ve(t, e, r, h), (o && 2 !== s || 1 === s) && Object.freeze(h), h;
    }
    return 3 === s || (i ? 2 === s && (s = $b34bd66f0aa7fdf3$var$jt(o), o = $b34bd66f0aa7fdf3$var$Dt(o), $b34bd66f0aa7fdf3$var$zt(o, s), $b34bd66f0aa7fdf3$var$Ve(t, e, r, o)) : (i = Object.isFrozen(o), 1 === s ? i || Object.freeze(o) : (n = -33 & (s = $b34bd66f0aa7fdf3$var$jt(o)), i || 2 & s ? (o = $b34bd66f0aa7fdf3$var$Dt(o), $b34bd66f0aa7fdf3$var$zt(o, -3 & n), $b34bd66f0aa7fdf3$var$Ve(t, e, r, o)) : s !== n && $b34bd66f0aa7fdf3$var$zt(o, n)))), o;
}
function $b34bd66f0aa7fdf3$var$rn(t, e, n) {
    var r = t.u;
    const s = $b34bd66f0aa7fdf3$var$Vt(r);
    if (e = $b34bd66f0aa7fdf3$var$nn(r, s, e, n, (t = !!(2 & s)) ? 1 : 2), !(t || 8 & $b34bd66f0aa7fdf3$var$jt(e))) {
        for(n = 0; n < e.length; n++)(t = e[n]) !== (r = $b34bd66f0aa7fdf3$var$Ue(t)) && (e[n] = r);
        $b34bd66f0aa7fdf3$var$Ut(e, 8);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$sn(t, e, n, r, s) {
    return null == r && (r = void 0), $b34bd66f0aa7fdf3$var$je(t, n, r, s);
}
function $b34bd66f0aa7fdf3$var$on(t, e, n, r) {
    null == r && (r = void 0), t = t.u;
    const s = $b34bd66f0aa7fdf3$var$Vt(t);
    $b34bd66f0aa7fdf3$var$te(s), (n = $b34bd66f0aa7fdf3$var$Ze(t, s, n)) && n !== e && null != r && $b34bd66f0aa7fdf3$var$Ve(t, s, n), $b34bd66f0aa7fdf3$var$Ve(t, s, e, r);
}
function $b34bd66f0aa7fdf3$var$an(t, e, n) {
    t = t.u;
    const r = $b34bd66f0aa7fdf3$var$Vt(t);
    $b34bd66f0aa7fdf3$var$te(r), t = $b34bd66f0aa7fdf3$var$nn(t, r, e, 1, 2), e = null != n ? n : new e, t.push(e), 2 & $b34bd66f0aa7fdf3$var$jt(e.u) ? $b34bd66f0aa7fdf3$var$Gt(t, 8) : $b34bd66f0aa7fdf3$var$Gt(t, 16);
}
function $b34bd66f0aa7fdf3$var$hn(t, e) {
    return $b34bd66f0aa7fdf3$var$ue($b34bd66f0aa7fdf3$var$Ne(t, e));
}
function $b34bd66f0aa7fdf3$var$cn(t) {
    return t = null == (t = $b34bd66f0aa7fdf3$var$Ne(t, 2)) || $b34bd66f0aa7fdf3$var$ce(t) ? t : void 0;
}
function $b34bd66f0aa7fdf3$var$un(t, e) {
    return $b34bd66f0aa7fdf3$var$pe($b34bd66f0aa7fdf3$var$Ne(t, e));
}
function $b34bd66f0aa7fdf3$var$ln(t) {
    return t ?? 0;
}
function $b34bd66f0aa7fdf3$var$fn(t, e) {
    return $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$We(t, e));
}
function $b34bd66f0aa7fdf3$var$dn(t, e, n) {
    if (null != n) {
        if ("boolean" != typeof n) throw t = typeof n, Error(`Expected boolean but got ${"object" != t ? t : n ? Array.isArray(n) ? "array" : t : "null"}: ${n}`);
        n = !!n;
    }
    $b34bd66f0aa7fdf3$var$je(t, e, n);
}
function $b34bd66f0aa7fdf3$var$pn(e, n, r) {
    if (null != r) {
        if ("number" != typeof r) throw $b34bd66f0aa7fdf3$var$oe(e = Error(), "warning"), e;
        if (!Number.isFinite(r)) {
            const e = Error();
            $b34bd66f0aa7fdf3$var$oe(e, "incident"), function(e) {
                $b34bd66f0aa7fdf3$var$t.setTimeout(()=>{
                    throw e;
                }, 0);
            }(e);
        }
    }
    $b34bd66f0aa7fdf3$var$je(e, n, r);
}
function $b34bd66f0aa7fdf3$var$gn(t, e, n) {
    if (null != n && "number" != typeof n) throw Error(`Value of float/double field must be a number, found ${typeof n}: ${n}`);
    $b34bd66f0aa7fdf3$var$je(t, e, n);
}
function $b34bd66f0aa7fdf3$var$mn(t, e, n) {
    n = $b34bd66f0aa7fdf3$var$fe(n), t = t.u;
    const r = $b34bd66f0aa7fdf3$var$Vt(t);
    $b34bd66f0aa7fdf3$var$te(r), $b34bd66f0aa7fdf3$var$ze(t, r, e, 2).push(n);
}
function $b34bd66f0aa7fdf3$var$yn(t, e, n) {
    e.g ? e.m(t, e.g, e.h, n, !0) : e.m(t, e.h, n, !0);
}
$b34bd66f0aa7fdf3$var$Le.prototype.toJSON = void 0;
var $b34bd66f0aa7fdf3$var$vn = class {
    constructor(t, e){
        this.u = $b34bd66f0aa7fdf3$var$Te(t, e);
    }
    toJSON() {
        return $b34bd66f0aa7fdf3$var$_n(this, $b34bd66f0aa7fdf3$var$Pe(this.u, $b34bd66f0aa7fdf3$var$Ce, void 0, void 0, !1, !1), !0);
    }
    l() {
        var t = $b34bd66f0aa7fdf3$var$Ui;
        return t.g ? t.l(this, t.g, t.h, !0) : t.l(this, t.h, t.defaultValue, !0);
    }
    clone() {
        const t = this.u;
        return $b34bd66f0aa7fdf3$var$De(this, t, $b34bd66f0aa7fdf3$var$Vt(t), !1);
    }
    H() {
        return !!(2 & $b34bd66f0aa7fdf3$var$jt(this.u));
    }
};
function $b34bd66f0aa7fdf3$var$_n(t, e, n) {
    var r = t.constructor.B, s = $b34bd66f0aa7fdf3$var$$t($b34bd66f0aa7fdf3$var$Vt(n ? t.u : e)), i = !1;
    if (r) {
        if (!n) {
            var o;
            if ((e = $b34bd66f0aa7fdf3$var$Dt(e)).length && $b34bd66f0aa7fdf3$var$Jt(o = e[e.length - 1])) {
                for(i = 0; i < r.length; i++)if (r[i] >= s) {
                    Object.assign(e[e.length - 1] = {}, o);
                    break;
                }
            }
            i = !0;
        }
        var a;
        s = e, n = !n, t = $b34bd66f0aa7fdf3$var$$t(o = $b34bd66f0aa7fdf3$var$Vt(t.u)), o = +!!(512 & o) - 1;
        for(let e = 0; e < r.length; e++){
            var h = r[e];
            if (h < t) {
                var c = s[h += o];
                null == c ? s[h] = n ? $b34bd66f0aa7fdf3$var$qt : $b34bd66f0aa7fdf3$var$Wt() : n && c !== $b34bd66f0aa7fdf3$var$qt && $b34bd66f0aa7fdf3$var$Nt(c);
            } else {
                if (!a) {
                    var u = void 0;
                    s.length && $b34bd66f0aa7fdf3$var$Jt(u = s[s.length - 1]) ? a = u : s.push(a = {});
                }
                c = a[h], null == a[h] ? a[h] = n ? $b34bd66f0aa7fdf3$var$qt : $b34bd66f0aa7fdf3$var$Wt() : n && c !== $b34bd66f0aa7fdf3$var$qt && $b34bd66f0aa7fdf3$var$Nt(c);
            }
        }
    }
    if (!(r = e.length)) return e;
    let l, f;
    if ($b34bd66f0aa7fdf3$var$Jt(a = e[r - 1])) {
        t: {
            var d = a;
            u = {}, s = !1;
            for(let t in d)n = d[t], Array.isArray(n) && n != n && (s = !0), null != n ? u[t] = n : s = !0;
            if (s) {
                for(let t in u){
                    d = u;
                    break t;
                }
                d = null;
            }
        }
        d != a && (l = !0), r--;
    }
    for(; 0 < r && null == (a = e[r - 1]); r--)f = !0;
    return l || f ? (e = i ? e : Array.prototype.slice.call(e, 0, r), i && (e.length = r), d && e.push(d), e) : e;
}
function $b34bd66f0aa7fdf3$var$wn(t) {
    return {
        ca: $b34bd66f0aa7fdf3$var$gr,
        U: t
    };
}
function $b34bd66f0aa7fdf3$var$An(t, e) {
    if (Array.isArray(e)) {
        var n = $b34bd66f0aa7fdf3$var$jt(e);
        if (4 & n) return e;
        for(var r = 0, s = 0; r < e.length; r++){
            const n = t(e[r]);
            null != n && (e[s++] = n);
        }
        return s < r && (e.length = s), $b34bd66f0aa7fdf3$var$zt(e, 5 | n), 2 & n && Object.freeze(e), e;
    }
}
$b34bd66f0aa7fdf3$var$vn.prototype.M = $b34bd66f0aa7fdf3$var$Kt, $b34bd66f0aa7fdf3$var$vn.prototype.toString = function() {
    return $b34bd66f0aa7fdf3$var$_n(this, this.u, !1).toString();
};
const $b34bd66f0aa7fdf3$var$bn = Symbol();
function $b34bd66f0aa7fdf3$var$En(t) {
    let e = t[$b34bd66f0aa7fdf3$var$bn];
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$Sn(t), r = $b34bd66f0aa7fdf3$var$Gn(t), s = r.h;
        e = s ? (t, e)=>s(t, e, r) : (t, e)=>{
            for(; $b34bd66f0aa7fdf3$var$ft(e) && 4 != e.h;){
                var s = e.m, i = r[s];
                if (!i) {
                    var o = r.g;
                    o && (o = o[s]) && (i = r[s] = $b34bd66f0aa7fdf3$var$Tn(o));
                }
                i && i(e, t, s) || (s = (i = e).l, $b34bd66f0aa7fdf3$var$dt(i), i.aa ? i = void 0 : (o = i.g.g - s, i.g.g = s, i = $b34bd66f0aa7fdf3$var$ct(i.g, o)), s = t, i && ($b34bd66f0aa7fdf3$var$re ||= Symbol(), (o = s[$b34bd66f0aa7fdf3$var$re]) ? o.push(i) : s[$b34bd66f0aa7fdf3$var$re] = [
                    i
                ]));
            }
            for(const e in n){
                t[$b34bd66f0aa7fdf3$var$se ||= Symbol()] = n;
                break;
            }
        }, t[$b34bd66f0aa7fdf3$var$bn] = e;
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Tn(t) {
    const e = function(t) {
        if (t = t.U) return $b34bd66f0aa7fdf3$var$En(t);
    }(t), n = t.ca.g;
    if (e) {
        const r = $b34bd66f0aa7fdf3$var$Gn(t.U).L;
        return (t, s, i)=>n(t, s, i, r, e);
    }
    return (t, e, r)=>n(t, e, r);
}
const $b34bd66f0aa7fdf3$var$kn = Symbol();
function $b34bd66f0aa7fdf3$var$xn(t, e, n, r) {
    let s;
    if (r) {
        const e = r[$b34bd66f0aa7fdf3$var$kn];
        s = e ? e.L : $b34bd66f0aa7fdf3$var$be(r[0]), n[t] = e ?? r;
    }
    s && s === $b34bd66f0aa7fdf3$var$we ? ((e = n.xa) || (n.xa = e = []), e.push(t)) : e.l && ((e = n.Ba) || (n.Ba = e = []), e.push(t));
}
function $b34bd66f0aa7fdf3$var$Ln(t, e, n, r) {
    $b34bd66f0aa7fdf3$var$xn(t, e, r);
}
function $b34bd66f0aa7fdf3$var$Fn(t, e, n, r, s) {
    $b34bd66f0aa7fdf3$var$xn(t, e, s, n);
}
function $b34bd66f0aa7fdf3$var$Sn(t) {
    let e = t[$b34bd66f0aa7fdf3$var$kn];
    return e || (e = t[$b34bd66f0aa7fdf3$var$kn] = {}, $b34bd66f0aa7fdf3$var$On(t, e, $b34bd66f0aa7fdf3$var$Ln, $b34bd66f0aa7fdf3$var$Fn, e));
}
function $b34bd66f0aa7fdf3$var$On(t, e, n, r, s) {
    e.L = $b34bd66f0aa7fdf3$var$be(t[0]);
    let i = 1;
    if (t.length > i && !(t[i] instanceof $b34bd66f0aa7fdf3$var$It)) {
        var o = t[i++];
        if (Array.isArray(o)) return e.h = o[0], e.g = o[1], e;
        e.g = o;
    }
    for(o = 0; i < t.length;){
        var a = t[i++], h = t[i];
        for("number" == typeof h ? (i++, o += h) : o++, h = i; h < t.length && !(t[h] instanceof $b34bd66f0aa7fdf3$var$It);)h++;
        if (h -= i) {
            var c = t, u = i, l = c[u];
            if ("function" == typeof l && (l = l(), c[u] = l), (c = Array.isArray(l)) && !(c = $b34bd66f0aa7fdf3$var$Bn in l || $b34bd66f0aa7fdf3$var$Rn in l) && (c = 0 < l.length)) {
                const t = $b34bd66f0aa7fdf3$var$be(u = (c = l)[0]);
                null != t && t !== u && (c[0] = t), c = null != t;
            }
            (l = c ? l : void 0) ? (i++, 1 === h ? void 0 !== (a = r(o, a, l, void 0, s)) && (e[o] = a) : void 0 !== (a = r(o, a, l, t[i++], s)) && (e[o] = a)) : void 0 !== (a = n(o, a, t[i++], s)) && (e[o] = a);
        } else void 0 !== (a = n(o, a, void 0, s)) && (e[o] = a);
    }
    return e;
}
const $b34bd66f0aa7fdf3$var$Mn = Symbol();
function $b34bd66f0aa7fdf3$var$Pn(t) {
    let e = t[$b34bd66f0aa7fdf3$var$Mn];
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$Dn(t);
        e = (t, e)=>$b34bd66f0aa7fdf3$var$Vn(t, e, n), t[$b34bd66f0aa7fdf3$var$Mn] = e;
    }
    return e;
}
const $b34bd66f0aa7fdf3$var$Rn = Symbol();
function $b34bd66f0aa7fdf3$var$Cn(t, e) {
    return e.h;
}
function $b34bd66f0aa7fdf3$var$In(t, e, n) {
    let r, s;
    const i = e.h;
    return (t, e, o)=>i(t, e, o, s ||= $b34bd66f0aa7fdf3$var$Dn(n).L, r ||= $b34bd66f0aa7fdf3$var$Pn(n));
}
function $b34bd66f0aa7fdf3$var$Dn(t) {
    let e = t[$b34bd66f0aa7fdf3$var$Rn];
    return e || (e = $b34bd66f0aa7fdf3$var$On(t, t[$b34bd66f0aa7fdf3$var$Rn] = {}, $b34bd66f0aa7fdf3$var$Cn, $b34bd66f0aa7fdf3$var$In), $b34bd66f0aa7fdf3$var$Bn in t && $b34bd66f0aa7fdf3$var$Rn in t && (t.length = 0), e);
}
const $b34bd66f0aa7fdf3$var$Bn = Symbol();
function $b34bd66f0aa7fdf3$var$Un(t, e, n) {
    const r = e.g;
    return n ? (t, e, s)=>r(t, e, s, n) : r;
}
function $b34bd66f0aa7fdf3$var$Nn(t, e, n, r) {
    const s = e.g;
    let i, o;
    return (t, e, a)=>s(t, e, a, o ||= $b34bd66f0aa7fdf3$var$Gn(n).L, i ||= $b34bd66f0aa7fdf3$var$En(n), r);
}
function $b34bd66f0aa7fdf3$var$Gn(t) {
    let e = t[$b34bd66f0aa7fdf3$var$Bn];
    return e || ($b34bd66f0aa7fdf3$var$Sn(t), e = $b34bd66f0aa7fdf3$var$On(t, t[$b34bd66f0aa7fdf3$var$Bn] = {}, $b34bd66f0aa7fdf3$var$Un, $b34bd66f0aa7fdf3$var$Nn), $b34bd66f0aa7fdf3$var$Bn in t && $b34bd66f0aa7fdf3$var$Rn in t && (t.length = 0), e);
}
function $b34bd66f0aa7fdf3$var$jn(t, e) {
    var n = t[e];
    if (n) return n;
    if ((n = t.g) && (n = n[e])) {
        var r = n.U, s = n.ca.h;
        if (r) {
            const t = $b34bd66f0aa7fdf3$var$Pn(r), e = $b34bd66f0aa7fdf3$var$Dn(r).L;
            n = (n, r, i)=>s(n, r, i, e, t);
        } else n = s;
        return t[e] = n;
    }
}
function $b34bd66f0aa7fdf3$var$Vn(t, e, n) {
    for(var r = $b34bd66f0aa7fdf3$var$Vt(t), s = +!!(512 & r) - 1, i = t.length, o = 512 & r ? 1 : 0, a = i + (256 & r ? -1 : 0); o < a; o++){
        const r = t[o];
        if (null == r) continue;
        const i = o - s, a = $b34bd66f0aa7fdf3$var$jn(n, i);
        a && a(e, r, i);
    }
    if (256 & r) {
        r = t[i - 1];
        for(let t in r)s = +t, Number.isNaN(s) || null != (i = r[t]) && (a = $b34bd66f0aa7fdf3$var$jn(n, s)) && a(e, i, s);
    }
    if (t = $b34bd66f0aa7fdf3$var$re ? t[$b34bd66f0aa7fdf3$var$re] : void 0) for($b34bd66f0aa7fdf3$var$St(e, e.g.end()), n = 0; n < t.length; n++)$b34bd66f0aa7fdf3$var$St(e, $b34bd66f0aa7fdf3$var$G(t[n]) || $b34bd66f0aa7fdf3$var$I());
}
function $b34bd66f0aa7fdf3$var$zn(t, e) {
    return new $b34bd66f0aa7fdf3$var$It(t, e, !1);
}
function $b34bd66f0aa7fdf3$var$Wn(t, e) {
    return new $b34bd66f0aa7fdf3$var$It(t, e, !0);
}
function $b34bd66f0aa7fdf3$var$Xn(t, e, n) {
    $b34bd66f0aa7fdf3$var$Ve(t, $b34bd66f0aa7fdf3$var$Vt(t), e, n);
}
var $b34bd66f0aa7fdf3$var$Hn = $b34bd66f0aa7fdf3$var$zn(function(t, e, n, r, s) {
    return 2 === t.h && (t = $b34bd66f0aa7fdf3$var$pt(t, $b34bd66f0aa7fdf3$var$Ee([
        void 0,
        void 0
    ], r), s), $b34bd66f0aa7fdf3$var$te(r = $b34bd66f0aa7fdf3$var$Vt(e)), (s = $b34bd66f0aa7fdf3$var$Ge(e, r, n)) instanceof $b34bd66f0aa7fdf3$var$Le ? 0 != (2 & s.g) ? ((s = s.m()).push(t), $b34bd66f0aa7fdf3$var$Ve(e, r, n, s)) : s.I(t) : Array.isArray(s) ? (2 & $b34bd66f0aa7fdf3$var$jt(s) && $b34bd66f0aa7fdf3$var$Ve(e, r, n, s = $b34bd66f0aa7fdf3$var$qe(s)), s.push(t)) : $b34bd66f0aa7fdf3$var$Ve(e, r, n, [
        t
    ]), !0);
}, function(t, e, n, r, s) {
    if (e instanceof $b34bd66f0aa7fdf3$var$Le) e.forEach((e, i)=>{
        $b34bd66f0aa7fdf3$var$Ct(t, n, $b34bd66f0aa7fdf3$var$Ee([
            i,
            e
        ], r), s);
    });
    else if (Array.isArray(e)) for(let i = 0; i < e.length; i++){
        const o = e[i];
        Array.isArray(o) && $b34bd66f0aa7fdf3$var$Ct(t, n, $b34bd66f0aa7fdf3$var$Ee(o, r), s);
    }
});
function $b34bd66f0aa7fdf3$var$Yn(t, e, n) {
    t: if (null != e) {
        if ($b34bd66f0aa7fdf3$var$ce(e)) {
            if ("string" == typeof e) break t;
            if ("number" == typeof e) break t;
        }
        e = void 0;
    }
    null != e && ("string" == typeof e && $b34bd66f0aa7fdf3$var$bt(e), null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), "number" == typeof e ? (t = t.g, $b34bd66f0aa7fdf3$var$J(e), $b34bd66f0aa7fdf3$var$kt(t, $b34bd66f0aa7fdf3$var$q, $b34bd66f0aa7fdf3$var$K)) : (n = $b34bd66f0aa7fdf3$var$bt(e), $b34bd66f0aa7fdf3$var$kt(t.g, n.h, n.g))));
}
function $b34bd66f0aa7fdf3$var$$n(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ue(e)) && null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), $b34bd66f0aa7fdf3$var$Lt(t.g, e));
}
function $b34bd66f0aa7fdf3$var$qn(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$he(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), t.g.g.push(e ? 1 : 0));
}
function $b34bd66f0aa7fdf3$var$Kn(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$pe(e)) && $b34bd66f0aa7fdf3$var$Rt(t, n, $b34bd66f0aa7fdf3$var$h(e));
}
function $b34bd66f0aa7fdf3$var$Jn(t, e, n, r, s) {
    $b34bd66f0aa7fdf3$var$Ct(t, n, e instanceof $b34bd66f0aa7fdf3$var$vn ? e.u : Array.isArray(e) ? $b34bd66f0aa7fdf3$var$Ee(e, r) : void 0, s);
}
function $b34bd66f0aa7fdf3$var$Zn(t, e, n) {
    null != (e = null == e || "string" == typeof e || $b34bd66f0aa7fdf3$var$R(e) || e instanceof $b34bd66f0aa7fdf3$var$j ? e : void 0) && $b34bd66f0aa7fdf3$var$Rt(t, n, $b34bd66f0aa7fdf3$var$H(e).buffer);
}
function $b34bd66f0aa7fdf3$var$Qn(t, e, n) {
    return (5 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$ze(e, $b34bd66f0aa7fdf3$var$Vt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$yt(t, $b34bd66f0aa7fdf3$var$ut.prototype.A, e) : e.push(t.g.A()), !0);
}
var $b34bd66f0aa7fdf3$var$tr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    if (1 !== t.h) return !1;
    var r = t.g;
    t = $b34bd66f0aa7fdf3$var$at(r);
    const s = $b34bd66f0aa7fdf3$var$at(r);
    r = 2 * (s >> 31) + 1;
    const i = s >>> 20 & 2047;
    return t = 4294967296 * (1048575 & s) + t, $b34bd66f0aa7fdf3$var$Xn(e, n, 2047 == i ? t ? NaN : 1 / 0 * r : 0 == i ? r * Math.pow(2, -1074) * t : r * Math.pow(2, i - 1075) * (t + 4503599627370496)), !0;
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ae(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 1), t = t.g, (n = $b34bd66f0aa7fdf3$var$$ ||= new DataView(new ArrayBuffer(8))).setFloat64(0, +e, !0), $b34bd66f0aa7fdf3$var$q = n.getUint32(0, !0), $b34bd66f0aa7fdf3$var$K = n.getUint32(4, !0), $b34bd66f0aa7fdf3$var$Ft(t, $b34bd66f0aa7fdf3$var$q), $b34bd66f0aa7fdf3$var$Ft(t, $b34bd66f0aa7fdf3$var$K));
}), $b34bd66f0aa7fdf3$var$er = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 5 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, t.g.A()), !0);
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ae(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 5), t = t.g, $b34bd66f0aa7fdf3$var$Z(e), $b34bd66f0aa7fdf3$var$Ft(t, $b34bd66f0aa7fdf3$var$q));
}), $b34bd66f0aa7fdf3$var$nr = $b34bd66f0aa7fdf3$var$Wn($b34bd66f0aa7fdf3$var$Qn, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$ae, e))) for(let i = 0; i < e.length; i++){
        var r = t, s = e[i];
        null != s && ($b34bd66f0aa7fdf3$var$Ot(r, n, 5), r = r.g, $b34bd66f0aa7fdf3$var$Z(s), $b34bd66f0aa7fdf3$var$Ft(r, $b34bd66f0aa7fdf3$var$q));
    }
}), $b34bd66f0aa7fdf3$var$rr = $b34bd66f0aa7fdf3$var$Wn($b34bd66f0aa7fdf3$var$Qn, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$ae, e)) && e.length) {
        $b34bd66f0aa7fdf3$var$Ot(t, n, 2), $b34bd66f0aa7fdf3$var$xt(t.g, 4 * e.length);
        for(let r = 0; r < e.length; r++)n = t.g, $b34bd66f0aa7fdf3$var$Z(e[r]), $b34bd66f0aa7fdf3$var$Ft(n, $b34bd66f0aa7fdf3$var$q);
    }
}), $b34bd66f0aa7fdf3$var$sr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$tt)), !0);
}, $b34bd66f0aa7fdf3$var$Yn), $b34bd66f0aa7fdf3$var$ir = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, 0 === (t = $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$tt)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$Yn), $b34bd66f0aa7fdf3$var$or = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$Q)), !0);
}, function(t, e, n) {
    t: if (null != e) {
        if ($b34bd66f0aa7fdf3$var$ce(e)) {
            if ("string" == typeof e) break t;
            if ("number" == typeof e) break t;
        }
        e = void 0;
    }
    null != e && ("string" == typeof e && $b34bd66f0aa7fdf3$var$_t(e), null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), "number" == typeof e ? (t = t.g, $b34bd66f0aa7fdf3$var$J(e), $b34bd66f0aa7fdf3$var$kt(t, $b34bd66f0aa7fdf3$var$q, $b34bd66f0aa7fdf3$var$K)) : (n = $b34bd66f0aa7fdf3$var$_t(e), $b34bd66f0aa7fdf3$var$kt(t.g, n.h, n.g))));
}), $b34bd66f0aa7fdf3$var$ar = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, t.g.m()), !0);
}, $b34bd66f0aa7fdf3$var$$n), $b34bd66f0aa7fdf3$var$hr = $b34bd66f0aa7fdf3$var$Wn(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$ze(e, $b34bd66f0aa7fdf3$var$Vt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$yt(t, $b34bd66f0aa7fdf3$var$ut.prototype.m, e) : e.push(t.g.m()), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$ue, e)) && e.length) {
        n = $b34bd66f0aa7fdf3$var$Mt(t, n);
        for(let n = 0; n < e.length; n++)$b34bd66f0aa7fdf3$var$Lt(t.g, e[n]);
        $b34bd66f0aa7fdf3$var$Pt(t, n);
    }
}), $b34bd66f0aa7fdf3$var$cr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, 0 === (t = t.g.m()) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$$n), $b34bd66f0aa7fdf3$var$ur = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, $b34bd66f0aa7fdf3$var$ot(t.g)), !0);
}, $b34bd66f0aa7fdf3$var$qn), $b34bd66f0aa7fdf3$var$lr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, !1 === (t = $b34bd66f0aa7fdf3$var$ot(t.g)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$qn), $b34bd66f0aa7fdf3$var$fr = $b34bd66f0aa7fdf3$var$Wn(function(t, e, n) {
    if (2 !== t.h) return !1;
    t = $b34bd66f0aa7fdf3$var$gt(t);
    const r = $b34bd66f0aa7fdf3$var$Vt(e);
    return $b34bd66f0aa7fdf3$var$te(r), $b34bd66f0aa7fdf3$var$ze(e, r, n, 2).push(t), !0;
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$pe, e))) for(let s = 0; s < e.length; s++){
        var r = e[s];
        null != r && $b34bd66f0aa7fdf3$var$Rt(t, n, $b34bd66f0aa7fdf3$var$h(r));
    }
}), $b34bd66f0aa7fdf3$var$dr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, "" === (t = $b34bd66f0aa7fdf3$var$gt(t)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$Kn), $b34bd66f0aa7fdf3$var$pr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, $b34bd66f0aa7fdf3$var$gt(t)), !0);
}, $b34bd66f0aa7fdf3$var$Kn), $b34bd66f0aa7fdf3$var$gr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n, r, s) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$pt(t, $b34bd66f0aa7fdf3$var$Qe(e, r, n, !0), s), !0);
}, $b34bd66f0aa7fdf3$var$Jn), $b34bd66f0aa7fdf3$var$mr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n, r, s) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$pt(t, $b34bd66f0aa7fdf3$var$Qe(e, r, n), s), !0);
}, $b34bd66f0aa7fdf3$var$Jn), $b34bd66f0aa7fdf3$var$yr = $b34bd66f0aa7fdf3$var$Wn(function(t, e, n, r, s) {
    if (2 !== t.h) return !1;
    r = $b34bd66f0aa7fdf3$var$Ee(void 0, r);
    const i = $b34bd66f0aa7fdf3$var$Vt(e);
    $b34bd66f0aa7fdf3$var$te(i);
    let o = $b34bd66f0aa7fdf3$var$ze(e, i, n, 3);
    return (Object.isFrozen(o) || 4 & $b34bd66f0aa7fdf3$var$jt(o)) && (o = $b34bd66f0aa7fdf3$var$Dt(o), $b34bd66f0aa7fdf3$var$Ve(e, i, n, o)), o.push(r), $b34bd66f0aa7fdf3$var$pt(t, r, s), !0;
}, function(t, e, n, r, s) {
    if (Array.isArray(e)) for(let i = 0; i < e.length; i++)$b34bd66f0aa7fdf3$var$Jn(t, e[i], n, r, s);
}), $b34bd66f0aa7fdf3$var$vr = $b34bd66f0aa7fdf3$var$zn(function(t, e, n, r, s, i) {
    if (2 !== t.h) return !1;
    const o = $b34bd66f0aa7fdf3$var$Vt(e);
    return $b34bd66f0aa7fdf3$var$te(o), (i = $b34bd66f0aa7fdf3$var$Ze(e, o, i)) && n !== i && $b34bd66f0aa7fdf3$var$Ve(e, o, i), $b34bd66f0aa7fdf3$var$pt(t, e = $b34bd66f0aa7fdf3$var$Qe(e, r, n), s), !0;
}, $b34bd66f0aa7fdf3$var$Jn), $b34bd66f0aa7fdf3$var$_r = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, $b34bd66f0aa7fdf3$var$mt(t)), !0);
}, $b34bd66f0aa7fdf3$var$Zn), $b34bd66f0aa7fdf3$var$wr = $b34bd66f0aa7fdf3$var$Wn(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$ze(e, $b34bd66f0aa7fdf3$var$Vt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$yt(t, $b34bd66f0aa7fdf3$var$ut.prototype.j, e) : e.push(t.g.j()), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$le, e))) for(let i = 0; i < e.length; i++){
        var r = t, s = e[i];
        null != s && ($b34bd66f0aa7fdf3$var$Ot(r, n, 0), $b34bd66f0aa7fdf3$var$xt(r.g, s));
    }
}), $b34bd66f0aa7fdf3$var$Ar = $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, t.g.m()), !0);
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ue(e)) && (e = parseInt(e, 10), $b34bd66f0aa7fdf3$var$Ot(t, n, 0), $b34bd66f0aa7fdf3$var$Lt(t.g, e));
}), $b34bd66f0aa7fdf3$var$br = $b34bd66f0aa7fdf3$var$Wn(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$ze(e, $b34bd66f0aa7fdf3$var$Vt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$yt(t, $b34bd66f0aa7fdf3$var$ut.prototype.C, e) : e.push(t.g.m()), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$An($b34bd66f0aa7fdf3$var$ue, e)) && e.length) {
        n = $b34bd66f0aa7fdf3$var$Mt(t, n);
        for(let n = 0; n < e.length; n++)$b34bd66f0aa7fdf3$var$Lt(t.g, e[n]);
        $b34bd66f0aa7fdf3$var$Pt(t, n);
    }
});
class $b34bd66f0aa7fdf3$var$Er {
    constructor(t, e){
        this.h = t, this.g = e, this.l = $b34bd66f0aa7fdf3$var$en, this.m = $b34bd66f0aa7fdf3$var$sn, this.defaultValue = void 0;
    }
}
function $b34bd66f0aa7fdf3$var$Tr(t, e) {
    return new $b34bd66f0aa7fdf3$var$Er(t, e);
}
function $b34bd66f0aa7fdf3$var$kr(t, e) {
    return (n, r)=>{
        t: {
            if ($b34bd66f0aa7fdf3$var$vt.length) {
                const t = $b34bd66f0aa7fdf3$var$vt.pop();
                t.o(r), $b34bd66f0aa7fdf3$var$rt(t.g, n, r), n = t;
            } else n = new class {
                constructor(t, e){
                    if ($b34bd66f0aa7fdf3$var$lt.length) {
                        const n = $b34bd66f0aa7fdf3$var$lt.pop();
                        $b34bd66f0aa7fdf3$var$rt(n, t, e), t = n;
                    } else t = new $b34bd66f0aa7fdf3$var$ut(t, e);
                    this.g = t, this.l = this.g.g, this.h = this.m = -1, this.o(e);
                }
                o({ aa: t = !1 } = {}) {
                    this.aa = t;
                }
            }(n, r);
            try {
                var s = new t;
                const r = s.u;
                $b34bd66f0aa7fdf3$var$En(e)(r, n), $b34bd66f0aa7fdf3$var$se && delete r[$b34bd66f0aa7fdf3$var$se];
                var i = s;
                break t;
            } finally{
                (s = n.g).h = null, s.s = !1, s.v = 0, s.l = 0, s.g = 0, s.R = !1, n.m = -1, n.h = -1, 100 > $b34bd66f0aa7fdf3$var$vt.length && $b34bd66f0aa7fdf3$var$vt.push(n);
            }
            i = void 0;
        }
        return i;
    };
}
function $b34bd66f0aa7fdf3$var$xr(t) {
    return function() {
        const e = new class {
            constructor(){
                this.l = [], this.h = 0, this.g = new class {
                    constructor(){
                        this.g = [];
                    }
                    length() {
                        return this.g.length;
                    }
                    end() {
                        const t = this.g;
                        return this.g = [], t;
                    }
                };
            }
        };
        $b34bd66f0aa7fdf3$var$Vn(this.u, e, $b34bd66f0aa7fdf3$var$Dn(t)), $b34bd66f0aa7fdf3$var$St(e, e.g.end());
        const n = new Uint8Array(e.h), r = e.l, s = r.length;
        let i = 0;
        for(let t = 0; t < s; t++){
            const e = r[t];
            n.set(e, i), i += e.length;
        }
        return e.l = [
            n
        ], n;
    };
}
var $b34bd66f0aa7fdf3$var$Lr = [
    0,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$zn(function(t, e, n) {
        return 2 === t.h && ($b34bd66f0aa7fdf3$var$Xn(e, n, (t = $b34bd66f0aa7fdf3$var$mt(t)) === $b34bd66f0aa7fdf3$var$N() ? void 0 : t), !0);
    }, function(t, e, n) {
        if (null != e) {
            if (e instanceof $b34bd66f0aa7fdf3$var$vn) {
                const r = e.Ea;
                return void (r && (e = r(e), null != e && $b34bd66f0aa7fdf3$var$Rt(t, n, $b34bd66f0aa7fdf3$var$H(e).buffer)));
            }
            if (Array.isArray(e)) return;
        }
        $b34bd66f0aa7fdf3$var$Zn(t, e, n);
    })
], $b34bd66f0aa7fdf3$var$Fr = [
    0,
    $b34bd66f0aa7fdf3$var$pr
], $b34bd66f0aa7fdf3$var$Sr = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$hr,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$Ar
], $b34bd66f0aa7fdf3$var$Or = [
    0,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$Mr = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$Mr.B = [
    6
];
var $b34bd66f0aa7fdf3$var$Pr = [
    0,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$br,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Or,
    $b34bd66f0aa7fdf3$var$Ar
], $b34bd66f0aa7fdf3$var$Rr = [
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr
], $b34bd66f0aa7fdf3$var$Cr = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(){
        super();
    }
}, $b34bd66f0aa7fdf3$var$Ir = [
    0
], $b34bd66f0aa7fdf3$var$Dr = [
    0,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$Br = [
    1,
    2,
    3,
    4,
    5
], $b34bd66f0aa7fdf3$var$Ur = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t, 2);
    }
}, $b34bd66f0aa7fdf3$var$Nr = {}, $b34bd66f0aa7fdf3$var$Gr = [
    -2,
    $b34bd66f0aa7fdf3$var$Nr,
    $b34bd66f0aa7fdf3$var$ur
];
$b34bd66f0aa7fdf3$var$Nr[336783863] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$mr,
    [
        0,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Ir,
        $b34bd66f0aa7fdf3$var$Br,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Pr,
        $b34bd66f0aa7fdf3$var$Br,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Rr,
        $b34bd66f0aa7fdf3$var$Br,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Dr,
        $b34bd66f0aa7fdf3$var$Br,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Sr,
        $b34bd66f0aa7fdf3$var$Br
    ],
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Fr
]);
var $b34bd66f0aa7fdf3$var$jr = [
    0,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$lr
], $b34bd66f0aa7fdf3$var$Vr = [
    0,
    $b34bd66f0aa7fdf3$var$ir,
    $b34bd66f0aa7fdf3$var$ir,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$ir,
    $b34bd66f0aa7fdf3$var$hr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$ir,
    $b34bd66f0aa7fdf3$var$ir,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$dr
], $b34bd66f0aa7fdf3$var$zr = [
    -1,
    {}
], $b34bd66f0aa7fdf3$var$Wr = [
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    2,
    $b34bd66f0aa7fdf3$var$zr
], $b34bd66f0aa7fdf3$var$Xr = [
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$zr
];
function $b34bd66f0aa7fdf3$var$Hr(t, e) {
    e = $b34bd66f0aa7fdf3$var$de(e), t = t.u;
    const n = $b34bd66f0aa7fdf3$var$Vt(t);
    $b34bd66f0aa7fdf3$var$te(n), $b34bd66f0aa7fdf3$var$Ve(t, n, 2, "" === e ? void 0 : e);
}
function $b34bd66f0aa7fdf3$var$Yr(t, e) {
    $b34bd66f0aa7fdf3$var$mn(t, 3, e);
}
function $b34bd66f0aa7fdf3$var$$r(t, e) {
    $b34bd66f0aa7fdf3$var$mn(t, 4, e);
}
var $b34bd66f0aa7fdf3$var$qr = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t, 500);
    }
    o(t) {
        return $b34bd66f0aa7fdf3$var$sn(this, 0, 7, t);
    }
};
$b34bd66f0aa7fdf3$var$qr.B = [
    3,
    4,
    5,
    6,
    8,
    13,
    17,
    1005
];
var $b34bd66f0aa7fdf3$var$Kr = [
    -500,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Gr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Lr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Wr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Vr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    988
], $b34bd66f0aa7fdf3$var$Jr = [
    0,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$zr
], $b34bd66f0aa7fdf3$var$Zr = [
    -500,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    [
        -1,
        {}
    ],
    $b34bd66f0aa7fdf3$var$pr,
    999
], $b34bd66f0aa7fdf3$var$Qr = [
    -500,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$mr,
    [
        -2,
        {},
        $b34bd66f0aa7fdf3$var$ur
    ],
    $b34bd66f0aa7fdf3$var$fr,
    998,
    $b34bd66f0aa7fdf3$var$fr
], $b34bd66f0aa7fdf3$var$ts = [
    -500,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$fr,
    999
];
function $b34bd66f0aa7fdf3$var$es(t, e) {
    $b34bd66f0aa7fdf3$var$an(t, $b34bd66f0aa7fdf3$var$qr, e);
}
function $b34bd66f0aa7fdf3$var$ns(t, e) {
    $b34bd66f0aa7fdf3$var$mn(t, 10, e);
}
function $b34bd66f0aa7fdf3$var$rs(t, e) {
    $b34bd66f0aa7fdf3$var$mn(t, 15, e);
}
var $b34bd66f0aa7fdf3$var$ss = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t, 500);
    }
    o(t) {
        return $b34bd66f0aa7fdf3$var$sn(this, 0, 1001, t);
    }
};
$b34bd66f0aa7fdf3$var$ss.B = [
    1,
    6,
    7,
    9,
    10,
    15,
    16,
    17,
    14,
    1002
];
var $b34bd66f0aa7fdf3$var$is = [
    -500,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Kr,
    $b34bd66f0aa7fdf3$var$yr,
    5,
    $b34bd66f0aa7fdf3$var$Zr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Qr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$ts,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$cr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Wr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Vr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$dr,
    $b34bd66f0aa7fdf3$var$lr,
    $b34bd66f0aa7fdf3$var$mr,
    980,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Lr
], $b34bd66f0aa7fdf3$var$os = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$ss, $b34bd66f0aa7fdf3$var$is);
$b34bd66f0aa7fdf3$var$ss.prototype.g = $b34bd66f0aa7fdf3$var$xr($b34bd66f0aa7fdf3$var$is);
var $b34bd66f0aa7fdf3$var$as = [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    [
        0,
        $b34bd66f0aa7fdf3$var$ar,
        $b34bd66f0aa7fdf3$var$ar,
        $b34bd66f0aa7fdf3$var$ar
    ]
], $b34bd66f0aa7fdf3$var$hs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$cs = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr
], $b34bd66f0aa7fdf3$var$us = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$rn(this, $b34bd66f0aa7fdf3$var$hs, 1);
    }
};
$b34bd66f0aa7fdf3$var$us.B = [
    1
];
var $b34bd66f0aa7fdf3$var$ls = [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$cs
], $b34bd66f0aa7fdf3$var$fs = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$us, $b34bd66f0aa7fdf3$var$ls), $b34bd66f0aa7fdf3$var$ds = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$ps = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$as
], $b34bd66f0aa7fdf3$var$gs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ms = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$ys = [
    0,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$vs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$_s = [
    0,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$ws = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    h() {
        return $b34bd66f0aa7fdf3$var$en(this, $b34bd66f0aa7fdf3$var$gs, 2);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$rn(this, $b34bd66f0aa7fdf3$var$vs, 5);
    }
};
$b34bd66f0aa7fdf3$var$ws.B = [
    5
];
var $b34bd66f0aa7fdf3$var$As = [
    0,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ms,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ys,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ps,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$_s
], $b34bd66f0aa7fdf3$var$bs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$bs.B = [
    1,
    2,
    3,
    8,
    9
];
var $b34bd66f0aa7fdf3$var$Es = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$bs, [
    0,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$hr,
    $b34bd66f0aa7fdf3$var$rr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$As,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$sr,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$ds,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$sr
]), $b34bd66f0aa7fdf3$var$Ts = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ks = [
    0,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$xs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$xs.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Ls = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$xs, [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$ks
]), $b34bd66f0aa7fdf3$var$Fs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ss = [
    0,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$Os = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Os.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Ms = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$Os, [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Ss
]), $b34bd66f0aa7fdf3$var$Ps = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Ps.B = [
    3
];
var $b34bd66f0aa7fdf3$var$Rs = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$rr,
    $b34bd66f0aa7fdf3$var$Ar
], $b34bd66f0aa7fdf3$var$Cs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$Cs.prototype.g = $b34bd66f0aa7fdf3$var$xr([
    0,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$sr
]);
var $b34bd66f0aa7fdf3$var$Is = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ds = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    2,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ls
], $b34bd66f0aa7fdf3$var$Bs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Bs.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Us = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$Bs, [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$Ds,
    $b34bd66f0aa7fdf3$var$sr
]), $b34bd66f0aa7fdf3$var$Ns = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Ns.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Gs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    fa() {
        const t = $b34bd66f0aa7fdf3$var$Xe(this);
        return null == t ? $b34bd66f0aa7fdf3$var$N() : t;
    }
}, $b34bd66f0aa7fdf3$var$js = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Vs = [
    1,
    2
], $b34bd66f0aa7fdf3$var$zs = [
    0,
    $b34bd66f0aa7fdf3$var$vr,
    [
        0,
        $b34bd66f0aa7fdf3$var$rr
    ],
    $b34bd66f0aa7fdf3$var$Vs,
    $b34bd66f0aa7fdf3$var$vr,
    [
        0,
        $b34bd66f0aa7fdf3$var$_r
    ],
    $b34bd66f0aa7fdf3$var$Vs,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$pr
], $b34bd66f0aa7fdf3$var$Ws = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Ws.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Xs = $b34bd66f0aa7fdf3$var$kr($b34bd66f0aa7fdf3$var$Ws, [
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$zs,
    $b34bd66f0aa7fdf3$var$sr
]), $b34bd66f0aa7fdf3$var$Hs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Hs.B = [
    4,
    5
];
var $b34bd66f0aa7fdf3$var$Ys = [
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr
], $b34bd66f0aa7fdf3$var$$s = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$qs = [
    0,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$Ks = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Js = [
    1,
    2,
    3,
    4,
    5
], $b34bd66f0aa7fdf3$var$Zs = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    g() {
        return null != $b34bd66f0aa7fdf3$var$Xe(this);
    }
    h() {
        return null != $b34bd66f0aa7fdf3$var$un(this, 2);
    }
}, $b34bd66f0aa7fdf3$var$Qs = [
    0,
    $b34bd66f0aa7fdf3$var$_r,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    [
        0,
        $b34bd66f0aa7fdf3$var$ar,
        $b34bd66f0aa7fdf3$var$sr,
        $b34bd66f0aa7fdf3$var$sr
    ],
    $b34bd66f0aa7fdf3$var$mr,
    [
        0,
        $b34bd66f0aa7fdf3$var$or,
        $b34bd66f0aa7fdf3$var$sr
    ]
], $b34bd66f0aa7fdf3$var$ti = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$he($b34bd66f0aa7fdf3$var$Ne(this, 2)) ?? !1;
    }
}, $b34bd66f0aa7fdf3$var$ei = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Qs,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$mr,
    [
        0,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Dr,
        $b34bd66f0aa7fdf3$var$Js,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Pr,
        $b34bd66f0aa7fdf3$var$Js,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Sr,
        $b34bd66f0aa7fdf3$var$Js,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Ir,
        $b34bd66f0aa7fdf3$var$Js,
        $b34bd66f0aa7fdf3$var$vr,
        $b34bd66f0aa7fdf3$var$Rr,
        $b34bd66f0aa7fdf3$var$Js
    ]
], $b34bd66f0aa7fdf3$var$ni = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ri = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$si = $b34bd66f0aa7fdf3$var$Tr(502141897, $b34bd66f0aa7fdf3$var$ni);
$b34bd66f0aa7fdf3$var$Nr[502141897] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$ri);
var $b34bd66f0aa7fdf3$var$ii = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Qs
];
$b34bd66f0aa7fdf3$var$Nr[512499200] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$ii);
var $b34bd66f0aa7fdf3$var$oi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ii
];
$b34bd66f0aa7fdf3$var$Nr[515723506] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$oi);
var $b34bd66f0aa7fdf3$var$ai = $b34bd66f0aa7fdf3$var$kr(class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Ar,
        $b34bd66f0aa7fdf3$var$Ar,
        $b34bd66f0aa7fdf3$var$nr,
        $b34bd66f0aa7fdf3$var$wr
    ],
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Rs
]), $b34bd66f0aa7fdf3$var$hi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei
];
$b34bd66f0aa7fdf3$var$Nr[508981768] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$hi);
var $b34bd66f0aa7fdf3$var$ci = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ui = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$hi,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$li = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$fi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ri,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ui,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$oi
];
$b34bd66f0aa7fdf3$var$Nr[508968149] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$ui);
var $b34bd66f0aa7fdf3$var$di = $b34bd66f0aa7fdf3$var$Tr(508968150, $b34bd66f0aa7fdf3$var$li);
$b34bd66f0aa7fdf3$var$Nr[508968150] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$fi);
var $b34bd66f0aa7fdf3$var$pi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$gi = $b34bd66f0aa7fdf3$var$Tr(513916220, $b34bd66f0aa7fdf3$var$pi);
$b34bd66f0aa7fdf3$var$Nr[513916220] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$fi,
    $b34bd66f0aa7fdf3$var$ar
]);
var $b34bd66f0aa7fdf3$var$mi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    h() {
        return $b34bd66f0aa7fdf3$var$en(this, $b34bd66f0aa7fdf3$var$Hs, 2);
    }
    g() {
        $b34bd66f0aa7fdf3$var$je(this, 2);
    }
}, $b34bd66f0aa7fdf3$var$yi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ys
];
$b34bd66f0aa7fdf3$var$Nr[478825465] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$yi);
var $b34bd66f0aa7fdf3$var$vi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei
];
$b34bd66f0aa7fdf3$var$Nr[478825422] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$vi);
var $b34bd66f0aa7fdf3$var$_i = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$wi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$vi,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$yi,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$yi
], $b34bd66f0aa7fdf3$var$Ai = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$bi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$Ei = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ti = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$ki = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$xi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$bi,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ti,
    $b34bd66f0aa7fdf3$var$er
], $b34bd66f0aa7fdf3$var$Li = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Fi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$xi,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$wi
];
$b34bd66f0aa7fdf3$var$Nr[463370452] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$wi), $b34bd66f0aa7fdf3$var$Nr[464864288] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$bi), $b34bd66f0aa7fdf3$var$Nr[474472470] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$Ti);
var $b34bd66f0aa7fdf3$var$Si = $b34bd66f0aa7fdf3$var$Tr(462713202, $b34bd66f0aa7fdf3$var$ki);
$b34bd66f0aa7fdf3$var$Nr[462713202] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$xi);
var $b34bd66f0aa7fdf3$var$Oi = $b34bd66f0aa7fdf3$var$Tr(479097054, $b34bd66f0aa7fdf3$var$Li);
$b34bd66f0aa7fdf3$var$Nr[479097054] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$Fi);
var $b34bd66f0aa7fdf3$var$Mi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Pi = $b34bd66f0aa7fdf3$var$Tr(456383383, $b34bd66f0aa7fdf3$var$Mi);
$b34bd66f0aa7fdf3$var$Nr[456383383] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ys
]);
var $b34bd66f0aa7fdf3$var$Ri = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ci = $b34bd66f0aa7fdf3$var$Tr(476348187, $b34bd66f0aa7fdf3$var$Ri);
$b34bd66f0aa7fdf3$var$Nr[476348187] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$qs
]);
var $b34bd66f0aa7fdf3$var$Ii = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Di = [
    0,
    $b34bd66f0aa7fdf3$var$Ar,
    $b34bd66f0aa7fdf3$var$Ar
], $b34bd66f0aa7fdf3$var$Bi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Bi.B = [
    3
];
var $b34bd66f0aa7fdf3$var$Ui = $b34bd66f0aa7fdf3$var$Tr(458105876, class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
    g() {
        var t = this.u;
        const e = $b34bd66f0aa7fdf3$var$Vt(t);
        var n = 2 & e;
        return t = function(t, e, n) {
            var r = $b34bd66f0aa7fdf3$var$Bi;
            const s = 2 & e;
            let i = !1;
            if (null == n) {
                if (s) return $b34bd66f0aa7fdf3$var$$e();
                n = [];
            } else if (n.constructor === $b34bd66f0aa7fdf3$var$Le) {
                if (0 == (2 & n.g) || s) return n;
                n = n.m();
            } else Array.isArray(n) ? i = !!(2 & $b34bd66f0aa7fdf3$var$jt(n)) : n = [];
            if (s) {
                if (!n.length) return $b34bd66f0aa7fdf3$var$$e();
                i || (i = !0, $b34bd66f0aa7fdf3$var$Xt(n));
            } else i && (i = !1, n = $b34bd66f0aa7fdf3$var$qe(n));
            return i || (64 & $b34bd66f0aa7fdf3$var$jt(n) ? $b34bd66f0aa7fdf3$var$Gt(n, 32) : 32 & e && $b34bd66f0aa7fdf3$var$Ut(n, 32)), $b34bd66f0aa7fdf3$var$Ve(t, e, 2, r = new $b34bd66f0aa7fdf3$var$Le(n, r, $b34bd66f0aa7fdf3$var$ve, void 0), !1), r;
        }(t, e, $b34bd66f0aa7fdf3$var$Ge(t, e, 2)), null == t || !n && $b34bd66f0aa7fdf3$var$Bi && (t.v = !0), n = t;
    }
});
$b34bd66f0aa7fdf3$var$Nr[458105876] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Di,
    $b34bd66f0aa7fdf3$var$Hn,
    [
        !0,
        $b34bd66f0aa7fdf3$var$sr,
        $b34bd66f0aa7fdf3$var$mr,
        [
            0,
            $b34bd66f0aa7fdf3$var$pr,
            $b34bd66f0aa7fdf3$var$pr,
            $b34bd66f0aa7fdf3$var$fr
        ]
    ]
]);
var $b34bd66f0aa7fdf3$var$Ni = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Gi = $b34bd66f0aa7fdf3$var$Tr(458105758, $b34bd66f0aa7fdf3$var$Ni);
$b34bd66f0aa7fdf3$var$Nr[458105758] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Di
]);
var $b34bd66f0aa7fdf3$var$ji = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$ji.B = [
    5,
    6
];
var $b34bd66f0aa7fdf3$var$Vi = $b34bd66f0aa7fdf3$var$Tr(443442058, $b34bd66f0aa7fdf3$var$ji);
$b34bd66f0aa7fdf3$var$Nr[443442058] = $b34bd66f0aa7fdf3$var$wn([
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$fr,
    $b34bd66f0aa7fdf3$var$fr
]);
var $b34bd66f0aa7fdf3$var$zi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Wi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$ar
];
$b34bd66f0aa7fdf3$var$Nr[514774813] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$Wi);
var $b34bd66f0aa7fdf3$var$Xi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Hi = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$er,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$Yi = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$$i = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Wi,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Hi,
    $b34bd66f0aa7fdf3$var$er
];
$b34bd66f0aa7fdf3$var$Nr[518928384] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$Hi);
var $b34bd66f0aa7fdf3$var$qi = $b34bd66f0aa7fdf3$var$Tr(516587230, $b34bd66f0aa7fdf3$var$Yi);
function $b34bd66f0aa7fdf3$var$Ki(t, e) {
    return e = e ? e.clone() : new $b34bd66f0aa7fdf3$var$Hs, void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$je(e, 1, $b34bd66f0aa7fdf3$var$de(t.displayNamesLocale)) : void 0 === t.displayNamesLocale && $b34bd66f0aa7fdf3$var$je(e, 1), void 0 !== t.maxResults ? $b34bd66f0aa7fdf3$var$pn(e, 2, t.maxResults) : "maxResults" in t && $b34bd66f0aa7fdf3$var$je(e, 2), void 0 !== t.scoreThreshold ? $b34bd66f0aa7fdf3$var$gn(e, 3, t.scoreThreshold) : "scoreThreshold" in t && $b34bd66f0aa7fdf3$var$je(e, 3), void 0 !== t.categoryAllowlist ? $b34bd66f0aa7fdf3$var$Ke(e, 4, t.categoryAllowlist) : "categoryAllowlist" in t && $b34bd66f0aa7fdf3$var$je(e, 4), void 0 !== t.categoryDenylist ? $b34bd66f0aa7fdf3$var$Ke(e, 5, t.categoryDenylist) : "categoryDenylist" in t && $b34bd66f0aa7fdf3$var$je(e, 5), e;
}
function $b34bd66f0aa7fdf3$var$Ji(t, e = -1, n = "") {
    return {
        categories: t.map((t)=>({
                index: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(t, 1)) ?? -1,
                score: $b34bd66f0aa7fdf3$var$fn(t, 2) ?? 0,
                categoryName: $b34bd66f0aa7fdf3$var$un(t, 3) ?? "" ?? "",
                displayName: $b34bd66f0aa7fdf3$var$un(t, 4) ?? "" ?? ""
            })),
        headIndex: e,
        headName: n
    };
}
function $b34bd66f0aa7fdf3$var$Zi(t) {
    var e = $b34bd66f0aa7fdf3$var$He(t, 3, $b34bd66f0aa7fdf3$var$ae), n = $b34bd66f0aa7fdf3$var$He(t, 2, $b34bd66f0aa7fdf3$var$ue);
    const r = $b34bd66f0aa7fdf3$var$He(t, 1, $b34bd66f0aa7fdf3$var$pe), s = $b34bd66f0aa7fdf3$var$He(t, 9, $b34bd66f0aa7fdf3$var$pe), i = {
        categories: [],
        keypoints: []
    };
    for(let t = 0; t < e.length; t++)i.categories.push({
        score: e[t],
        index: n[t] ?? -1,
        categoryName: r[t] ?? "",
        displayName: s[t] ?? ""
    });
    if ((e = $b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$ws, 4)?.h()) && (i.boundingBox = {
        originX: $b34bd66f0aa7fdf3$var$hn(e, 1) ?? 0,
        originY: $b34bd66f0aa7fdf3$var$hn(e, 2) ?? 0,
        width: $b34bd66f0aa7fdf3$var$hn(e, 3) ?? 0,
        height: $b34bd66f0aa7fdf3$var$hn(e, 4) ?? 0,
        angle: 0
    }), $b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$ws, 4)?.g().length) for (const e of $b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$ws, 4).g())i.keypoints.push({
        x: $b34bd66f0aa7fdf3$var$We(e, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$We(e, 2) ?? 0,
        score: $b34bd66f0aa7fdf3$var$We(e, 4) ?? 0,
        label: $b34bd66f0aa7fdf3$var$un(e, 3) ?? ""
    });
    return i;
}
function $b34bd66f0aa7fdf3$var$Qi(t) {
    const e = [];
    for (const n of $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$Fs, 1))e.push({
        x: $b34bd66f0aa7fdf3$var$fn(n, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$fn(n, 2) ?? 0,
        z: $b34bd66f0aa7fdf3$var$fn(n, 3) ?? 0
    });
    return e;
}
function $b34bd66f0aa7fdf3$var$to(t) {
    const e = [];
    for (const n of $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$Ts, 1))e.push({
        x: $b34bd66f0aa7fdf3$var$fn(n, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$fn(n, 2) ?? 0,
        z: $b34bd66f0aa7fdf3$var$fn(n, 3) ?? 0
    });
    return e;
}
function $b34bd66f0aa7fdf3$var$eo(t) {
    return Array.from(t, (t)=>127 < t ? t - 256 : t);
}
function $b34bd66f0aa7fdf3$var$no(t, e) {
    if (t.length !== e.length) throw Error(`Cannot compute cosine similarity between embeddings of different sizes (${t.length} vs. ${e.length}).`);
    let n = 0, r = 0, s = 0;
    for(let i = 0; i < t.length; i++)n += t[i] * e[i], r += t[i] * t[i], s += e[i] * e[i];
    if (0 >= r || 0 >= s) throw Error("Cannot compute cosine similarity on embedding with 0 norm.");
    return n / Math.sqrt(r * s);
}
let $b34bd66f0aa7fdf3$var$ro;
$b34bd66f0aa7fdf3$var$Nr[516587230] = $b34bd66f0aa7fdf3$var$wn($b34bd66f0aa7fdf3$var$$i);
const $b34bd66f0aa7fdf3$var$so = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    5,
    1,
    96,
    0,
    1,
    123,
    3,
    2,
    1,
    0,
    10,
    10,
    1,
    8,
    0,
    65,
    0,
    253,
    15,
    253,
    98,
    11
]);
async function $b34bd66f0aa7fdf3$var$io() {
    if (void 0 === $b34bd66f0aa7fdf3$var$ro) try {
        await WebAssembly.instantiate($b34bd66f0aa7fdf3$var$so), $b34bd66f0aa7fdf3$var$ro = !0;
    } catch  {
        $b34bd66f0aa7fdf3$var$ro = !1;
    }
    return $b34bd66f0aa7fdf3$var$ro;
}
async function $b34bd66f0aa7fdf3$var$oo(t, e = "") {
    const n = await $b34bd66f0aa7fdf3$var$io() ? "wasm_internal" : "wasm_nosimd_internal";
    return {
        wasmLoaderPath: `${e}/${t}_${n}.js`,
        wasmBinaryPath: `${e}/${t}_${n}.wasm`
    };
}
var $b34bd66f0aa7fdf3$export$f97946dfe503e8d3 = class {
};
function $b34bd66f0aa7fdf3$var$ho() {
    const t = navigator.userAgent;
    return t.includes("Safari") && !t.includes("Chrome");
}
async function $b34bd66f0aa7fdf3$var$co(t) {
    if ("function" != typeof importScripts) {
        const e = document.createElement("script");
        return e.src = t.toString(), e.crossOrigin = "anonymous", new Promise((t, n)=>{
            e.addEventListener("load", ()=>{
                t();
            }, !1), e.addEventListener("error", (t)=>{
                n(t);
            }, !1), document.body.appendChild(e);
        });
    }
    importScripts(t.toString());
}
function $b34bd66f0aa7fdf3$var$uo(t, e, n) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target"), n(e = t.i.stringToNewUTF8(e)), t.i._free(e);
}
function $b34bd66f0aa7fdf3$var$lo(t, e, n) {
    if (!t.i.canvas) throw Error("No OpenGL canvas configured.");
    if (n ? t.i._bindTextureToStream(n) : t.i._bindTextureToCanvas(), !(n = t.i.canvas.getContext("webgl2") || t.i.canvas.getContext("webgl"))) throw Error("Failed to obtain WebGL context from the provided canvas. `getContext()` should only be invoked with `webgl` or `webgl2`.");
    return t.i.gpuOriginForWebTexturesIsBottomLeft && n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !0), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, e), t.i.gpuOriginForWebTexturesIsBottomLeft && n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !1), e.videoWidth ? (n = e.videoWidth, e = e.videoHeight) : e.naturalWidth ? (n = e.naturalWidth, e = e.naturalHeight) : (n = e.width, e = e.height), !t.l || n === t.i.canvas.width && e === t.i.canvas.height || (t.i.canvas.width = n, t.i.canvas.height = e), [
        n,
        e
    ];
}
function $b34bd66f0aa7fdf3$var$fo(t, e, n) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target");
    const r = new Uint32Array(e.length);
    for(let n = 0; n < e.length; n++)r[n] = t.i.stringToNewUTF8(e[n]);
    e = t.i._malloc(4 * r.length), t.i.HEAPU32.set(r, e >> 2), n(e);
    for (const e of r)t.i._free(e);
    t.i._free(e);
}
function $b34bd66f0aa7fdf3$var$po(t, e, n) {
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = n;
}
function $b34bd66f0aa7fdf3$var$go(t, e, n) {
    let r = [];
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = (t, e, s)=>{
        e ? (n(r, s), r = []) : r.push(t);
    };
}
$b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forVisionTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$oo("vision", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forTextTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$oo("text", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forAudioTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$oo("audio", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.isSimdSupported = function() {
    return $b34bd66f0aa7fdf3$var$io();
};
async function $b34bd66f0aa7fdf3$var$mo(t, e, n, r) {
    return t = await (async (t, e, n, r, s)=>{
        if (e && await $b34bd66f0aa7fdf3$var$co(e), !self.ModuleFactory) throw Error("ModuleFactory not set.");
        if (n && (await $b34bd66f0aa7fdf3$var$co(n), !self.ModuleFactory)) throw Error("ModuleFactory not set.");
        return self.Module && s && ((e = self.Module).locateFile = s.locateFile, s.mainScriptUrlOrBlob && (e.mainScriptUrlOrBlob = s.mainScriptUrlOrBlob)), s = await self.ModuleFactory(self.Module || s), self.ModuleFactory = self.Module = void 0, new t(s, r);
    })(t, n.wasmLoaderPath, n.assetLoaderPath, e, {
        locateFile: (t)=>t.endsWith(".wasm") ? n.wasmBinaryPath.toString() : n.assetBinaryPath && t.endsWith(".data") ? n.assetBinaryPath.toString() : t
    }), await t.o(r), t;
}
function $b34bd66f0aa7fdf3$var$yo(t, e) {
    const n = $b34bd66f0aa7fdf3$var$en(t.baseOptions, $b34bd66f0aa7fdf3$var$Zs, 1) || new $b34bd66f0aa7fdf3$var$Zs;
    "string" == typeof e ? ($b34bd66f0aa7fdf3$var$je(n, 2, $b34bd66f0aa7fdf3$var$de(e)), $b34bd66f0aa7fdf3$var$je(n, 1)) : e instanceof Uint8Array && ($b34bd66f0aa7fdf3$var$je(n, 1, $b34bd66f0aa7fdf3$var$Zt(e, !1, !1)), $b34bd66f0aa7fdf3$var$je(n, 2)), $b34bd66f0aa7fdf3$var$sn(t.baseOptions, 0, 1, n);
}
function $b34bd66f0aa7fdf3$var$vo(t) {
    try {
        const e = t.J.length;
        if (1 === e) throw Error(t.J[0].message);
        if (1 < e) throw Error("Encountered multiple errors: " + t.J.map((t)=>t.message).join(", "));
    } finally{
        t.J = [];
    }
}
function $b34bd66f0aa7fdf3$var$_o(t, e) {
    t.I = Math.max(t.I, e);
}
function $b34bd66f0aa7fdf3$var$wo(t, e) {
    t.A = new $b34bd66f0aa7fdf3$var$qr, $b34bd66f0aa7fdf3$var$Hr(t.A, "PassThroughCalculator"), $b34bd66f0aa7fdf3$var$Yr(t.A, "free_memory"), $b34bd66f0aa7fdf3$var$$r(t.A, "free_memory_unused_out"), $b34bd66f0aa7fdf3$var$ns(e, "free_memory"), $b34bd66f0aa7fdf3$var$es(e, t.A);
}
function $b34bd66f0aa7fdf3$var$Ao(t, e) {
    $b34bd66f0aa7fdf3$var$Yr(t.A, e), $b34bd66f0aa7fdf3$var$$r(t.A, e + "_unused_out");
}
function $b34bd66f0aa7fdf3$var$bo(t) {
    t.g.addBoolToStream(!0, "free_memory", t.I);
}
var $b34bd66f0aa7fdf3$export$61e9fc2d6edc635c = class {
    constructor(t){
        this.g = t, this.J = [], this.I = 0, this.g.setAutoRenderToScreen(!1);
    }
    l(t, e = !0) {
        if (e) {
            const e = t.baseOptions || {};
            if (t.baseOptions?.modelAssetBuffer && t.baseOptions?.modelAssetPath) throw Error("Cannot set both baseOptions.modelAssetPath and baseOptions.modelAssetBuffer");
            if (!($b34bd66f0aa7fdf3$var$en(this.baseOptions, $b34bd66f0aa7fdf3$var$Zs, 1)?.g() || $b34bd66f0aa7fdf3$var$en(this.baseOptions, $b34bd66f0aa7fdf3$var$Zs, 1)?.h() || t.baseOptions?.modelAssetBuffer || t.baseOptions?.modelAssetPath)) throw Error("Either baseOptions.modelAssetPath or baseOptions.modelAssetBuffer must be set");
            if (function(t, e) {
                let n = $b34bd66f0aa7fdf3$var$en(t.baseOptions, $b34bd66f0aa7fdf3$var$Ks, 3);
                if (!n) {
                    var r = n = new $b34bd66f0aa7fdf3$var$Ks, s = new $b34bd66f0aa7fdf3$var$Cr;
                    $b34bd66f0aa7fdf3$var$on(r, 4, $b34bd66f0aa7fdf3$var$Js, s);
                }
                "delegate" in e && ("GPU" === e.delegate ? (e = n, r = new $b34bd66f0aa7fdf3$var$Mr, $b34bd66f0aa7fdf3$var$on(e, 2, $b34bd66f0aa7fdf3$var$Js, r)) : (e = n, r = new $b34bd66f0aa7fdf3$var$Cr, $b34bd66f0aa7fdf3$var$on(e, 4, $b34bd66f0aa7fdf3$var$Js, r))), $b34bd66f0aa7fdf3$var$sn(t.baseOptions, 0, 3, n);
            }(this, e), e.modelAssetPath) return fetch(e.modelAssetPath.toString()).then((t)=>{
                if (t.ok) return t.arrayBuffer();
                throw Error(`Failed to fetch model: ${e.modelAssetPath} (${t.status})`);
            }).then((t)=>{
                try {
                    this.g.i.FS_unlink("/model.dat");
                } catch  {}
                this.g.i.FS_createDataFile("/", "model.dat", new Uint8Array(t), !0, !1, !1), $b34bd66f0aa7fdf3$var$yo(this, "/model.dat"), this.m(), this.P();
            });
            $b34bd66f0aa7fdf3$var$yo(this, e.modelAssetBuffer);
        }
        return this.m(), this.P(), Promise.resolve();
    }
    P() {}
    W() {
        let t;
        if (this.g.W((e)=>{
            t = $b34bd66f0aa7fdf3$var$os(e);
        }), !t) throw Error("Failed to retrieve CalculatorGraphConfig");
        return t;
    }
    setGraph(t, e) {
        this.g.attachErrorListener((t, e)=>{
            this.J.push(Error(e));
        }), this.g.Aa(), this.g.setGraph(t, e), this.A = void 0, $b34bd66f0aa7fdf3$var$vo(this);
    }
    finishProcessing() {
        this.g.finishProcessing(), $b34bd66f0aa7fdf3$var$vo(this);
    }
    close() {
        this.A = void 0, this.g.closeGraph();
    }
};
$b34bd66f0aa7fdf3$export$61e9fc2d6edc635c.prototype.close = $b34bd66f0aa7fdf3$export$61e9fc2d6edc635c.prototype.close;
const $b34bd66f0aa7fdf3$var$To = {
    color: "white",
    lineWidth: 4,
    radius: 6
};
function $b34bd66f0aa7fdf3$var$ko(t) {
    return {
        ...$b34bd66f0aa7fdf3$var$To,
        fillColor: (t = t || {}).color,
        ...t
    };
}
function $b34bd66f0aa7fdf3$var$xo(t, e) {
    return t instanceof Function ? t(e) : t;
}
function $b34bd66f0aa7fdf3$var$Lo(t, e, n) {
    return Math.max(Math.min(e, n), Math.min(Math.max(e, n), t));
}
var $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de = class {
    constructor(t){
        this.g = t;
    }
    ma(t, e) {
        if (t) {
            var n = this.g;
            e = $b34bd66f0aa7fdf3$var$ko(e), n.save();
            var r = n.canvas, s = 0;
            for (const i of t)n.fillStyle = $b34bd66f0aa7fdf3$var$xo(e.fillColor, {
                index: s,
                from: i
            }), n.strokeStyle = $b34bd66f0aa7fdf3$var$xo(e.color, {
                index: s,
                from: i
            }), n.lineWidth = $b34bd66f0aa7fdf3$var$xo(e.lineWidth, {
                index: s,
                from: i
            }), (t = new Path2D).arc(i.x * r.width, i.y * r.height, $b34bd66f0aa7fdf3$var$xo(e.radius, {
                index: s,
                from: i
            }), 0, 2 * Math.PI), n.fill(t), n.stroke(t), ++s;
            n.restore();
        }
    }
    la(t, e, n) {
        if (t && e) {
            var r = this.g;
            n = $b34bd66f0aa7fdf3$var$ko(n), r.save();
            var s = r.canvas, i = 0;
            for (const o of e){
                r.beginPath(), e = t[o.start];
                const a = t[o.end];
                e && a && (r.strokeStyle = $b34bd66f0aa7fdf3$var$xo(n.color, {
                    index: i,
                    from: e,
                    to: a
                }), r.lineWidth = $b34bd66f0aa7fdf3$var$xo(n.lineWidth, {
                    index: i,
                    from: e,
                    to: a
                }), r.moveTo(e.x * s.width, e.y * s.height), r.lineTo(a.x * s.width, a.y * s.height)), ++i, r.stroke();
            }
            r.restore();
        }
    }
    ka(t, e) {
        const n = this.g;
        e = $b34bd66f0aa7fdf3$var$ko(e), n.save(), n.beginPath(), n.lineWidth = $b34bd66f0aa7fdf3$var$xo(e.lineWidth, {}), n.strokeStyle = $b34bd66f0aa7fdf3$var$xo(e.color, {}), n.fillStyle = $b34bd66f0aa7fdf3$var$xo(e.fillColor, {}), n.moveTo(t.originX, t.originY), n.lineTo(t.originX + t.width, t.originY), n.lineTo(t.originX + t.width, t.originY + t.height), n.lineTo(t.originX, t.originY + t.height), n.lineTo(t.originX, t.originY), n.stroke(), n.fill(), n.restore();
    }
};
function $b34bd66f0aa7fdf3$var$So(t, e) {
    if (null === t) throw Error(`Unable to obtain required WebGL resource: ${e}`);
    return t;
}
$b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawBoundingBox = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.ka, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawConnectors = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.la, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawLandmarks = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.ma, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.lerp = function(t, e, n, r, s) {
    return $b34bd66f0aa7fdf3$var$Lo(r * (1 - (t - e) / (n - e)) + s * (1 - (n - t) / (n - e)), r, s);
}, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.clamp = $b34bd66f0aa7fdf3$var$Lo;
class $b34bd66f0aa7fdf3$var$Oo {
    constructor(t, e, n, r){
        this.g = t, this.h = e, this.m = n, this.l = r;
    }
    bind() {
        this.g.bindVertexArray(this.h);
    }
    close() {
        this.g.deleteVertexArray(this.h), this.g.deleteBuffer(this.m), this.g.deleteBuffer(this.l);
    }
}
function $b34bd66f0aa7fdf3$var$Mo(t, e, n) {
    const r = t.h;
    if (n = $b34bd66f0aa7fdf3$var$So(r.createShader(n), "Failed to create WebGL shader"), r.shaderSource(n, e), r.compileShader(n), !r.getShaderParameter(n, r.COMPILE_STATUS)) throw Error(`Could not compile WebGL shader: ${r.getShaderInfoLog(n)}`);
    return r.attachShader(t.g, n), n;
}
function $b34bd66f0aa7fdf3$var$Po(t, e) {
    const n = t.h, r = $b34bd66f0aa7fdf3$var$So(n.createVertexArray(), "Failed to create vertex array");
    n.bindVertexArray(r);
    const s = $b34bd66f0aa7fdf3$var$So(n.createBuffer(), "Failed to create buffer");
    n.bindBuffer(n.ARRAY_BUFFER, s), n.enableVertexAttribArray(t.s), n.vertexAttribPointer(t.s, 2, n.FLOAT, !1, 0, 0), n.bufferData(n.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        1,
        1,
        -1
    ]), n.STATIC_DRAW);
    const i = $b34bd66f0aa7fdf3$var$So(n.createBuffer(), "Failed to create buffer");
    return n.bindBuffer(n.ARRAY_BUFFER, i), n.enableVertexAttribArray(t.A), n.vertexAttribPointer(t.A, 2, n.FLOAT, !1, 0, 0), n.bufferData(n.ARRAY_BUFFER, new Float32Array(e ? [
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1
    ] : [
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]), n.STATIC_DRAW), n.bindBuffer(n.ARRAY_BUFFER, null), n.bindVertexArray(null), new $b34bd66f0aa7fdf3$var$Oo(n, r, s, i);
}
function $b34bd66f0aa7fdf3$var$Ro(t, e) {
    if (t.h) {
        if (e !== t.h) throw Error("Cannot change GL context once initialized");
    } else t.h = e;
}
function $b34bd66f0aa7fdf3$var$Co(t, e, n, r) {
    if ($b34bd66f0aa7fdf3$var$Ro(t, e), !t.g) {
        const e = t.h;
        if (t.g = $b34bd66f0aa7fdf3$var$So(e.createProgram(), "Failed to create WebGL program"), t.C = $b34bd66f0aa7fdf3$var$Mo(t, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", e.VERTEX_SHADER), t.v = $b34bd66f0aa7fdf3$var$Mo(t, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D inputTexture;\n   void main() {\n     gl_FragColor = texture2D(inputTexture, vTex);\n   }\n ", e.FRAGMENT_SHADER), e.linkProgram(t.g), !e.getProgramParameter(t.g, e.LINK_STATUS)) throw Error(`Error during program linking: ${e.getProgramInfoLog(t.g)}`);
        t.s = e.getAttribLocation(t.g, "aVertex"), t.A = e.getAttribLocation(t.g, "aTex");
    }
    return n ? (t.m || (t.m = $b34bd66f0aa7fdf3$var$Po(t, !0)), n = t.m) : (t.j || (t.j = $b34bd66f0aa7fdf3$var$Po(t, !1)), n = t.j), e.useProgram(t.g), n.bind(), t = r(), n.g.bindVertexArray(null), t;
}
function $b34bd66f0aa7fdf3$var$Io(t, e, n) {
    $b34bd66f0aa7fdf3$var$Ro(t, e), t.l || (t.l = $b34bd66f0aa7fdf3$var$So(e.createFramebuffer(), "Failed to create framebuffe.")), e.bindFramebuffer(e.FRAMEBUFFER, t.l), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, n, 0);
}
function $b34bd66f0aa7fdf3$var$Do(t) {
    t.h?.bindFramebuffer(t.h.FRAMEBUFFER, null);
}
var $b34bd66f0aa7fdf3$var$Bo = class {
    close() {
        if (this.g) {
            const t = this.h;
            t.deleteProgram(this.g), t.deleteShader(this.C), t.deleteShader(this.v);
        }
        this.l && this.h.deleteFramebuffer(this.l), this.j && this.j.close(), this.m && this.m.close();
    }
};
function $b34bd66f0aa7fdf3$var$Uo(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof ImageData);
        case 1:
            return t.g.find((t)=>"undefined" != typeof ImageBitmap && t instanceof ImageBitmap);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $b34bd66f0aa7fdf3$var$No(t) {
    var e = $b34bd66f0aa7fdf3$var$Uo(t, 0);
    if (!e) {
        e = $b34bd66f0aa7fdf3$var$jo(t);
        const n = $b34bd66f0aa7fdf3$var$Vo(t), r = new Uint8Array(t.width * t.height * 4);
        $b34bd66f0aa7fdf3$var$Io(n, e, $b34bd66f0aa7fdf3$var$Go(t)), e.readPixels(0, 0, t.width, t.height, e.RGBA, e.UNSIGNED_BYTE, r), $b34bd66f0aa7fdf3$var$Do(n), e = new ImageData(new Uint8ClampedArray(r.buffer), t.width, t.height), t.g.push(e);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Go(t) {
    let e = $b34bd66f0aa7fdf3$var$Uo(t, 2);
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$jo(t);
        e = $b34bd66f0aa7fdf3$var$Wo(t);
        const r = $b34bd66f0aa7fdf3$var$Uo(t, 1) || $b34bd66f0aa7fdf3$var$No(t);
        n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, r), $b34bd66f0aa7fdf3$var$Xo(t);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$jo(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when iniitializing the image.");
    return t.h || (t.h = $b34bd66f0aa7fdf3$var$So(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $b34bd66f0aa7fdf3$var$Vo(t) {
    return t.l || (t.l = new $b34bd66f0aa7fdf3$var$Bo), t.l;
}
function $b34bd66f0aa7fdf3$var$zo(t) {
    (t = $b34bd66f0aa7fdf3$var$jo(t)).texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR);
}
function $b34bd66f0aa7fdf3$var$Wo(t) {
    const e = $b34bd66f0aa7fdf3$var$jo(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    let n = $b34bd66f0aa7fdf3$var$Uo(t, 2);
    return n ? e.bindTexture(e.TEXTURE_2D, n) : (n = $b34bd66f0aa7fdf3$var$So(e.createTexture(), "Failed to create texture"), t.g.push(n), t.m = !0, e.bindTexture(e.TEXTURE_2D, n), $b34bd66f0aa7fdf3$var$zo(t)), n;
}
function $b34bd66f0aa7fdf3$var$Xo(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
function $b34bd66f0aa7fdf3$var$Ho(t) {
    const e = $b34bd66f0aa7fdf3$var$jo(t);
    return $b34bd66f0aa7fdf3$var$Co($b34bd66f0aa7fdf3$var$Vo(t), e, !0, ()=>(function(t, e) {
            const n = t.canvas;
            if (n.width === t.width && n.height === t.height) return e();
            const r = n.width, s = n.height;
            return n.width = t.width, n.height = t.height, t = e(), n.width = r, n.height = s, t;
        })(t, ()=>{
            if (e.bindFramebuffer(e.FRAMEBUFFER, null), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), e.drawArrays(e.TRIANGLE_FAN, 0, 4), !(t.canvas instanceof OffscreenCanvas)) throw Error("Conversion to ImageBitmap requires that the MediaPipe Tasks is initialized with an OffscreenCanvas");
            return t.canvas.transferToImageBitmap();
        }));
}
var $b34bd66f0aa7fdf3$export$7c9479202f61c045 = class {
    constructor(t, e, n, r, s, i, o){
        this.g = t, this.j = e, this.m = n, this.canvas = r, this.l = s, this.width = i, this.height = o, (this.j || this.m) && 0 === --$b34bd66f0aa7fdf3$var$$o && console.error("You seem to be creating MPImage instances without invoking .close(). This leaks resources.");
    }
    va() {
        return !!$b34bd66f0aa7fdf3$var$Uo(this, 0);
    }
    ba() {
        return !!$b34bd66f0aa7fdf3$var$Uo(this, 1);
    }
    K() {
        return !!$b34bd66f0aa7fdf3$var$Uo(this, 2);
    }
    ra() {
        return $b34bd66f0aa7fdf3$var$No(this);
    }
    qa() {
        var t = $b34bd66f0aa7fdf3$var$Uo(this, 1);
        return t || ($b34bd66f0aa7fdf3$var$Go(this), $b34bd66f0aa7fdf3$var$Wo(this), t = $b34bd66f0aa7fdf3$var$Ho(this), $b34bd66f0aa7fdf3$var$Xo(this), this.g.push(t), this.j = !0), t;
    }
    V() {
        return $b34bd66f0aa7fdf3$var$Go(this);
    }
    clone() {
        const t = [];
        for (const e of this.g){
            let n;
            if (e instanceof ImageData) n = new ImageData(e.data, this.width, this.height);
            else if (e instanceof WebGLTexture) {
                const t = $b34bd66f0aa7fdf3$var$jo(this), e = $b34bd66f0aa7fdf3$var$Vo(this);
                t.activeTexture(t.TEXTURE1), n = $b34bd66f0aa7fdf3$var$So(t.createTexture(), "Failed to create texture"), t.bindTexture(t.TEXTURE_2D, n), $b34bd66f0aa7fdf3$var$zo(this), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, this.width, this.height, 0, t.RGBA, t.UNSIGNED_BYTE, null), t.bindTexture(t.TEXTURE_2D, null), $b34bd66f0aa7fdf3$var$Io(e, t, n), $b34bd66f0aa7fdf3$var$Co(e, t, !1, ()=>{
                    $b34bd66f0aa7fdf3$var$Wo(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $b34bd66f0aa7fdf3$var$Xo(this);
                }), $b34bd66f0aa7fdf3$var$Do(e), $b34bd66f0aa7fdf3$var$Xo(this);
            } else {
                if (!(e instanceof ImageBitmap)) throw Error(`Type is not supported: ${e}`);
                $b34bd66f0aa7fdf3$var$Go(this), $b34bd66f0aa7fdf3$var$Wo(this), n = $b34bd66f0aa7fdf3$var$Ho(this), $b34bd66f0aa7fdf3$var$Xo(this);
            }
            t.push(n);
        }
        return new $b34bd66f0aa7fdf3$export$7c9479202f61c045(t, this.ba(), this.K(), this.canvas, this.l, this.width, this.height);
    }
    close() {
        this.j && $b34bd66f0aa7fdf3$var$Uo(this, 1).close(), this.m && $b34bd66f0aa7fdf3$var$jo(this).deleteTexture($b34bd66f0aa7fdf3$var$Uo(this, 2)), $b34bd66f0aa7fdf3$var$$o = -1;
    }
};
$b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.close = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.close, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.clone = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.clone, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsWebGLTexture = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.V, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsImageBitmap = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.qa, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsImageData = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.ra, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasWebGLTexture = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.K, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasImageBitmap = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.ba, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasImageData = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.va;
var $b34bd66f0aa7fdf3$var$$o = 250;
function $b34bd66f0aa7fdf3$var$qo(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof Uint8Array);
        case 1:
            return t.g.find((t)=>t instanceof Float32Array);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $b34bd66f0aa7fdf3$var$Ko(t) {
    var e = $b34bd66f0aa7fdf3$var$qo(t, 1);
    if (!e) {
        if (e = $b34bd66f0aa7fdf3$var$qo(t, 0)) e = new Float32Array(e).map((t)=>t / 255);
        else {
            e = new Float32Array(t.width * t.height);
            const r = $b34bd66f0aa7fdf3$var$Zo(t);
            var n = $b34bd66f0aa7fdf3$var$ta(t);
            if ($b34bd66f0aa7fdf3$var$Io(n, r, $b34bd66f0aa7fdf3$var$Jo(t)), "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document) {
                n = new Float32Array(t.width * t.height * 4), r.readPixels(0, 0, t.width, t.height, r.RGBA, r.FLOAT, n);
                for(let t = 0, r = 0; t < e.length; ++t, r += 4)e[t] = n[r];
            } else r.readPixels(0, 0, t.width, t.height, r.RED, r.FLOAT, e);
        }
        t.g.push(e);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Jo(t) {
    let e = $b34bd66f0aa7fdf3$var$qo(t, 2);
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$Zo(t);
        e = $b34bd66f0aa7fdf3$var$na(t);
        const r = $b34bd66f0aa7fdf3$var$Ko(t), s = $b34bd66f0aa7fdf3$var$Qo(t);
        n.texImage2D(n.TEXTURE_2D, 0, s, t.width, t.height, 0, n.RED, n.FLOAT, r), $b34bd66f0aa7fdf3$var$ra(t);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Zo(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when initializing the image.");
    return t.h || (t.h = $b34bd66f0aa7fdf3$var$So(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $b34bd66f0aa7fdf3$var$Qo(t) {
    if (t = $b34bd66f0aa7fdf3$var$Zo(t), !$b34bd66f0aa7fdf3$var$sa) {
        if (t.getExtension("EXT_color_buffer_float") && t.getExtension("OES_texture_float_linear") && t.getExtension("EXT_float_blend")) $b34bd66f0aa7fdf3$var$sa = t.R32F;
        else {
            if (!t.getExtension("EXT_color_buffer_half_float")) throw Error("GPU does not fully support 4-channel float32 or float16 formats");
            $b34bd66f0aa7fdf3$var$sa = t.R16F;
        }
    }
    return $b34bd66f0aa7fdf3$var$sa;
}
function $b34bd66f0aa7fdf3$var$ta(t) {
    return t.l || (t.l = new $b34bd66f0aa7fdf3$var$Bo), t.l;
}
function $b34bd66f0aa7fdf3$var$ea(t) {
    (t = $b34bd66f0aa7fdf3$var$Zo(t)).texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST);
}
function $b34bd66f0aa7fdf3$var$na(t) {
    const e = $b34bd66f0aa7fdf3$var$Zo(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    let n = $b34bd66f0aa7fdf3$var$qo(t, 2);
    return n ? e.bindTexture(e.TEXTURE_2D, n) : (n = $b34bd66f0aa7fdf3$var$So(e.createTexture(), "Failed to create texture"), t.g.push(n), t.m = !0, e.bindTexture(e.TEXTURE_2D, n), $b34bd66f0aa7fdf3$var$ea(t)), n;
}
function $b34bd66f0aa7fdf3$var$ra(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
var $b34bd66f0aa7fdf3$var$sa, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef = class {
    constructor(t, e, n, r, s, i){
        this.g = t, this.m = e, this.canvas = n, this.l = r, this.width = s, this.height = i, this.m && 0 === --$b34bd66f0aa7fdf3$var$oa && console.error("You seem to be creating MPMask instances without invoking .close(). This leaks resources.");
    }
    wa() {
        return !!$b34bd66f0aa7fdf3$var$qo(this, 0);
    }
    ua() {
        return !!$b34bd66f0aa7fdf3$var$qo(this, 1);
    }
    K() {
        return !!$b34bd66f0aa7fdf3$var$qo(this, 2);
    }
    sa() {
        var t, e;
        return (e = $b34bd66f0aa7fdf3$var$qo(t = this, 0)) || (e = $b34bd66f0aa7fdf3$var$Ko(t), e = new Uint8Array(e.map((t)=>255 * t)), t.g.push(e)), e;
    }
    pa() {
        return $b34bd66f0aa7fdf3$var$Ko(this);
    }
    V() {
        return $b34bd66f0aa7fdf3$var$Jo(this);
    }
    clone() {
        const t = [];
        for (const e of this.g){
            let n;
            if (e instanceof Uint8Array) n = new Uint8Array(e);
            else if (e instanceof Float32Array) n = new Float32Array(e);
            else {
                if (!(e instanceof WebGLTexture)) throw Error(`Type is not supported: ${e}`);
                {
                    const t = $b34bd66f0aa7fdf3$var$Zo(this), e = $b34bd66f0aa7fdf3$var$ta(this);
                    t.activeTexture(t.TEXTURE1), n = $b34bd66f0aa7fdf3$var$So(t.createTexture(), "Failed to create texture"), t.bindTexture(t.TEXTURE_2D, n), $b34bd66f0aa7fdf3$var$ea(this);
                    const r = $b34bd66f0aa7fdf3$var$Qo(this);
                    t.texImage2D(t.TEXTURE_2D, 0, r, this.width, this.height, 0, t.RED, t.FLOAT, null), t.bindTexture(t.TEXTURE_2D, null), $b34bd66f0aa7fdf3$var$Io(e, t, n), $b34bd66f0aa7fdf3$var$Co(e, t, !1, ()=>{
                        $b34bd66f0aa7fdf3$var$na(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $b34bd66f0aa7fdf3$var$ra(this);
                    }), $b34bd66f0aa7fdf3$var$Do(e), $b34bd66f0aa7fdf3$var$ra(this);
                }
            }
            t.push(n);
        }
        return new $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef(t, this.K(), this.canvas, this.l, this.width, this.height);
    }
    close() {
        this.m && $b34bd66f0aa7fdf3$var$Zo(this).deleteTexture($b34bd66f0aa7fdf3$var$qo(this, 2)), $b34bd66f0aa7fdf3$var$oa = -1;
    }
};
$b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.close = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.close, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.clone = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.clone, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsWebGLTexture = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.V, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsFloat32Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.pa, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsUint8Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.sa, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasWebGLTexture = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.K, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasFloat32Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.ua, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasUint8Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.wa;
var $b34bd66f0aa7fdf3$var$oa = 250;
function $b34bd66f0aa7fdf3$var$aa(...t) {
    return t.map(([t, e])=>({
            start: t,
            end: e
        }));
}
const $b34bd66f0aa7fdf3$var$ha = function(t) {
    return class extends t {
        Aa() {
            this.i._registerModelResourcesGraphService();
        }
    };
}(($b34bd66f0aa7fdf3$var$ca = class {
    constructor(t, e){
        this.l = !0, this.i = t, this.g = null, this.h = 0, this.m = "function" == typeof this.i._addIntToInputStream, void 0 !== e ? this.i.canvas = e : "undefined" == typeof OffscreenCanvas || $b34bd66f0aa7fdf3$var$ho() ? (console.warn("OffscreenCanvas not supported and GraphRunner constructor glCanvas parameter is undefined. Creating backup canvas."), this.i.canvas = document.createElement("canvas")) : this.i.canvas = new OffscreenCanvas(1, 1);
    }
    async initializeGraph(t) {
        const e = await (await fetch(t)).arrayBuffer();
        t = !(t.endsWith(".pbtxt") || t.endsWith(".textproto")), this.setGraph(new Uint8Array(e), t);
    }
    setGraphFromString(t) {
        this.setGraph((new TextEncoder).encode(t), !1);
    }
    setGraph(t, e) {
        const n = t.length, r = this.i._malloc(n);
        this.i.HEAPU8.set(t, r), e ? this.i._changeBinaryGraph(n, r) : this.i._changeTextGraph(n, r), this.i._free(r);
    }
    configureAudio(t, e, n, r, s) {
        this.i._configureAudio || console.warn('Attempting to use configureAudio without support for input audio. Is build dep ":gl_graph_runner_audio" missing?'), $b34bd66f0aa7fdf3$var$uo(this, r || "input_audio", (r)=>{
            $b34bd66f0aa7fdf3$var$uo(this, s = s || "audio_header", (s)=>{
                this.i._configureAudio(r, s, t, e, n);
            });
        });
    }
    setAutoResizeCanvas(t) {
        this.l = t;
    }
    setAutoRenderToScreen(t) {
        this.i._setAutoRenderToScreen(t);
    }
    setGpuBufferVerticalFlip(t) {
        this.i.gpuOriginForWebTexturesIsBottomLeft = t;
    }
    W(t) {
        $b34bd66f0aa7fdf3$var$po(this, "__graph_config__", (e)=>{
            t(e);
        }), $b34bd66f0aa7fdf3$var$uo(this, "__graph_config__", (t)=>{
            this.i._getGraphConfig(t, void 0);
        }), delete this.i.simpleListeners.__graph_config__;
    }
    attachErrorListener(t) {
        this.i.errorListener = t;
    }
    attachEmptyPacketListener(t, e) {
        this.i.emptyPacketListeners = this.i.emptyPacketListeners || {}, this.i.emptyPacketListeners[t] = e;
    }
    addAudioToStream(t, e, n) {
        this.addAudioToStreamWithShape(t, 0, 0, e, n);
    }
    addAudioToStreamWithShape(t, e, n, r, s) {
        const i = 4 * t.length;
        this.h !== i && (this.g && this.i._free(this.g), this.g = this.i._malloc(i), this.h = i), this.i.HEAPF32.set(t, this.g / 4), $b34bd66f0aa7fdf3$var$uo(this, r, (t)=>{
            this.i._addAudioToInputStream(this.g, e, n, t, s);
        });
    }
    addGpuBufferToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            const [r, s] = $b34bd66f0aa7fdf3$var$lo(this, t, e);
            this.i._addBoundTextureToStream(e, r, s, n);
        });
    }
    addBoolToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addBoolToInputStream(t, e, n);
        });
    }
    addDoubleToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addDoubleToInputStream(t, e, n);
        });
    }
    addFloatToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addFloatToInputStream(t, e, n);
        });
    }
    addIntToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addIntToInputStream(t, e, n);
        });
    }
    addStringToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
                this.i._addStringToInputStream(t, e, n);
            });
        });
    }
    addStringRecordToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$fo(this, Object.keys(t), (r)=>{
                $b34bd66f0aa7fdf3$var$fo(this, Object.values(t), (s)=>{
                    this.i._addFlatHashMapToInputStream(r, s, Object.keys(t).length, e, n);
                });
            });
        });
    }
    addProtoToStream(t, e, n, r) {
        $b34bd66f0aa7fdf3$var$uo(this, n, (n)=>{
            $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
                const s = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, s), this.i._addProtoToInputStream(s, t.length, e, n, r), this.i._free(s);
            });
        });
    }
    addEmptyPacketToStream(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._addEmptyPacketToInputStream(t, e);
        });
    }
    addBoolToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addBoolToInputSidePacket(t, e);
        });
    }
    addDoubleToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addDoubleToInputSidePacket(t, e);
        });
    }
    addFloatToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addFloatToInputSidePacket(t, e);
        });
    }
    addIntToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            this.i._addIntToInputSidePacket(t, e);
        });
    }
    addStringToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
                this.i._addStringToInputSidePacket(t, e);
            });
        });
    }
    addProtoToInputSidePacket(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, n, (n)=>{
            $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
                const r = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, r), this.i._addProtoToInputSidePacket(r, t.length, e, n), this.i._free(r);
            });
        });
    }
    attachBoolListener(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachBoolListener(t);
        });
    }
    attachBoolVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachBoolVectorListener(t);
        });
    }
    attachIntListener(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachIntListener(t);
        });
    }
    attachIntVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachIntVectorListener(t);
        });
    }
    attachDoubleListener(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachDoubleListener(t);
        });
    }
    attachDoubleVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachDoubleVectorListener(t);
        });
    }
    attachFloatListener(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachFloatListener(t);
        });
    }
    attachFloatVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachFloatVectorListener(t);
        });
    }
    attachStringListener(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachStringListener(t);
        });
    }
    attachStringVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachStringVectorListener(t);
        });
    }
    attachProtoListener(t, e, n) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachProtoListener(t, n || !1);
        });
    }
    attachProtoVectorListener(t, e, n) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachProtoVectorListener(t, n || !1);
        });
    }
    attachAudioListener(t, e, n) {
        this.i._attachAudioListener || console.warn('Attempting to use attachAudioListener without support for output audio. Is build dep ":gl_graph_runner_audio_out" missing?'), $b34bd66f0aa7fdf3$var$po(this, t, (t, n)=>{
            t = new Float32Array(t.buffer, t.byteOffset, t.length / 4), e(t, n);
        }), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.i._attachAudioListener(t, n || !1);
        });
    }
    finishProcessing() {
        this.i._waitUntilIdle();
    }
    closeGraph() {
        this.i._closeGraph(), this.i.simpleListeners = void 0, this.i.emptyPacketListeners = void 0;
    }
}, class extends $b34bd66f0aa7fdf3$var$ca {
    get Y() {
        return this.i;
    }
    ga(t, e, n) {
        $b34bd66f0aa7fdf3$var$uo(this, e, (e)=>{
            const [r, s] = $b34bd66f0aa7fdf3$var$lo(this, t, e);
            this.Y._addBoundTextureAsImageToStream(e, r, s, n);
        });
    }
    S(t, e) {
        $b34bd66f0aa7fdf3$var$po(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.Y._attachImageListener(t);
        });
    }
    T(t, e) {
        $b34bd66f0aa7fdf3$var$go(this, t, e), $b34bd66f0aa7fdf3$var$uo(this, t, (t)=>{
            this.Y._attachImageVectorListener(t);
        });
    }
}));
var $b34bd66f0aa7fdf3$var$ca, $b34bd66f0aa7fdf3$var$ua = class extends $b34bd66f0aa7fdf3$var$ha {
};
async function $b34bd66f0aa7fdf3$var$la(t, e, n) {
    return async function(t, e, n, r) {
        return $b34bd66f0aa7fdf3$var$mo(t, e, n, r);
    }(t, n.canvas ?? ("undefined" == typeof OffscreenCanvas || $b34bd66f0aa7fdf3$var$ho() ? document.createElement("canvas") : void 0), e, n);
}
function $b34bd66f0aa7fdf3$var$fa(t, e, n, r) {
    if (t.Z) {
        const i = new $b34bd66f0aa7fdf3$var$Cs;
        if (n?.regionOfInterest) {
            if (!t.ea) throw Error("This task doesn't support region-of-interest.");
            var s = n.regionOfInterest;
            if (s.left >= s.right || s.top >= s.bottom) throw Error("Expected RectF with left < right and top < bottom.");
            if (0 > s.left || 0 > s.top || 1 < s.right || 1 < s.bottom) throw Error("Expected RectF values to be in [0,1].");
            $b34bd66f0aa7fdf3$var$gn(i, 1, (s.left + s.right) / 2), $b34bd66f0aa7fdf3$var$gn(i, 2, (s.top + s.bottom) / 2), $b34bd66f0aa7fdf3$var$gn(i, 4, s.right - s.left), $b34bd66f0aa7fdf3$var$gn(i, 3, s.bottom - s.top);
        } else $b34bd66f0aa7fdf3$var$gn(i, 1, .5), $b34bd66f0aa7fdf3$var$gn(i, 2, .5), $b34bd66f0aa7fdf3$var$gn(i, 4, 1), $b34bd66f0aa7fdf3$var$gn(i, 3, 1);
        if (n?.rotationDegrees) {
            if (0 != n?.rotationDegrees % 90) throw Error("Expected rotation to be a multiple of 90\xb0.");
            if ($b34bd66f0aa7fdf3$var$gn(i, 5, -Math.PI * n.rotationDegrees / 180), 0 != n?.rotationDegrees % 180) {
                const [t, r] = void 0 !== e.videoWidth ? [
                    e.videoWidth,
                    e.videoHeight
                ] : void 0 !== e.naturalWidth ? [
                    e.naturalWidth,
                    e.naturalHeight
                ] : [
                    e.width,
                    e.height
                ];
                n = $b34bd66f0aa7fdf3$var$fn(i, 3) * r / t, s = $b34bd66f0aa7fdf3$var$fn(i, 4) * t / r, $b34bd66f0aa7fdf3$var$gn(i, 4, n), $b34bd66f0aa7fdf3$var$gn(i, 3, s);
            }
        }
        t.g.addProtoToStream(i.g(), "mediapipe.NormalizedRect", t.Z, r);
    }
    t.g.ga(e, t.da, r ?? performance.now()), t.finishProcessing();
}
function $b34bd66f0aa7fdf3$var$da(t, e, n) {
    if (t.baseOptions?.g()) throw Error("Task is not initialized with image mode. 'runningMode' must be set to 'IMAGE'.");
    $b34bd66f0aa7fdf3$var$fa(t, e, n, t.I + 1);
}
function $b34bd66f0aa7fdf3$var$pa(t, e, n, r) {
    if (!t.baseOptions?.g()) throw Error("Task is not initialized with video mode. 'runningMode' must be set to 'VIDEO'.");
    $b34bd66f0aa7fdf3$var$fa(t, e, n, r);
}
function $b34bd66f0aa7fdf3$var$ga(t, e, n) {
    var r = e.data;
    const s = e.width, i = s * (e = e.height);
    if ((r instanceof Uint8Array || r instanceof Float32Array) && r.length !== i) throw Error("Unsupported channel count: " + r.length / i);
    return t = new $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef([
        r
    ], !1, t.g.i.canvas, t.O, s, e), n ? t.clone() : t;
}
var $b34bd66f0aa7fdf3$export$6371bff908d1a094 = class extends $b34bd66f0aa7fdf3$export$61e9fc2d6edc635c {
    constructor(t, e, n, r){
        super(t), this.g = t, this.da = e, this.Z = n, this.ea = r, this.O = new $b34bd66f0aa7fdf3$var$Bo;
    }
    l(t, e = !0) {
        if ("runningMode" in t && $b34bd66f0aa7fdf3$var$dn(this.baseOptions, 2, !!t.runningMode && "IMAGE" !== t.runningMode), void 0 !== t.canvas && this.g.i.canvas !== t.canvas) throw Error("You must create a new task to reset the canvas.");
        return super.l(t, e);
    }
    close() {
        this.O.close(), super.close();
    }
};
$b34bd66f0aa7fdf3$export$6371bff908d1a094.prototype.close = $b34bd66f0aa7fdf3$export$6371bff908d1a094.prototype.close;
var $b34bd66f0aa7fdf3$export$6de3c7136b240002 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect_in", !1), this.j = {
            detections: []
        }, this.h = new $b34bd66f0aa7fdf3$var$ni, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t), $b34bd66f0aa7fdf3$var$gn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.h, 3, .3);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return "minDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 2, t.minDetectionConfidence ?? .5), "minSuppressionThreshold" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 3, t.minSuppressionThreshold ?? .3), this.l(t);
    }
    F(t, e) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$da(this, t, e), this.j;
    }
    G(t, e, n) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$pa(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect_in"), $b34bd66f0aa7fdf3$var$rs(t, "detections");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$si, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.face_detector.FaceDetectorGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect_in"), $b34bd66f0aa7fdf3$var$$r(n, "DETECTIONS:detections"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Es(e), this.j.detections.push($b34bd66f0aa7fdf3$var$Zi(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.G, $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.detect = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.F, $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.setOptions = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.o, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromModelPath = async function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, e);
};
var $b34bd66f0aa7fdf3$var$va = $b34bd66f0aa7fdf3$var$aa([
    61,
    146
], [
    146,
    91
], [
    91,
    181
], [
    181,
    84
], [
    84,
    17
], [
    17,
    314
], [
    314,
    405
], [
    405,
    321
], [
    321,
    375
], [
    375,
    291
], [
    61,
    185
], [
    185,
    40
], [
    40,
    39
], [
    39,
    37
], [
    37,
    0
], [
    0,
    267
], [
    267,
    269
], [
    269,
    270
], [
    270,
    409
], [
    409,
    291
], [
    78,
    95
], [
    95,
    88
], [
    88,
    178
], [
    178,
    87
], [
    87,
    14
], [
    14,
    317
], [
    317,
    402
], [
    402,
    318
], [
    318,
    324
], [
    324,
    308
], [
    78,
    191
], [
    191,
    80
], [
    80,
    81
], [
    81,
    82
], [
    82,
    13
], [
    13,
    312
], [
    312,
    311
], [
    311,
    310
], [
    310,
    415
], [
    415,
    308
]), $b34bd66f0aa7fdf3$var$_a = $b34bd66f0aa7fdf3$var$aa([
    263,
    249
], [
    249,
    390
], [
    390,
    373
], [
    373,
    374
], [
    374,
    380
], [
    380,
    381
], [
    381,
    382
], [
    382,
    362
], [
    263,
    466
], [
    466,
    388
], [
    388,
    387
], [
    387,
    386
], [
    386,
    385
], [
    385,
    384
], [
    384,
    398
], [
    398,
    362
]), $b34bd66f0aa7fdf3$var$wa = $b34bd66f0aa7fdf3$var$aa([
    276,
    283
], [
    283,
    282
], [
    282,
    295
], [
    295,
    285
], [
    300,
    293
], [
    293,
    334
], [
    334,
    296
], [
    296,
    336
]), $b34bd66f0aa7fdf3$var$Aa = $b34bd66f0aa7fdf3$var$aa([
    474,
    475
], [
    475,
    476
], [
    476,
    477
], [
    477,
    474
]), $b34bd66f0aa7fdf3$var$ba = $b34bd66f0aa7fdf3$var$aa([
    33,
    7
], [
    7,
    163
], [
    163,
    144
], [
    144,
    145
], [
    145,
    153
], [
    153,
    154
], [
    154,
    155
], [
    155,
    133
], [
    33,
    246
], [
    246,
    161
], [
    161,
    160
], [
    160,
    159
], [
    159,
    158
], [
    158,
    157
], [
    157,
    173
], [
    173,
    133
]), $b34bd66f0aa7fdf3$var$Ea = $b34bd66f0aa7fdf3$var$aa([
    46,
    53
], [
    53,
    52
], [
    52,
    65
], [
    65,
    55
], [
    70,
    63
], [
    63,
    105
], [
    105,
    66
], [
    66,
    107
]), $b34bd66f0aa7fdf3$var$Ta = $b34bd66f0aa7fdf3$var$aa([
    469,
    470
], [
    470,
    471
], [
    471,
    472
], [
    472,
    469
]), $b34bd66f0aa7fdf3$var$ka = $b34bd66f0aa7fdf3$var$aa([
    10,
    338
], [
    338,
    297
], [
    297,
    332
], [
    332,
    284
], [
    284,
    251
], [
    251,
    389
], [
    389,
    356
], [
    356,
    454
], [
    454,
    323
], [
    323,
    361
], [
    361,
    288
], [
    288,
    397
], [
    397,
    365
], [
    365,
    379
], [
    379,
    378
], [
    378,
    400
], [
    400,
    377
], [
    377,
    152
], [
    152,
    148
], [
    148,
    176
], [
    176,
    149
], [
    149,
    150
], [
    150,
    136
], [
    136,
    172
], [
    172,
    58
], [
    58,
    132
], [
    132,
    93
], [
    93,
    234
], [
    234,
    127
], [
    127,
    162
], [
    162,
    21
], [
    21,
    54
], [
    54,
    103
], [
    103,
    67
], [
    67,
    109
], [
    109,
    10
]), $b34bd66f0aa7fdf3$var$xa = [
    ...$b34bd66f0aa7fdf3$var$va,
    ...$b34bd66f0aa7fdf3$var$_a,
    ...$b34bd66f0aa7fdf3$var$wa,
    ...$b34bd66f0aa7fdf3$var$ba,
    ...$b34bd66f0aa7fdf3$var$Ea,
    ...$b34bd66f0aa7fdf3$var$ka
], $b34bd66f0aa7fdf3$var$La = $b34bd66f0aa7fdf3$var$aa([
    127,
    34
], [
    34,
    139
], [
    139,
    127
], [
    11,
    0
], [
    0,
    37
], [
    37,
    11
], [
    232,
    231
], [
    231,
    120
], [
    120,
    232
], [
    72,
    37
], [
    37,
    39
], [
    39,
    72
], [
    128,
    121
], [
    121,
    47
], [
    47,
    128
], [
    232,
    121
], [
    121,
    128
], [
    128,
    232
], [
    104,
    69
], [
    69,
    67
], [
    67,
    104
], [
    175,
    171
], [
    171,
    148
], [
    148,
    175
], [
    118,
    50
], [
    50,
    101
], [
    101,
    118
], [
    73,
    39
], [
    39,
    40
], [
    40,
    73
], [
    9,
    151
], [
    151,
    108
], [
    108,
    9
], [
    48,
    115
], [
    115,
    131
], [
    131,
    48
], [
    194,
    204
], [
    204,
    211
], [
    211,
    194
], [
    74,
    40
], [
    40,
    185
], [
    185,
    74
], [
    80,
    42
], [
    42,
    183
], [
    183,
    80
], [
    40,
    92
], [
    92,
    186
], [
    186,
    40
], [
    230,
    229
], [
    229,
    118
], [
    118,
    230
], [
    202,
    212
], [
    212,
    214
], [
    214,
    202
], [
    83,
    18
], [
    18,
    17
], [
    17,
    83
], [
    76,
    61
], [
    61,
    146
], [
    146,
    76
], [
    160,
    29
], [
    29,
    30
], [
    30,
    160
], [
    56,
    157
], [
    157,
    173
], [
    173,
    56
], [
    106,
    204
], [
    204,
    194
], [
    194,
    106
], [
    135,
    214
], [
    214,
    192
], [
    192,
    135
], [
    203,
    165
], [
    165,
    98
], [
    98,
    203
], [
    21,
    71
], [
    71,
    68
], [
    68,
    21
], [
    51,
    45
], [
    45,
    4
], [
    4,
    51
], [
    144,
    24
], [
    24,
    23
], [
    23,
    144
], [
    77,
    146
], [
    146,
    91
], [
    91,
    77
], [
    205,
    50
], [
    50,
    187
], [
    187,
    205
], [
    201,
    200
], [
    200,
    18
], [
    18,
    201
], [
    91,
    106
], [
    106,
    182
], [
    182,
    91
], [
    90,
    91
], [
    91,
    181
], [
    181,
    90
], [
    85,
    84
], [
    84,
    17
], [
    17,
    85
], [
    206,
    203
], [
    203,
    36
], [
    36,
    206
], [
    148,
    171
], [
    171,
    140
], [
    140,
    148
], [
    92,
    40
], [
    40,
    39
], [
    39,
    92
], [
    193,
    189
], [
    189,
    244
], [
    244,
    193
], [
    159,
    158
], [
    158,
    28
], [
    28,
    159
], [
    247,
    246
], [
    246,
    161
], [
    161,
    247
], [
    236,
    3
], [
    3,
    196
], [
    196,
    236
], [
    54,
    68
], [
    68,
    104
], [
    104,
    54
], [
    193,
    168
], [
    168,
    8
], [
    8,
    193
], [
    117,
    228
], [
    228,
    31
], [
    31,
    117
], [
    189,
    193
], [
    193,
    55
], [
    55,
    189
], [
    98,
    97
], [
    97,
    99
], [
    99,
    98
], [
    126,
    47
], [
    47,
    100
], [
    100,
    126
], [
    166,
    79
], [
    79,
    218
], [
    218,
    166
], [
    155,
    154
], [
    154,
    26
], [
    26,
    155
], [
    209,
    49
], [
    49,
    131
], [
    131,
    209
], [
    135,
    136
], [
    136,
    150
], [
    150,
    135
], [
    47,
    126
], [
    126,
    217
], [
    217,
    47
], [
    223,
    52
], [
    52,
    53
], [
    53,
    223
], [
    45,
    51
], [
    51,
    134
], [
    134,
    45
], [
    211,
    170
], [
    170,
    140
], [
    140,
    211
], [
    67,
    69
], [
    69,
    108
], [
    108,
    67
], [
    43,
    106
], [
    106,
    91
], [
    91,
    43
], [
    230,
    119
], [
    119,
    120
], [
    120,
    230
], [
    226,
    130
], [
    130,
    247
], [
    247,
    226
], [
    63,
    53
], [
    53,
    52
], [
    52,
    63
], [
    238,
    20
], [
    20,
    242
], [
    242,
    238
], [
    46,
    70
], [
    70,
    156
], [
    156,
    46
], [
    78,
    62
], [
    62,
    96
], [
    96,
    78
], [
    46,
    53
], [
    53,
    63
], [
    63,
    46
], [
    143,
    34
], [
    34,
    227
], [
    227,
    143
], [
    123,
    117
], [
    117,
    111
], [
    111,
    123
], [
    44,
    125
], [
    125,
    19
], [
    19,
    44
], [
    236,
    134
], [
    134,
    51
], [
    51,
    236
], [
    216,
    206
], [
    206,
    205
], [
    205,
    216
], [
    154,
    153
], [
    153,
    22
], [
    22,
    154
], [
    39,
    37
], [
    37,
    167
], [
    167,
    39
], [
    200,
    201
], [
    201,
    208
], [
    208,
    200
], [
    36,
    142
], [
    142,
    100
], [
    100,
    36
], [
    57,
    212
], [
    212,
    202
], [
    202,
    57
], [
    20,
    60
], [
    60,
    99
], [
    99,
    20
], [
    28,
    158
], [
    158,
    157
], [
    157,
    28
], [
    35,
    226
], [
    226,
    113
], [
    113,
    35
], [
    160,
    159
], [
    159,
    27
], [
    27,
    160
], [
    204,
    202
], [
    202,
    210
], [
    210,
    204
], [
    113,
    225
], [
    225,
    46
], [
    46,
    113
], [
    43,
    202
], [
    202,
    204
], [
    204,
    43
], [
    62,
    76
], [
    76,
    77
], [
    77,
    62
], [
    137,
    123
], [
    123,
    116
], [
    116,
    137
], [
    41,
    38
], [
    38,
    72
], [
    72,
    41
], [
    203,
    129
], [
    129,
    142
], [
    142,
    203
], [
    64,
    98
], [
    98,
    240
], [
    240,
    64
], [
    49,
    102
], [
    102,
    64
], [
    64,
    49
], [
    41,
    73
], [
    73,
    74
], [
    74,
    41
], [
    212,
    216
], [
    216,
    207
], [
    207,
    212
], [
    42,
    74
], [
    74,
    184
], [
    184,
    42
], [
    169,
    170
], [
    170,
    211
], [
    211,
    169
], [
    170,
    149
], [
    149,
    176
], [
    176,
    170
], [
    105,
    66
], [
    66,
    69
], [
    69,
    105
], [
    122,
    6
], [
    6,
    168
], [
    168,
    122
], [
    123,
    147
], [
    147,
    187
], [
    187,
    123
], [
    96,
    77
], [
    77,
    90
], [
    90,
    96
], [
    65,
    55
], [
    55,
    107
], [
    107,
    65
], [
    89,
    90
], [
    90,
    180
], [
    180,
    89
], [
    101,
    100
], [
    100,
    120
], [
    120,
    101
], [
    63,
    105
], [
    105,
    104
], [
    104,
    63
], [
    93,
    137
], [
    137,
    227
], [
    227,
    93
], [
    15,
    86
], [
    86,
    85
], [
    85,
    15
], [
    129,
    102
], [
    102,
    49
], [
    49,
    129
], [
    14,
    87
], [
    87,
    86
], [
    86,
    14
], [
    55,
    8
], [
    8,
    9
], [
    9,
    55
], [
    100,
    47
], [
    47,
    121
], [
    121,
    100
], [
    145,
    23
], [
    23,
    22
], [
    22,
    145
], [
    88,
    89
], [
    89,
    179
], [
    179,
    88
], [
    6,
    122
], [
    122,
    196
], [
    196,
    6
], [
    88,
    95
], [
    95,
    96
], [
    96,
    88
], [
    138,
    172
], [
    172,
    136
], [
    136,
    138
], [
    215,
    58
], [
    58,
    172
], [
    172,
    215
], [
    115,
    48
], [
    48,
    219
], [
    219,
    115
], [
    42,
    80
], [
    80,
    81
], [
    81,
    42
], [
    195,
    3
], [
    3,
    51
], [
    51,
    195
], [
    43,
    146
], [
    146,
    61
], [
    61,
    43
], [
    171,
    175
], [
    175,
    199
], [
    199,
    171
], [
    81,
    82
], [
    82,
    38
], [
    38,
    81
], [
    53,
    46
], [
    46,
    225
], [
    225,
    53
], [
    144,
    163
], [
    163,
    110
], [
    110,
    144
], [
    52,
    65
], [
    65,
    66
], [
    66,
    52
], [
    229,
    228
], [
    228,
    117
], [
    117,
    229
], [
    34,
    127
], [
    127,
    234
], [
    234,
    34
], [
    107,
    108
], [
    108,
    69
], [
    69,
    107
], [
    109,
    108
], [
    108,
    151
], [
    151,
    109
], [
    48,
    64
], [
    64,
    235
], [
    235,
    48
], [
    62,
    78
], [
    78,
    191
], [
    191,
    62
], [
    129,
    209
], [
    209,
    126
], [
    126,
    129
], [
    111,
    35
], [
    35,
    143
], [
    143,
    111
], [
    117,
    123
], [
    123,
    50
], [
    50,
    117
], [
    222,
    65
], [
    65,
    52
], [
    52,
    222
], [
    19,
    125
], [
    125,
    141
], [
    141,
    19
], [
    221,
    55
], [
    55,
    65
], [
    65,
    221
], [
    3,
    195
], [
    195,
    197
], [
    197,
    3
], [
    25,
    7
], [
    7,
    33
], [
    33,
    25
], [
    220,
    237
], [
    237,
    44
], [
    44,
    220
], [
    70,
    71
], [
    71,
    139
], [
    139,
    70
], [
    122,
    193
], [
    193,
    245
], [
    245,
    122
], [
    247,
    130
], [
    130,
    33
], [
    33,
    247
], [
    71,
    21
], [
    21,
    162
], [
    162,
    71
], [
    170,
    169
], [
    169,
    150
], [
    150,
    170
], [
    188,
    174
], [
    174,
    196
], [
    196,
    188
], [
    216,
    186
], [
    186,
    92
], [
    92,
    216
], [
    2,
    97
], [
    97,
    167
], [
    167,
    2
], [
    141,
    125
], [
    125,
    241
], [
    241,
    141
], [
    164,
    167
], [
    167,
    37
], [
    37,
    164
], [
    72,
    38
], [
    38,
    12
], [
    12,
    72
], [
    38,
    82
], [
    82,
    13
], [
    13,
    38
], [
    63,
    68
], [
    68,
    71
], [
    71,
    63
], [
    226,
    35
], [
    35,
    111
], [
    111,
    226
], [
    101,
    50
], [
    50,
    205
], [
    205,
    101
], [
    206,
    92
], [
    92,
    165
], [
    165,
    206
], [
    209,
    198
], [
    198,
    217
], [
    217,
    209
], [
    165,
    167
], [
    167,
    97
], [
    97,
    165
], [
    220,
    115
], [
    115,
    218
], [
    218,
    220
], [
    133,
    112
], [
    112,
    243
], [
    243,
    133
], [
    239,
    238
], [
    238,
    241
], [
    241,
    239
], [
    214,
    135
], [
    135,
    169
], [
    169,
    214
], [
    190,
    173
], [
    173,
    133
], [
    133,
    190
], [
    171,
    208
], [
    208,
    32
], [
    32,
    171
], [
    125,
    44
], [
    44,
    237
], [
    237,
    125
], [
    86,
    87
], [
    87,
    178
], [
    178,
    86
], [
    85,
    86
], [
    86,
    179
], [
    179,
    85
], [
    84,
    85
], [
    85,
    180
], [
    180,
    84
], [
    83,
    84
], [
    84,
    181
], [
    181,
    83
], [
    201,
    83
], [
    83,
    182
], [
    182,
    201
], [
    137,
    93
], [
    93,
    132
], [
    132,
    137
], [
    76,
    62
], [
    62,
    183
], [
    183,
    76
], [
    61,
    76
], [
    76,
    184
], [
    184,
    61
], [
    57,
    61
], [
    61,
    185
], [
    185,
    57
], [
    212,
    57
], [
    57,
    186
], [
    186,
    212
], [
    214,
    207
], [
    207,
    187
], [
    187,
    214
], [
    34,
    143
], [
    143,
    156
], [
    156,
    34
], [
    79,
    239
], [
    239,
    237
], [
    237,
    79
], [
    123,
    137
], [
    137,
    177
], [
    177,
    123
], [
    44,
    1
], [
    1,
    4
], [
    4,
    44
], [
    201,
    194
], [
    194,
    32
], [
    32,
    201
], [
    64,
    102
], [
    102,
    129
], [
    129,
    64
], [
    213,
    215
], [
    215,
    138
], [
    138,
    213
], [
    59,
    166
], [
    166,
    219
], [
    219,
    59
], [
    242,
    99
], [
    99,
    97
], [
    97,
    242
], [
    2,
    94
], [
    94,
    141
], [
    141,
    2
], [
    75,
    59
], [
    59,
    235
], [
    235,
    75
], [
    24,
    110
], [
    110,
    228
], [
    228,
    24
], [
    25,
    130
], [
    130,
    226
], [
    226,
    25
], [
    23,
    24
], [
    24,
    229
], [
    229,
    23
], [
    22,
    23
], [
    23,
    230
], [
    230,
    22
], [
    26,
    22
], [
    22,
    231
], [
    231,
    26
], [
    112,
    26
], [
    26,
    232
], [
    232,
    112
], [
    189,
    190
], [
    190,
    243
], [
    243,
    189
], [
    221,
    56
], [
    56,
    190
], [
    190,
    221
], [
    28,
    56
], [
    56,
    221
], [
    221,
    28
], [
    27,
    28
], [
    28,
    222
], [
    222,
    27
], [
    29,
    27
], [
    27,
    223
], [
    223,
    29
], [
    30,
    29
], [
    29,
    224
], [
    224,
    30
], [
    247,
    30
], [
    30,
    225
], [
    225,
    247
], [
    238,
    79
], [
    79,
    20
], [
    20,
    238
], [
    166,
    59
], [
    59,
    75
], [
    75,
    166
], [
    60,
    75
], [
    75,
    240
], [
    240,
    60
], [
    147,
    177
], [
    177,
    215
], [
    215,
    147
], [
    20,
    79
], [
    79,
    166
], [
    166,
    20
], [
    187,
    147
], [
    147,
    213
], [
    213,
    187
], [
    112,
    233
], [
    233,
    244
], [
    244,
    112
], [
    233,
    128
], [
    128,
    245
], [
    245,
    233
], [
    128,
    114
], [
    114,
    188
], [
    188,
    128
], [
    114,
    217
], [
    217,
    174
], [
    174,
    114
], [
    131,
    115
], [
    115,
    220
], [
    220,
    131
], [
    217,
    198
], [
    198,
    236
], [
    236,
    217
], [
    198,
    131
], [
    131,
    134
], [
    134,
    198
], [
    177,
    132
], [
    132,
    58
], [
    58,
    177
], [
    143,
    35
], [
    35,
    124
], [
    124,
    143
], [
    110,
    163
], [
    163,
    7
], [
    7,
    110
], [
    228,
    110
], [
    110,
    25
], [
    25,
    228
], [
    356,
    389
], [
    389,
    368
], [
    368,
    356
], [
    11,
    302
], [
    302,
    267
], [
    267,
    11
], [
    452,
    350
], [
    350,
    349
], [
    349,
    452
], [
    302,
    303
], [
    303,
    269
], [
    269,
    302
], [
    357,
    343
], [
    343,
    277
], [
    277,
    357
], [
    452,
    453
], [
    453,
    357
], [
    357,
    452
], [
    333,
    332
], [
    332,
    297
], [
    297,
    333
], [
    175,
    152
], [
    152,
    377
], [
    377,
    175
], [
    347,
    348
], [
    348,
    330
], [
    330,
    347
], [
    303,
    304
], [
    304,
    270
], [
    270,
    303
], [
    9,
    336
], [
    336,
    337
], [
    337,
    9
], [
    278,
    279
], [
    279,
    360
], [
    360,
    278
], [
    418,
    262
], [
    262,
    431
], [
    431,
    418
], [
    304,
    408
], [
    408,
    409
], [
    409,
    304
], [
    310,
    415
], [
    415,
    407
], [
    407,
    310
], [
    270,
    409
], [
    409,
    410
], [
    410,
    270
], [
    450,
    348
], [
    348,
    347
], [
    347,
    450
], [
    422,
    430
], [
    430,
    434
], [
    434,
    422
], [
    313,
    314
], [
    314,
    17
], [
    17,
    313
], [
    306,
    307
], [
    307,
    375
], [
    375,
    306
], [
    387,
    388
], [
    388,
    260
], [
    260,
    387
], [
    286,
    414
], [
    414,
    398
], [
    398,
    286
], [
    335,
    406
], [
    406,
    418
], [
    418,
    335
], [
    364,
    367
], [
    367,
    416
], [
    416,
    364
], [
    423,
    358
], [
    358,
    327
], [
    327,
    423
], [
    251,
    284
], [
    284,
    298
], [
    298,
    251
], [
    281,
    5
], [
    5,
    4
], [
    4,
    281
], [
    373,
    374
], [
    374,
    253
], [
    253,
    373
], [
    307,
    320
], [
    320,
    321
], [
    321,
    307
], [
    425,
    427
], [
    427,
    411
], [
    411,
    425
], [
    421,
    313
], [
    313,
    18
], [
    18,
    421
], [
    321,
    405
], [
    405,
    406
], [
    406,
    321
], [
    320,
    404
], [
    404,
    405
], [
    405,
    320
], [
    315,
    16
], [
    16,
    17
], [
    17,
    315
], [
    426,
    425
], [
    425,
    266
], [
    266,
    426
], [
    377,
    400
], [
    400,
    369
], [
    369,
    377
], [
    322,
    391
], [
    391,
    269
], [
    269,
    322
], [
    417,
    465
], [
    465,
    464
], [
    464,
    417
], [
    386,
    257
], [
    257,
    258
], [
    258,
    386
], [
    466,
    260
], [
    260,
    388
], [
    388,
    466
], [
    456,
    399
], [
    399,
    419
], [
    419,
    456
], [
    284,
    332
], [
    332,
    333
], [
    333,
    284
], [
    417,
    285
], [
    285,
    8
], [
    8,
    417
], [
    346,
    340
], [
    340,
    261
], [
    261,
    346
], [
    413,
    441
], [
    441,
    285
], [
    285,
    413
], [
    327,
    460
], [
    460,
    328
], [
    328,
    327
], [
    355,
    371
], [
    371,
    329
], [
    329,
    355
], [
    392,
    439
], [
    439,
    438
], [
    438,
    392
], [
    382,
    341
], [
    341,
    256
], [
    256,
    382
], [
    429,
    420
], [
    420,
    360
], [
    360,
    429
], [
    364,
    394
], [
    394,
    379
], [
    379,
    364
], [
    277,
    343
], [
    343,
    437
], [
    437,
    277
], [
    443,
    444
], [
    444,
    283
], [
    283,
    443
], [
    275,
    440
], [
    440,
    363
], [
    363,
    275
], [
    431,
    262
], [
    262,
    369
], [
    369,
    431
], [
    297,
    338
], [
    338,
    337
], [
    337,
    297
], [
    273,
    375
], [
    375,
    321
], [
    321,
    273
], [
    450,
    451
], [
    451,
    349
], [
    349,
    450
], [
    446,
    342
], [
    342,
    467
], [
    467,
    446
], [
    293,
    334
], [
    334,
    282
], [
    282,
    293
], [
    458,
    461
], [
    461,
    462
], [
    462,
    458
], [
    276,
    353
], [
    353,
    383
], [
    383,
    276
], [
    308,
    324
], [
    324,
    325
], [
    325,
    308
], [
    276,
    300
], [
    300,
    293
], [
    293,
    276
], [
    372,
    345
], [
    345,
    447
], [
    447,
    372
], [
    352,
    345
], [
    345,
    340
], [
    340,
    352
], [
    274,
    1
], [
    1,
    19
], [
    19,
    274
], [
    456,
    248
], [
    248,
    281
], [
    281,
    456
], [
    436,
    427
], [
    427,
    425
], [
    425,
    436
], [
    381,
    256
], [
    256,
    252
], [
    252,
    381
], [
    269,
    391
], [
    391,
    393
], [
    393,
    269
], [
    200,
    199
], [
    199,
    428
], [
    428,
    200
], [
    266,
    330
], [
    330,
    329
], [
    329,
    266
], [
    287,
    273
], [
    273,
    422
], [
    422,
    287
], [
    250,
    462
], [
    462,
    328
], [
    328,
    250
], [
    258,
    286
], [
    286,
    384
], [
    384,
    258
], [
    265,
    353
], [
    353,
    342
], [
    342,
    265
], [
    387,
    259
], [
    259,
    257
], [
    257,
    387
], [
    424,
    431
], [
    431,
    430
], [
    430,
    424
], [
    342,
    353
], [
    353,
    276
], [
    276,
    342
], [
    273,
    335
], [
    335,
    424
], [
    424,
    273
], [
    292,
    325
], [
    325,
    307
], [
    307,
    292
], [
    366,
    447
], [
    447,
    345
], [
    345,
    366
], [
    271,
    303
], [
    303,
    302
], [
    302,
    271
], [
    423,
    266
], [
    266,
    371
], [
    371,
    423
], [
    294,
    455
], [
    455,
    460
], [
    460,
    294
], [
    279,
    278
], [
    278,
    294
], [
    294,
    279
], [
    271,
    272
], [
    272,
    304
], [
    304,
    271
], [
    432,
    434
], [
    434,
    427
], [
    427,
    432
], [
    272,
    407
], [
    407,
    408
], [
    408,
    272
], [
    394,
    430
], [
    430,
    431
], [
    431,
    394
], [
    395,
    369
], [
    369,
    400
], [
    400,
    395
], [
    334,
    333
], [
    333,
    299
], [
    299,
    334
], [
    351,
    417
], [
    417,
    168
], [
    168,
    351
], [
    352,
    280
], [
    280,
    411
], [
    411,
    352
], [
    325,
    319
], [
    319,
    320
], [
    320,
    325
], [
    295,
    296
], [
    296,
    336
], [
    336,
    295
], [
    319,
    403
], [
    403,
    404
], [
    404,
    319
], [
    330,
    348
], [
    348,
    349
], [
    349,
    330
], [
    293,
    298
], [
    298,
    333
], [
    333,
    293
], [
    323,
    454
], [
    454,
    447
], [
    447,
    323
], [
    15,
    16
], [
    16,
    315
], [
    315,
    15
], [
    358,
    429
], [
    429,
    279
], [
    279,
    358
], [
    14,
    15
], [
    15,
    316
], [
    316,
    14
], [
    285,
    336
], [
    336,
    9
], [
    9,
    285
], [
    329,
    349
], [
    349,
    350
], [
    350,
    329
], [
    374,
    380
], [
    380,
    252
], [
    252,
    374
], [
    318,
    402
], [
    402,
    403
], [
    403,
    318
], [
    6,
    197
], [
    197,
    419
], [
    419,
    6
], [
    318,
    319
], [
    319,
    325
], [
    325,
    318
], [
    367,
    364
], [
    364,
    365
], [
    365,
    367
], [
    435,
    367
], [
    367,
    397
], [
    397,
    435
], [
    344,
    438
], [
    438,
    439
], [
    439,
    344
], [
    272,
    271
], [
    271,
    311
], [
    311,
    272
], [
    195,
    5
], [
    5,
    281
], [
    281,
    195
], [
    273,
    287
], [
    287,
    291
], [
    291,
    273
], [
    396,
    428
], [
    428,
    199
], [
    199,
    396
], [
    311,
    271
], [
    271,
    268
], [
    268,
    311
], [
    283,
    444
], [
    444,
    445
], [
    445,
    283
], [
    373,
    254
], [
    254,
    339
], [
    339,
    373
], [
    282,
    334
], [
    334,
    296
], [
    296,
    282
], [
    449,
    347
], [
    347,
    346
], [
    346,
    449
], [
    264,
    447
], [
    447,
    454
], [
    454,
    264
], [
    336,
    296
], [
    296,
    299
], [
    299,
    336
], [
    338,
    10
], [
    10,
    151
], [
    151,
    338
], [
    278,
    439
], [
    439,
    455
], [
    455,
    278
], [
    292,
    407
], [
    407,
    415
], [
    415,
    292
], [
    358,
    371
], [
    371,
    355
], [
    355,
    358
], [
    340,
    345
], [
    345,
    372
], [
    372,
    340
], [
    346,
    347
], [
    347,
    280
], [
    280,
    346
], [
    442,
    443
], [
    443,
    282
], [
    282,
    442
], [
    19,
    94
], [
    94,
    370
], [
    370,
    19
], [
    441,
    442
], [
    442,
    295
], [
    295,
    441
], [
    248,
    419
], [
    419,
    197
], [
    197,
    248
], [
    263,
    255
], [
    255,
    359
], [
    359,
    263
], [
    440,
    275
], [
    275,
    274
], [
    274,
    440
], [
    300,
    383
], [
    383,
    368
], [
    368,
    300
], [
    351,
    412
], [
    412,
    465
], [
    465,
    351
], [
    263,
    467
], [
    467,
    466
], [
    466,
    263
], [
    301,
    368
], [
    368,
    389
], [
    389,
    301
], [
    395,
    378
], [
    378,
    379
], [
    379,
    395
], [
    412,
    351
], [
    351,
    419
], [
    419,
    412
], [
    436,
    426
], [
    426,
    322
], [
    322,
    436
], [
    2,
    164
], [
    164,
    393
], [
    393,
    2
], [
    370,
    462
], [
    462,
    461
], [
    461,
    370
], [
    164,
    0
], [
    0,
    267
], [
    267,
    164
], [
    302,
    11
], [
    11,
    12
], [
    12,
    302
], [
    268,
    12
], [
    12,
    13
], [
    13,
    268
], [
    293,
    300
], [
    300,
    301
], [
    301,
    293
], [
    446,
    261
], [
    261,
    340
], [
    340,
    446
], [
    330,
    266
], [
    266,
    425
], [
    425,
    330
], [
    426,
    423
], [
    423,
    391
], [
    391,
    426
], [
    429,
    355
], [
    355,
    437
], [
    437,
    429
], [
    391,
    327
], [
    327,
    326
], [
    326,
    391
], [
    440,
    457
], [
    457,
    438
], [
    438,
    440
], [
    341,
    382
], [
    382,
    362
], [
    362,
    341
], [
    459,
    457
], [
    457,
    461
], [
    461,
    459
], [
    434,
    430
], [
    430,
    394
], [
    394,
    434
], [
    414,
    463
], [
    463,
    362
], [
    362,
    414
], [
    396,
    369
], [
    369,
    262
], [
    262,
    396
], [
    354,
    461
], [
    461,
    457
], [
    457,
    354
], [
    316,
    403
], [
    403,
    402
], [
    402,
    316
], [
    315,
    404
], [
    404,
    403
], [
    403,
    315
], [
    314,
    405
], [
    405,
    404
], [
    404,
    314
], [
    313,
    406
], [
    406,
    405
], [
    405,
    313
], [
    421,
    418
], [
    418,
    406
], [
    406,
    421
], [
    366,
    401
], [
    401,
    361
], [
    361,
    366
], [
    306,
    408
], [
    408,
    407
], [
    407,
    306
], [
    291,
    409
], [
    409,
    408
], [
    408,
    291
], [
    287,
    410
], [
    410,
    409
], [
    409,
    287
], [
    432,
    436
], [
    436,
    410
], [
    410,
    432
], [
    434,
    416
], [
    416,
    411
], [
    411,
    434
], [
    264,
    368
], [
    368,
    383
], [
    383,
    264
], [
    309,
    438
], [
    438,
    457
], [
    457,
    309
], [
    352,
    376
], [
    376,
    401
], [
    401,
    352
], [
    274,
    275
], [
    275,
    4
], [
    4,
    274
], [
    421,
    428
], [
    428,
    262
], [
    262,
    421
], [
    294,
    327
], [
    327,
    358
], [
    358,
    294
], [
    433,
    416
], [
    416,
    367
], [
    367,
    433
], [
    289,
    455
], [
    455,
    439
], [
    439,
    289
], [
    462,
    370
], [
    370,
    326
], [
    326,
    462
], [
    2,
    326
], [
    326,
    370
], [
    370,
    2
], [
    305,
    460
], [
    460,
    455
], [
    455,
    305
], [
    254,
    449
], [
    449,
    448
], [
    448,
    254
], [
    255,
    261
], [
    261,
    446
], [
    446,
    255
], [
    253,
    450
], [
    450,
    449
], [
    449,
    253
], [
    252,
    451
], [
    451,
    450
], [
    450,
    252
], [
    256,
    452
], [
    452,
    451
], [
    451,
    256
], [
    341,
    453
], [
    453,
    452
], [
    452,
    341
], [
    413,
    464
], [
    464,
    463
], [
    463,
    413
], [
    441,
    413
], [
    413,
    414
], [
    414,
    441
], [
    258,
    442
], [
    442,
    441
], [
    441,
    258
], [
    257,
    443
], [
    443,
    442
], [
    442,
    257
], [
    259,
    444
], [
    444,
    443
], [
    443,
    259
], [
    260,
    445
], [
    445,
    444
], [
    444,
    260
], [
    467,
    342
], [
    342,
    445
], [
    445,
    467
], [
    459,
    458
], [
    458,
    250
], [
    250,
    459
], [
    289,
    392
], [
    392,
    290
], [
    290,
    289
], [
    290,
    328
], [
    328,
    460
], [
    460,
    290
], [
    376,
    433
], [
    433,
    435
], [
    435,
    376
], [
    250,
    290
], [
    290,
    392
], [
    392,
    250
], [
    411,
    416
], [
    416,
    433
], [
    433,
    411
], [
    341,
    463
], [
    463,
    464
], [
    464,
    341
], [
    453,
    464
], [
    464,
    465
], [
    465,
    453
], [
    357,
    465
], [
    465,
    412
], [
    412,
    357
], [
    343,
    412
], [
    412,
    399
], [
    399,
    343
], [
    360,
    363
], [
    363,
    440
], [
    440,
    360
], [
    437,
    399
], [
    399,
    456
], [
    456,
    437
], [
    420,
    456
], [
    456,
    363
], [
    363,
    420
], [
    401,
    435
], [
    435,
    288
], [
    288,
    401
], [
    372,
    383
], [
    383,
    353
], [
    353,
    372
], [
    339,
    255
], [
    255,
    249
], [
    249,
    339
], [
    448,
    261
], [
    261,
    255
], [
    255,
    448
], [
    133,
    243
], [
    243,
    190
], [
    190,
    133
], [
    133,
    155
], [
    155,
    112
], [
    112,
    133
], [
    33,
    246
], [
    246,
    247
], [
    247,
    33
], [
    33,
    130
], [
    130,
    25
], [
    25,
    33
], [
    398,
    384
], [
    384,
    286
], [
    286,
    398
], [
    362,
    398
], [
    398,
    414
], [
    414,
    362
], [
    362,
    463
], [
    463,
    341
], [
    341,
    362
], [
    263,
    359
], [
    359,
    467
], [
    467,
    263
], [
    263,
    249
], [
    249,
    255
], [
    255,
    263
], [
    466,
    467
], [
    467,
    260
], [
    260,
    466
], [
    75,
    60
], [
    60,
    166
], [
    166,
    75
], [
    238,
    239
], [
    239,
    79
], [
    79,
    238
], [
    162,
    127
], [
    127,
    139
], [
    139,
    162
], [
    72,
    11
], [
    11,
    37
], [
    37,
    72
], [
    121,
    232
], [
    232,
    120
], [
    120,
    121
], [
    73,
    72
], [
    72,
    39
], [
    39,
    73
], [
    114,
    128
], [
    128,
    47
], [
    47,
    114
], [
    233,
    232
], [
    232,
    128
], [
    128,
    233
], [
    103,
    104
], [
    104,
    67
], [
    67,
    103
], [
    152,
    175
], [
    175,
    148
], [
    148,
    152
], [
    119,
    118
], [
    118,
    101
], [
    101,
    119
], [
    74,
    73
], [
    73,
    40
], [
    40,
    74
], [
    107,
    9
], [
    9,
    108
], [
    108,
    107
], [
    49,
    48
], [
    48,
    131
], [
    131,
    49
], [
    32,
    194
], [
    194,
    211
], [
    211,
    32
], [
    184,
    74
], [
    74,
    185
], [
    185,
    184
], [
    191,
    80
], [
    80,
    183
], [
    183,
    191
], [
    185,
    40
], [
    40,
    186
], [
    186,
    185
], [
    119,
    230
], [
    230,
    118
], [
    118,
    119
], [
    210,
    202
], [
    202,
    214
], [
    214,
    210
], [
    84,
    83
], [
    83,
    17
], [
    17,
    84
], [
    77,
    76
], [
    76,
    146
], [
    146,
    77
], [
    161,
    160
], [
    160,
    30
], [
    30,
    161
], [
    190,
    56
], [
    56,
    173
], [
    173,
    190
], [
    182,
    106
], [
    106,
    194
], [
    194,
    182
], [
    138,
    135
], [
    135,
    192
], [
    192,
    138
], [
    129,
    203
], [
    203,
    98
], [
    98,
    129
], [
    54,
    21
], [
    21,
    68
], [
    68,
    54
], [
    5,
    51
], [
    51,
    4
], [
    4,
    5
], [
    145,
    144
], [
    144,
    23
], [
    23,
    145
], [
    90,
    77
], [
    77,
    91
], [
    91,
    90
], [
    207,
    205
], [
    205,
    187
], [
    187,
    207
], [
    83,
    201
], [
    201,
    18
], [
    18,
    83
], [
    181,
    91
], [
    91,
    182
], [
    182,
    181
], [
    180,
    90
], [
    90,
    181
], [
    181,
    180
], [
    16,
    85
], [
    85,
    17
], [
    17,
    16
], [
    205,
    206
], [
    206,
    36
], [
    36,
    205
], [
    176,
    148
], [
    148,
    140
], [
    140,
    176
], [
    165,
    92
], [
    92,
    39
], [
    39,
    165
], [
    245,
    193
], [
    193,
    244
], [
    244,
    245
], [
    27,
    159
], [
    159,
    28
], [
    28,
    27
], [
    30,
    247
], [
    247,
    161
], [
    161,
    30
], [
    174,
    236
], [
    236,
    196
], [
    196,
    174
], [
    103,
    54
], [
    54,
    104
], [
    104,
    103
], [
    55,
    193
], [
    193,
    8
], [
    8,
    55
], [
    111,
    117
], [
    117,
    31
], [
    31,
    111
], [
    221,
    189
], [
    189,
    55
], [
    55,
    221
], [
    240,
    98
], [
    98,
    99
], [
    99,
    240
], [
    142,
    126
], [
    126,
    100
], [
    100,
    142
], [
    219,
    166
], [
    166,
    218
], [
    218,
    219
], [
    112,
    155
], [
    155,
    26
], [
    26,
    112
], [
    198,
    209
], [
    209,
    131
], [
    131,
    198
], [
    169,
    135
], [
    135,
    150
], [
    150,
    169
], [
    114,
    47
], [
    47,
    217
], [
    217,
    114
], [
    224,
    223
], [
    223,
    53
], [
    53,
    224
], [
    220,
    45
], [
    45,
    134
], [
    134,
    220
], [
    32,
    211
], [
    211,
    140
], [
    140,
    32
], [
    109,
    67
], [
    67,
    108
], [
    108,
    109
], [
    146,
    43
], [
    43,
    91
], [
    91,
    146
], [
    231,
    230
], [
    230,
    120
], [
    120,
    231
], [
    113,
    226
], [
    226,
    247
], [
    247,
    113
], [
    105,
    63
], [
    63,
    52
], [
    52,
    105
], [
    241,
    238
], [
    238,
    242
], [
    242,
    241
], [
    124,
    46
], [
    46,
    156
], [
    156,
    124
], [
    95,
    78
], [
    78,
    96
], [
    96,
    95
], [
    70,
    46
], [
    46,
    63
], [
    63,
    70
], [
    116,
    143
], [
    143,
    227
], [
    227,
    116
], [
    116,
    123
], [
    123,
    111
], [
    111,
    116
], [
    1,
    44
], [
    44,
    19
], [
    19,
    1
], [
    3,
    236
], [
    236,
    51
], [
    51,
    3
], [
    207,
    216
], [
    216,
    205
], [
    205,
    207
], [
    26,
    154
], [
    154,
    22
], [
    22,
    26
], [
    165,
    39
], [
    39,
    167
], [
    167,
    165
], [
    199,
    200
], [
    200,
    208
], [
    208,
    199
], [
    101,
    36
], [
    36,
    100
], [
    100,
    101
], [
    43,
    57
], [
    57,
    202
], [
    202,
    43
], [
    242,
    20
], [
    20,
    99
], [
    99,
    242
], [
    56,
    28
], [
    28,
    157
], [
    157,
    56
], [
    124,
    35
], [
    35,
    113
], [
    113,
    124
], [
    29,
    160
], [
    160,
    27
], [
    27,
    29
], [
    211,
    204
], [
    204,
    210
], [
    210,
    211
], [
    124,
    113
], [
    113,
    46
], [
    46,
    124
], [
    106,
    43
], [
    43,
    204
], [
    204,
    106
], [
    96,
    62
], [
    62,
    77
], [
    77,
    96
], [
    227,
    137
], [
    137,
    116
], [
    116,
    227
], [
    73,
    41
], [
    41,
    72
], [
    72,
    73
], [
    36,
    203
], [
    203,
    142
], [
    142,
    36
], [
    235,
    64
], [
    64,
    240
], [
    240,
    235
], [
    48,
    49
], [
    49,
    64
], [
    64,
    48
], [
    42,
    41
], [
    41,
    74
], [
    74,
    42
], [
    214,
    212
], [
    212,
    207
], [
    207,
    214
], [
    183,
    42
], [
    42,
    184
], [
    184,
    183
], [
    210,
    169
], [
    169,
    211
], [
    211,
    210
], [
    140,
    170
], [
    170,
    176
], [
    176,
    140
], [
    104,
    105
], [
    105,
    69
], [
    69,
    104
], [
    193,
    122
], [
    122,
    168
], [
    168,
    193
], [
    50,
    123
], [
    123,
    187
], [
    187,
    50
], [
    89,
    96
], [
    96,
    90
], [
    90,
    89
], [
    66,
    65
], [
    65,
    107
], [
    107,
    66
], [
    179,
    89
], [
    89,
    180
], [
    180,
    179
], [
    119,
    101
], [
    101,
    120
], [
    120,
    119
], [
    68,
    63
], [
    63,
    104
], [
    104,
    68
], [
    234,
    93
], [
    93,
    227
], [
    227,
    234
], [
    16,
    15
], [
    15,
    85
], [
    85,
    16
], [
    209,
    129
], [
    129,
    49
], [
    49,
    209
], [
    15,
    14
], [
    14,
    86
], [
    86,
    15
], [
    107,
    55
], [
    55,
    9
], [
    9,
    107
], [
    120,
    100
], [
    100,
    121
], [
    121,
    120
], [
    153,
    145
], [
    145,
    22
], [
    22,
    153
], [
    178,
    88
], [
    88,
    179
], [
    179,
    178
], [
    197,
    6
], [
    6,
    196
], [
    196,
    197
], [
    89,
    88
], [
    88,
    96
], [
    96,
    89
], [
    135,
    138
], [
    138,
    136
], [
    136,
    135
], [
    138,
    215
], [
    215,
    172
], [
    172,
    138
], [
    218,
    115
], [
    115,
    219
], [
    219,
    218
], [
    41,
    42
], [
    42,
    81
], [
    81,
    41
], [
    5,
    195
], [
    195,
    51
], [
    51,
    5
], [
    57,
    43
], [
    43,
    61
], [
    61,
    57
], [
    208,
    171
], [
    171,
    199
], [
    199,
    208
], [
    41,
    81
], [
    81,
    38
], [
    38,
    41
], [
    224,
    53
], [
    53,
    225
], [
    225,
    224
], [
    24,
    144
], [
    144,
    110
], [
    110,
    24
], [
    105,
    52
], [
    52,
    66
], [
    66,
    105
], [
    118,
    229
], [
    229,
    117
], [
    117,
    118
], [
    227,
    34
], [
    34,
    234
], [
    234,
    227
], [
    66,
    107
], [
    107,
    69
], [
    69,
    66
], [
    10,
    109
], [
    109,
    151
], [
    151,
    10
], [
    219,
    48
], [
    48,
    235
], [
    235,
    219
], [
    183,
    62
], [
    62,
    191
], [
    191,
    183
], [
    142,
    129
], [
    129,
    126
], [
    126,
    142
], [
    116,
    111
], [
    111,
    143
], [
    143,
    116
], [
    118,
    117
], [
    117,
    50
], [
    50,
    118
], [
    223,
    222
], [
    222,
    52
], [
    52,
    223
], [
    94,
    19
], [
    19,
    141
], [
    141,
    94
], [
    222,
    221
], [
    221,
    65
], [
    65,
    222
], [
    196,
    3
], [
    3,
    197
], [
    197,
    196
], [
    45,
    220
], [
    220,
    44
], [
    44,
    45
], [
    156,
    70
], [
    70,
    139
], [
    139,
    156
], [
    188,
    122
], [
    122,
    245
], [
    245,
    188
], [
    139,
    71
], [
    71,
    162
], [
    162,
    139
], [
    149,
    170
], [
    170,
    150
], [
    150,
    149
], [
    122,
    188
], [
    188,
    196
], [
    196,
    122
], [
    206,
    216
], [
    216,
    92
], [
    92,
    206
], [
    164,
    2
], [
    2,
    167
], [
    167,
    164
], [
    242,
    141
], [
    141,
    241
], [
    241,
    242
], [
    0,
    164
], [
    164,
    37
], [
    37,
    0
], [
    11,
    72
], [
    72,
    12
], [
    12,
    11
], [
    12,
    38
], [
    38,
    13
], [
    13,
    12
], [
    70,
    63
], [
    63,
    71
], [
    71,
    70
], [
    31,
    226
], [
    226,
    111
], [
    111,
    31
], [
    36,
    101
], [
    101,
    205
], [
    205,
    36
], [
    203,
    206
], [
    206,
    165
], [
    165,
    203
], [
    126,
    209
], [
    209,
    217
], [
    217,
    126
], [
    98,
    165
], [
    165,
    97
], [
    97,
    98
], [
    237,
    220
], [
    220,
    218
], [
    218,
    237
], [
    237,
    239
], [
    239,
    241
], [
    241,
    237
], [
    210,
    214
], [
    214,
    169
], [
    169,
    210
], [
    140,
    171
], [
    171,
    32
], [
    32,
    140
], [
    241,
    125
], [
    125,
    237
], [
    237,
    241
], [
    179,
    86
], [
    86,
    178
], [
    178,
    179
], [
    180,
    85
], [
    85,
    179
], [
    179,
    180
], [
    181,
    84
], [
    84,
    180
], [
    180,
    181
], [
    182,
    83
], [
    83,
    181
], [
    181,
    182
], [
    194,
    201
], [
    201,
    182
], [
    182,
    194
], [
    177,
    137
], [
    137,
    132
], [
    132,
    177
], [
    184,
    76
], [
    76,
    183
], [
    183,
    184
], [
    185,
    61
], [
    61,
    184
], [
    184,
    185
], [
    186,
    57
], [
    57,
    185
], [
    185,
    186
], [
    216,
    212
], [
    212,
    186
], [
    186,
    216
], [
    192,
    214
], [
    214,
    187
], [
    187,
    192
], [
    139,
    34
], [
    34,
    156
], [
    156,
    139
], [
    218,
    79
], [
    79,
    237
], [
    237,
    218
], [
    147,
    123
], [
    123,
    177
], [
    177,
    147
], [
    45,
    44
], [
    44,
    4
], [
    4,
    45
], [
    208,
    201
], [
    201,
    32
], [
    32,
    208
], [
    98,
    64
], [
    64,
    129
], [
    129,
    98
], [
    192,
    213
], [
    213,
    138
], [
    138,
    192
], [
    235,
    59
], [
    59,
    219
], [
    219,
    235
], [
    141,
    242
], [
    242,
    97
], [
    97,
    141
], [
    97,
    2
], [
    2,
    141
], [
    141,
    97
], [
    240,
    75
], [
    75,
    235
], [
    235,
    240
], [
    229,
    24
], [
    24,
    228
], [
    228,
    229
], [
    31,
    25
], [
    25,
    226
], [
    226,
    31
], [
    230,
    23
], [
    23,
    229
], [
    229,
    230
], [
    231,
    22
], [
    22,
    230
], [
    230,
    231
], [
    232,
    26
], [
    26,
    231
], [
    231,
    232
], [
    233,
    112
], [
    112,
    232
], [
    232,
    233
], [
    244,
    189
], [
    189,
    243
], [
    243,
    244
], [
    189,
    221
], [
    221,
    190
], [
    190,
    189
], [
    222,
    28
], [
    28,
    221
], [
    221,
    222
], [
    223,
    27
], [
    27,
    222
], [
    222,
    223
], [
    224,
    29
], [
    29,
    223
], [
    223,
    224
], [
    225,
    30
], [
    30,
    224
], [
    224,
    225
], [
    113,
    247
], [
    247,
    225
], [
    225,
    113
], [
    99,
    60
], [
    60,
    240
], [
    240,
    99
], [
    213,
    147
], [
    147,
    215
], [
    215,
    213
], [
    60,
    20
], [
    20,
    166
], [
    166,
    60
], [
    192,
    187
], [
    187,
    213
], [
    213,
    192
], [
    243,
    112
], [
    112,
    244
], [
    244,
    243
], [
    244,
    233
], [
    233,
    245
], [
    245,
    244
], [
    245,
    128
], [
    128,
    188
], [
    188,
    245
], [
    188,
    114
], [
    114,
    174
], [
    174,
    188
], [
    134,
    131
], [
    131,
    220
], [
    220,
    134
], [
    174,
    217
], [
    217,
    236
], [
    236,
    174
], [
    236,
    198
], [
    198,
    134
], [
    134,
    236
], [
    215,
    177
], [
    177,
    58
], [
    58,
    215
], [
    156,
    143
], [
    143,
    124
], [
    124,
    156
], [
    25,
    110
], [
    110,
    7
], [
    7,
    25
], [
    31,
    228
], [
    228,
    25
], [
    25,
    31
], [
    264,
    356
], [
    356,
    368
], [
    368,
    264
], [
    0,
    11
], [
    11,
    267
], [
    267,
    0
], [
    451,
    452
], [
    452,
    349
], [
    349,
    451
], [
    267,
    302
], [
    302,
    269
], [
    269,
    267
], [
    350,
    357
], [
    357,
    277
], [
    277,
    350
], [
    350,
    452
], [
    452,
    357
], [
    357,
    350
], [
    299,
    333
], [
    333,
    297
], [
    297,
    299
], [
    396,
    175
], [
    175,
    377
], [
    377,
    396
], [
    280,
    347
], [
    347,
    330
], [
    330,
    280
], [
    269,
    303
], [
    303,
    270
], [
    270,
    269
], [
    151,
    9
], [
    9,
    337
], [
    337,
    151
], [
    344,
    278
], [
    278,
    360
], [
    360,
    344
], [
    424,
    418
], [
    418,
    431
], [
    431,
    424
], [
    270,
    304
], [
    304,
    409
], [
    409,
    270
], [
    272,
    310
], [
    310,
    407
], [
    407,
    272
], [
    322,
    270
], [
    270,
    410
], [
    410,
    322
], [
    449,
    450
], [
    450,
    347
], [
    347,
    449
], [
    432,
    422
], [
    422,
    434
], [
    434,
    432
], [
    18,
    313
], [
    313,
    17
], [
    17,
    18
], [
    291,
    306
], [
    306,
    375
], [
    375,
    291
], [
    259,
    387
], [
    387,
    260
], [
    260,
    259
], [
    424,
    335
], [
    335,
    418
], [
    418,
    424
], [
    434,
    364
], [
    364,
    416
], [
    416,
    434
], [
    391,
    423
], [
    423,
    327
], [
    327,
    391
], [
    301,
    251
], [
    251,
    298
], [
    298,
    301
], [
    275,
    281
], [
    281,
    4
], [
    4,
    275
], [
    254,
    373
], [
    373,
    253
], [
    253,
    254
], [
    375,
    307
], [
    307,
    321
], [
    321,
    375
], [
    280,
    425
], [
    425,
    411
], [
    411,
    280
], [
    200,
    421
], [
    421,
    18
], [
    18,
    200
], [
    335,
    321
], [
    321,
    406
], [
    406,
    335
], [
    321,
    320
], [
    320,
    405
], [
    405,
    321
], [
    314,
    315
], [
    315,
    17
], [
    17,
    314
], [
    423,
    426
], [
    426,
    266
], [
    266,
    423
], [
    396,
    377
], [
    377,
    369
], [
    369,
    396
], [
    270,
    322
], [
    322,
    269
], [
    269,
    270
], [
    413,
    417
], [
    417,
    464
], [
    464,
    413
], [
    385,
    386
], [
    386,
    258
], [
    258,
    385
], [
    248,
    456
], [
    456,
    419
], [
    419,
    248
], [
    298,
    284
], [
    284,
    333
], [
    333,
    298
], [
    168,
    417
], [
    417,
    8
], [
    8,
    168
], [
    448,
    346
], [
    346,
    261
], [
    261,
    448
], [
    417,
    413
], [
    413,
    285
], [
    285,
    417
], [
    326,
    327
], [
    327,
    328
], [
    328,
    326
], [
    277,
    355
], [
    355,
    329
], [
    329,
    277
], [
    309,
    392
], [
    392,
    438
], [
    438,
    309
], [
    381,
    382
], [
    382,
    256
], [
    256,
    381
], [
    279,
    429
], [
    429,
    360
], [
    360,
    279
], [
    365,
    364
], [
    364,
    379
], [
    379,
    365
], [
    355,
    277
], [
    277,
    437
], [
    437,
    355
], [
    282,
    443
], [
    443,
    283
], [
    283,
    282
], [
    281,
    275
], [
    275,
    363
], [
    363,
    281
], [
    395,
    431
], [
    431,
    369
], [
    369,
    395
], [
    299,
    297
], [
    297,
    337
], [
    337,
    299
], [
    335,
    273
], [
    273,
    321
], [
    321,
    335
], [
    348,
    450
], [
    450,
    349
], [
    349,
    348
], [
    359,
    446
], [
    446,
    467
], [
    467,
    359
], [
    283,
    293
], [
    293,
    282
], [
    282,
    283
], [
    250,
    458
], [
    458,
    462
], [
    462,
    250
], [
    300,
    276
], [
    276,
    383
], [
    383,
    300
], [
    292,
    308
], [
    308,
    325
], [
    325,
    292
], [
    283,
    276
], [
    276,
    293
], [
    293,
    283
], [
    264,
    372
], [
    372,
    447
], [
    447,
    264
], [
    346,
    352
], [
    352,
    340
], [
    340,
    346
], [
    354,
    274
], [
    274,
    19
], [
    19,
    354
], [
    363,
    456
], [
    456,
    281
], [
    281,
    363
], [
    426,
    436
], [
    436,
    425
], [
    425,
    426
], [
    380,
    381
], [
    381,
    252
], [
    252,
    380
], [
    267,
    269
], [
    269,
    393
], [
    393,
    267
], [
    421,
    200
], [
    200,
    428
], [
    428,
    421
], [
    371,
    266
], [
    266,
    329
], [
    329,
    371
], [
    432,
    287
], [
    287,
    422
], [
    422,
    432
], [
    290,
    250
], [
    250,
    328
], [
    328,
    290
], [
    385,
    258
], [
    258,
    384
], [
    384,
    385
], [
    446,
    265
], [
    265,
    342
], [
    342,
    446
], [
    386,
    387
], [
    387,
    257
], [
    257,
    386
], [
    422,
    424
], [
    424,
    430
], [
    430,
    422
], [
    445,
    342
], [
    342,
    276
], [
    276,
    445
], [
    422,
    273
], [
    273,
    424
], [
    424,
    422
], [
    306,
    292
], [
    292,
    307
], [
    307,
    306
], [
    352,
    366
], [
    366,
    345
], [
    345,
    352
], [
    268,
    271
], [
    271,
    302
], [
    302,
    268
], [
    358,
    423
], [
    423,
    371
], [
    371,
    358
], [
    327,
    294
], [
    294,
    460
], [
    460,
    327
], [
    331,
    279
], [
    279,
    294
], [
    294,
    331
], [
    303,
    271
], [
    271,
    304
], [
    304,
    303
], [
    436,
    432
], [
    432,
    427
], [
    427,
    436
], [
    304,
    272
], [
    272,
    408
], [
    408,
    304
], [
    395,
    394
], [
    394,
    431
], [
    431,
    395
], [
    378,
    395
], [
    395,
    400
], [
    400,
    378
], [
    296,
    334
], [
    334,
    299
], [
    299,
    296
], [
    6,
    351
], [
    351,
    168
], [
    168,
    6
], [
    376,
    352
], [
    352,
    411
], [
    411,
    376
], [
    307,
    325
], [
    325,
    320
], [
    320,
    307
], [
    285,
    295
], [
    295,
    336
], [
    336,
    285
], [
    320,
    319
], [
    319,
    404
], [
    404,
    320
], [
    329,
    330
], [
    330,
    349
], [
    349,
    329
], [
    334,
    293
], [
    293,
    333
], [
    333,
    334
], [
    366,
    323
], [
    323,
    447
], [
    447,
    366
], [
    316,
    15
], [
    15,
    315
], [
    315,
    316
], [
    331,
    358
], [
    358,
    279
], [
    279,
    331
], [
    317,
    14
], [
    14,
    316
], [
    316,
    317
], [
    8,
    285
], [
    285,
    9
], [
    9,
    8
], [
    277,
    329
], [
    329,
    350
], [
    350,
    277
], [
    253,
    374
], [
    374,
    252
], [
    252,
    253
], [
    319,
    318
], [
    318,
    403
], [
    403,
    319
], [
    351,
    6
], [
    6,
    419
], [
    419,
    351
], [
    324,
    318
], [
    318,
    325
], [
    325,
    324
], [
    397,
    367
], [
    367,
    365
], [
    365,
    397
], [
    288,
    435
], [
    435,
    397
], [
    397,
    288
], [
    278,
    344
], [
    344,
    439
], [
    439,
    278
], [
    310,
    272
], [
    272,
    311
], [
    311,
    310
], [
    248,
    195
], [
    195,
    281
], [
    281,
    248
], [
    375,
    273
], [
    273,
    291
], [
    291,
    375
], [
    175,
    396
], [
    396,
    199
], [
    199,
    175
], [
    312,
    311
], [
    311,
    268
], [
    268,
    312
], [
    276,
    283
], [
    283,
    445
], [
    445,
    276
], [
    390,
    373
], [
    373,
    339
], [
    339,
    390
], [
    295,
    282
], [
    282,
    296
], [
    296,
    295
], [
    448,
    449
], [
    449,
    346
], [
    346,
    448
], [
    356,
    264
], [
    264,
    454
], [
    454,
    356
], [
    337,
    336
], [
    336,
    299
], [
    299,
    337
], [
    337,
    338
], [
    338,
    151
], [
    151,
    337
], [
    294,
    278
], [
    278,
    455
], [
    455,
    294
], [
    308,
    292
], [
    292,
    415
], [
    415,
    308
], [
    429,
    358
], [
    358,
    355
], [
    355,
    429
], [
    265,
    340
], [
    340,
    372
], [
    372,
    265
], [
    352,
    346
], [
    346,
    280
], [
    280,
    352
], [
    295,
    442
], [
    442,
    282
], [
    282,
    295
], [
    354,
    19
], [
    19,
    370
], [
    370,
    354
], [
    285,
    441
], [
    441,
    295
], [
    295,
    285
], [
    195,
    248
], [
    248,
    197
], [
    197,
    195
], [
    457,
    440
], [
    440,
    274
], [
    274,
    457
], [
    301,
    300
], [
    300,
    368
], [
    368,
    301
], [
    417,
    351
], [
    351,
    465
], [
    465,
    417
], [
    251,
    301
], [
    301,
    389
], [
    389,
    251
], [
    394,
    395
], [
    395,
    379
], [
    379,
    394
], [
    399,
    412
], [
    412,
    419
], [
    419,
    399
], [
    410,
    436
], [
    436,
    322
], [
    322,
    410
], [
    326,
    2
], [
    2,
    393
], [
    393,
    326
], [
    354,
    370
], [
    370,
    461
], [
    461,
    354
], [
    393,
    164
], [
    164,
    267
], [
    267,
    393
], [
    268,
    302
], [
    302,
    12
], [
    12,
    268
], [
    312,
    268
], [
    268,
    13
], [
    13,
    312
], [
    298,
    293
], [
    293,
    301
], [
    301,
    298
], [
    265,
    446
], [
    446,
    340
], [
    340,
    265
], [
    280,
    330
], [
    330,
    425
], [
    425,
    280
], [
    322,
    426
], [
    426,
    391
], [
    391,
    322
], [
    420,
    429
], [
    429,
    437
], [
    437,
    420
], [
    393,
    391
], [
    391,
    326
], [
    326,
    393
], [
    344,
    440
], [
    440,
    438
], [
    438,
    344
], [
    458,
    459
], [
    459,
    461
], [
    461,
    458
], [
    364,
    434
], [
    434,
    394
], [
    394,
    364
], [
    428,
    396
], [
    396,
    262
], [
    262,
    428
], [
    274,
    354
], [
    354,
    457
], [
    457,
    274
], [
    317,
    316
], [
    316,
    402
], [
    402,
    317
], [
    316,
    315
], [
    315,
    403
], [
    403,
    316
], [
    315,
    314
], [
    314,
    404
], [
    404,
    315
], [
    314,
    313
], [
    313,
    405
], [
    405,
    314
], [
    313,
    421
], [
    421,
    406
], [
    406,
    313
], [
    323,
    366
], [
    366,
    361
], [
    361,
    323
], [
    292,
    306
], [
    306,
    407
], [
    407,
    292
], [
    306,
    291
], [
    291,
    408
], [
    408,
    306
], [
    291,
    287
], [
    287,
    409
], [
    409,
    291
], [
    287,
    432
], [
    432,
    410
], [
    410,
    287
], [
    427,
    434
], [
    434,
    411
], [
    411,
    427
], [
    372,
    264
], [
    264,
    383
], [
    383,
    372
], [
    459,
    309
], [
    309,
    457
], [
    457,
    459
], [
    366,
    352
], [
    352,
    401
], [
    401,
    366
], [
    1,
    274
], [
    274,
    4
], [
    4,
    1
], [
    418,
    421
], [
    421,
    262
], [
    262,
    418
], [
    331,
    294
], [
    294,
    358
], [
    358,
    331
], [
    435,
    433
], [
    433,
    367
], [
    367,
    435
], [
    392,
    289
], [
    289,
    439
], [
    439,
    392
], [
    328,
    462
], [
    462,
    326
], [
    326,
    328
], [
    94,
    2
], [
    2,
    370
], [
    370,
    94
], [
    289,
    305
], [
    305,
    455
], [
    455,
    289
], [
    339,
    254
], [
    254,
    448
], [
    448,
    339
], [
    359,
    255
], [
    255,
    446
], [
    446,
    359
], [
    254,
    253
], [
    253,
    449
], [
    449,
    254
], [
    253,
    252
], [
    252,
    450
], [
    450,
    253
], [
    252,
    256
], [
    256,
    451
], [
    451,
    252
], [
    256,
    341
], [
    341,
    452
], [
    452,
    256
], [
    414,
    413
], [
    413,
    463
], [
    463,
    414
], [
    286,
    441
], [
    441,
    414
], [
    414,
    286
], [
    286,
    258
], [
    258,
    441
], [
    441,
    286
], [
    258,
    257
], [
    257,
    442
], [
    442,
    258
], [
    257,
    259
], [
    259,
    443
], [
    443,
    257
], [
    259,
    260
], [
    260,
    444
], [
    444,
    259
], [
    260,
    467
], [
    467,
    445
], [
    445,
    260
], [
    309,
    459
], [
    459,
    250
], [
    250,
    309
], [
    305,
    289
], [
    289,
    290
], [
    290,
    305
], [
    305,
    290
], [
    290,
    460
], [
    460,
    305
], [
    401,
    376
], [
    376,
    435
], [
    435,
    401
], [
    309,
    250
], [
    250,
    392
], [
    392,
    309
], [
    376,
    411
], [
    411,
    433
], [
    433,
    376
], [
    453,
    341
], [
    341,
    464
], [
    464,
    453
], [
    357,
    453
], [
    453,
    465
], [
    465,
    357
], [
    343,
    357
], [
    357,
    412
], [
    412,
    343
], [
    437,
    343
], [
    343,
    399
], [
    399,
    437
], [
    344,
    360
], [
    360,
    440
], [
    440,
    344
], [
    420,
    437
], [
    437,
    456
], [
    456,
    420
], [
    360,
    420
], [
    420,
    363
], [
    363,
    360
], [
    361,
    401
], [
    401,
    288
], [
    288,
    361
], [
    265,
    372
], [
    372,
    353
], [
    353,
    265
], [
    390,
    339
], [
    339,
    249
], [
    249,
    390
], [
    339,
    448
], [
    448,
    255
], [
    255,
    339
]);
function $b34bd66f0aa7fdf3$var$Fa(t) {
    t.j = {
        faceLandmarks: [],
        faceBlendshapes: [],
        facialTransformationMatrixes: []
    };
}
var $b34bd66f0aa7fdf3$export$9a141f0109a4ba18 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !1), this.j = {
            faceLandmarks: [],
            faceBlendshapes: [],
            facialTransformationMatrixes: []
        }, this.outputFacialTransformationMatrixes = this.outputFaceBlendshapes = !1, this.h = new $b34bd66f0aa7fdf3$var$li, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t), this.v = new $b34bd66f0aa7fdf3$var$ci, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 3, this.v), this.s = new $b34bd66f0aa7fdf3$var$ni, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 2, this.s), $b34bd66f0aa7fdf3$var$pn(this.s, 4, 1), $b34bd66f0aa7fdf3$var$gn(this.s, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.v, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.h, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return "numFaces" in t && $b34bd66f0aa7fdf3$var$pn(this.s, 4, t.numFaces ?? 1), "minFaceDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.s, 2, t.minFaceDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 4, t.minTrackingConfidence ?? .5), "minFacePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.v, 2, t.minFacePresenceConfidence ?? .5), "outputFaceBlendshapes" in t && (this.outputFaceBlendshapes = !!t.outputFaceBlendshapes), "outputFacialTransformationMatrixes" in t && (this.outputFacialTransformationMatrixes = !!t.outputFacialTransformationMatrixes), this.l(t);
    }
    F(t, e) {
        return $b34bd66f0aa7fdf3$var$Fa(this), $b34bd66f0aa7fdf3$var$da(this, t, e), this.j;
    }
    G(t, e, n) {
        return $b34bd66f0aa7fdf3$var$Fa(this), $b34bd66f0aa7fdf3$var$pa(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "face_landmarks");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$di, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.face_landmarker.FaceLandmarkerGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "NORM_LANDMARKS:face_landmarks"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoVectorListener("face_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Ms(e), this.j.faceLandmarks.push($b34bd66f0aa7fdf3$var$Qi(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("face_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.outputFaceBlendshapes && ($b34bd66f0aa7fdf3$var$rs(t, "blendshapes"), $b34bd66f0aa7fdf3$var$$r(n, "BLENDSHAPES:blendshapes"), this.g.attachProtoVectorListener("blendshapes", (t, e)=>{
            if (this.outputFaceBlendshapes) for (const e of t)t = $b34bd66f0aa7fdf3$var$fs(e), this.j.faceBlendshapes.push($b34bd66f0aa7fdf3$var$Ji(t.g() ?? []));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("blendshapes", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        })), this.outputFacialTransformationMatrixes && ($b34bd66f0aa7fdf3$var$rs(t, "face_geometry"), $b34bd66f0aa7fdf3$var$$r(n, "FACE_GEOMETRY:face_geometry"), this.g.attachProtoVectorListener("face_geometry", (t, e)=>{
            if (this.outputFacialTransformationMatrixes) for (const e of t)(t = $b34bd66f0aa7fdf3$var$en($b34bd66f0aa7fdf3$var$ai(e), $b34bd66f0aa7fdf3$var$Ps, 2)) && this.j.facialTransformationMatrixes.push({
                rows: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(t, 1)) ?? 0,
                columns: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(t, 2)) ?? 0,
                data: $b34bd66f0aa7fdf3$var$He(t, 3, $b34bd66f0aa7fdf3$var$ae) ?? []
            });
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("face_geometry", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.G, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.detect = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.F, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.setOptions = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.o, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, e);
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LIPS = $b34bd66f0aa7fdf3$var$va, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYE = $b34bd66f0aa7fdf3$var$_a, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYEBROW = $b34bd66f0aa7fdf3$var$wa, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_IRIS = $b34bd66f0aa7fdf3$var$Aa, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYE = $b34bd66f0aa7fdf3$var$ba, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYEBROW = $b34bd66f0aa7fdf3$var$Ea, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_IRIS = $b34bd66f0aa7fdf3$var$Ta, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_FACE_OVAL = $b34bd66f0aa7fdf3$var$ka, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_CONTOURS = $b34bd66f0aa7fdf3$var$xa, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_TESSELATION = $b34bd66f0aa7fdf3$var$La;
var $b34bd66f0aa7fdf3$export$f84ed81869a621dd = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !0), this.j = new $b34bd66f0aa7fdf3$var$pi, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.j, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.j, 0, 1, t);
    }
    o(t) {
        return super.l(t);
    }
    Da(t, e, n) {
        const r = "function" != typeof e ? e : {};
        if (this.h = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$da(this, t, r ?? {}), !this.h) return this.s;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "stylized_image");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$gi, this.j);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.face_stylizer.FaceStylizerGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "STYLIZED_IMAGE:stylized_image"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.S("stylized_image", (t, e)=>{
            var n = !this.h, r = t.data, s = t.width;
            const i = s * (t = t.height);
            if (r instanceof Uint8Array) {
                if (r.length === 3 * i) {
                    const e = new Uint8ClampedArray(4 * i);
                    for(let t = 0; t < i; ++t)e[4 * t] = r[3 * t], e[4 * t + 1] = r[3 * t + 1], e[4 * t + 2] = r[3 * t + 2], e[4 * t + 3] = 255;
                    r = new ImageData(e, s, t);
                } else {
                    if (r.length !== 4 * i) throw Error("Unsupported channel count: " + r.length / i);
                    r = new ImageData(new Uint8ClampedArray(r.buffer, r.byteOffset, r.length), s, t);
                }
            } else if (!(r instanceof WebGLTexture)) throw Error(`Unsupported format: ${r.constructor.name}`);
            s = new $b34bd66f0aa7fdf3$export$7c9479202f61c045([
                r
            ], !1, !1, this.g.i.canvas, this.O, s, t), this.s = n = n ? s.clone() : s, this.h && this.h(n), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("stylized_image", (t)=>{
            this.s = null, this.h && this.h(null), $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.stylize = $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.Da, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.setOptions = $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.o, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, e);
};
var $b34bd66f0aa7fdf3$var$Ma = $b34bd66f0aa7fdf3$var$aa([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    4
], [
    0,
    5
], [
    5,
    6
], [
    6,
    7
], [
    7,
    8
], [
    5,
    9
], [
    9,
    10
], [
    10,
    11
], [
    11,
    12
], [
    9,
    13
], [
    13,
    14
], [
    14,
    15
], [
    15,
    16
], [
    13,
    17
], [
    0,
    17
], [
    17,
    18
], [
    18,
    19
], [
    19,
    20
]);
function $b34bd66f0aa7fdf3$var$Pa(t) {
    t.gestures = [], t.landmarks = [], t.worldLandmarks = [], t.handedness = [];
}
function $b34bd66f0aa7fdf3$var$Ra(t) {
    return 0 === t.gestures.length ? {
        gestures: [],
        landmarks: [],
        worldLandmarks: [],
        handedness: [],
        handednesses: []
    } : {
        gestures: t.gestures,
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handedness: t.handedness,
        handednesses: t.handedness
    };
}
function $b34bd66f0aa7fdf3$var$Ca(t, e = !0) {
    const n = [];
    for (const s of t){
        var r = $b34bd66f0aa7fdf3$var$fs(s);
        t = [];
        for (const n of r.g())r = e && null != $b34bd66f0aa7fdf3$var$hn(n, 1) ? $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(n, 1)) : -1, t.push({
            score: $b34bd66f0aa7fdf3$var$fn(n, 2) ?? 0,
            index: r,
            categoryName: $b34bd66f0aa7fdf3$var$un(n, 3) ?? "" ?? "",
            displayName: $b34bd66f0aa7fdf3$var$un(n, 4) ?? "" ?? ""
        });
        n.push(t);
    }
    return n;
}
var $b34bd66f0aa7fdf3$export$e1bdb836a8013647 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !1), this.gestures = [], this.landmarks = [], this.worldLandmarks = [], this.handedness = [], this.v = new $b34bd66f0aa7fdf3$var$Li, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.v, 0, 1, t), this.C = new $b34bd66f0aa7fdf3$var$ki, $b34bd66f0aa7fdf3$var$sn(this.v, 0, 2, this.C), this.s = new $b34bd66f0aa7fdf3$var$Ei, $b34bd66f0aa7fdf3$var$sn(this.C, 0, 3, this.s), this.h = new $b34bd66f0aa7fdf3$var$Ai, $b34bd66f0aa7fdf3$var$sn(this.C, 0, 2, this.h), this.j = new $b34bd66f0aa7fdf3$var$_i, $b34bd66f0aa7fdf3$var$sn(this.v, 0, 3, this.j), $b34bd66f0aa7fdf3$var$gn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.C, 4, .5), $b34bd66f0aa7fdf3$var$gn(this.s, 2, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.v, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.v, 0, 1, t);
    }
    o(t) {
        if ($b34bd66f0aa7fdf3$var$pn(this.h, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.C, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.s, 2, t.minHandPresenceConfidence ?? .5), t.cannedGesturesClassifierOptions) {
            var e = new $b34bd66f0aa7fdf3$var$mi, n = $b34bd66f0aa7fdf3$var$Ki(t.cannedGesturesClassifierOptions, $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$mi, 3)?.h());
            $b34bd66f0aa7fdf3$var$sn(e, 0, 2, n), $b34bd66f0aa7fdf3$var$sn(this.j, 0, 3, e);
        } else void 0 === t.cannedGesturesClassifierOptions && $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$mi, 3)?.g();
        return t.customGesturesClassifierOptions ? ($b34bd66f0aa7fdf3$var$sn(e = new $b34bd66f0aa7fdf3$var$mi, 0, 2, n = $b34bd66f0aa7fdf3$var$Ki(t.customGesturesClassifierOptions, $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$mi, 4)?.h())), $b34bd66f0aa7fdf3$var$sn(this.j, 0, 4, e)) : void 0 === t.customGesturesClassifierOptions && $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$mi, 4)?.g(), this.l(t);
    }
    ya(t, e) {
        return $b34bd66f0aa7fdf3$var$Pa(this), $b34bd66f0aa7fdf3$var$da(this, t, e), $b34bd66f0aa7fdf3$var$Ra(this);
    }
    za(t, e, n) {
        return $b34bd66f0aa7fdf3$var$Pa(this), $b34bd66f0aa7fdf3$var$pa(this, t, n, e), $b34bd66f0aa7fdf3$var$Ra(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "hand_gestures"), $b34bd66f0aa7fdf3$var$rs(t, "hand_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "world_hand_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "handedness");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Oi, this.v);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.gesture_recognizer.GestureRecognizerGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "HAND_GESTURES:hand_gestures"), $b34bd66f0aa7fdf3$var$$r(n, "LANDMARKS:hand_landmarks"), $b34bd66f0aa7fdf3$var$$r(n, "WORLD_LANDMARKS:world_hand_landmarks"), $b34bd66f0aa7fdf3$var$$r(n, "HANDEDNESS:handedness"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$Ms(e);
                const n = [];
                for (const e of $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$Fs, 1))n.push({
                    x: $b34bd66f0aa7fdf3$var$fn(e, 1) ?? 0,
                    y: $b34bd66f0aa7fdf3$var$fn(e, 2) ?? 0,
                    z: $b34bd66f0aa7fdf3$var$fn(e, 3) ?? 0
                });
                this.landmarks.push(n);
            }
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$Ls(e);
                const n = [];
                for (const e of $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$Ts, 1))n.push({
                    x: $b34bd66f0aa7fdf3$var$fn(e, 1) ?? 0,
                    y: $b34bd66f0aa7fdf3$var$fn(e, 2) ?? 0,
                    z: $b34bd66f0aa7fdf3$var$fn(e, 3) ?? 0
                });
                this.worldLandmarks.push(n);
            }
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("hand_gestures", (t, e)=>{
            this.gestures.push(...$b34bd66f0aa7fdf3$var$Ca(t, !1)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("hand_gestures", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            this.handedness.push(...$b34bd66f0aa7fdf3$var$Ca(t)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
function $b34bd66f0aa7fdf3$var$Da(t) {
    return {
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handednesses: t.handedness,
        handedness: t.handedness
    };
}
$b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.recognizeForVideo = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.za, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.recognize = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.ya, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.setOptions = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.o, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, e);
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.HAND_CONNECTIONS = $b34bd66f0aa7fdf3$var$Ma;
var $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.handedness = [], this.j = new $b34bd66f0aa7fdf3$var$ki, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.j, 0, 1, t), this.s = new $b34bd66f0aa7fdf3$var$Ei, $b34bd66f0aa7fdf3$var$sn(this.j, 0, 3, this.s), this.h = new $b34bd66f0aa7fdf3$var$Ai, $b34bd66f0aa7fdf3$var$sn(this.j, 0, 2, this.h), $b34bd66f0aa7fdf3$var$pn(this.h, 3, 1), $b34bd66f0aa7fdf3$var$gn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.s, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.j, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.j, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.j, 0, 1, t);
    }
    o(t) {
        return "numHands" in t && $b34bd66f0aa7fdf3$var$pn(this.h, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.j, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.s, 2, t.minHandPresenceConfidence ?? .5), this.l(t);
    }
    F(t, e) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$da(this, t, e), $b34bd66f0aa7fdf3$var$Da(this);
    }
    G(t, e, n) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$pa(this, t, n, e), $b34bd66f0aa7fdf3$var$Da(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "hand_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "world_hand_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "handedness");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Si, this.j);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.hand_landmarker.HandLandmarkerGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "LANDMARKS:hand_landmarks"), $b34bd66f0aa7fdf3$var$$r(n, "WORLD_LANDMARKS:world_hand_landmarks"), $b34bd66f0aa7fdf3$var$$r(n, "HANDEDNESS:handedness"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Ms(e), this.landmarks.push($b34bd66f0aa7fdf3$var$Qi(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Ls(e), this.worldLandmarks.push($b34bd66f0aa7fdf3$var$to(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            var n = this.handedness, r = n.push;
            const s = [];
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$fs(e);
                const n = [];
                for (const e of t.g())n.push({
                    score: $b34bd66f0aa7fdf3$var$fn(e, 2) ?? 0,
                    index: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(e, 1)) ?? -1,
                    categoryName: $b34bd66f0aa7fdf3$var$un(e, 3) ?? "" ?? "",
                    displayName: $b34bd66f0aa7fdf3$var$un(e, 4) ?? "" ?? ""
                });
                s.push(n);
            }
            r.call(n, ...s), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.G, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.detect = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.F, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.setOptions = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.o, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, e);
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.HAND_CONNECTIONS = $b34bd66f0aa7fdf3$var$Ma;
var $b34bd66f0aa7fdf3$export$af0b5c7f41d90214 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "input_image", "norm_rect", !0), this.j = {
            classifications: []
        }, this.h = new $b34bd66f0aa7fdf3$var$Mi, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        var e = $b34bd66f0aa7fdf3$var$Ki(t, $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$Hs, 2));
        return $b34bd66f0aa7fdf3$var$sn(this.h, 0, 2, e), this.l(t);
    }
    ia(t, e) {
        return this.j = {
            classifications: []
        }, $b34bd66f0aa7fdf3$var$da(this, t, e), this.j;
    }
    ja(t, e, n) {
        return this.j = {
            classifications: []
        }, $b34bd66f0aa7fdf3$var$pa(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "input_image"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "classifications");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Pi, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.image_classifier.ImageClassifierGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:input_image"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "CLASSIFICATIONS:classifications"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoListener("classifications", (t, e)=>{
            this.j = function(t) {
                const e = {
                    classifications: $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$Is, 1).map((t)=>$b34bd66f0aa7fdf3$var$Ji($b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$us, 4)?.g() ?? [], $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(t, 2)), $b34bd66f0aa7fdf3$var$un(t, 3) ?? ""))
                };
                return null != $b34bd66f0aa7fdf3$var$cn(t) && (e.timestampMs = $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$cn(t))), e;
            }($b34bd66f0aa7fdf3$var$Us(t)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("classifications", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.classifyForVideo = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.ja, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.classify = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.ia, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.setOptions = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.o, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, e);
};
var $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !0), this.h = new $b34bd66f0aa7fdf3$var$Ri, this.embeddings = {
            embeddings: []
        }, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        var e = this.h, n = $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$$s, 2);
        return n = n ? n.clone() : new $b34bd66f0aa7fdf3$var$$s, void 0 !== t.l2Normalize ? $b34bd66f0aa7fdf3$var$dn(n, 1, t.l2Normalize) : "l2Normalize" in t && $b34bd66f0aa7fdf3$var$je(n, 1), void 0 !== t.quantize ? $b34bd66f0aa7fdf3$var$dn(n, 2, t.quantize) : "quantize" in t && $b34bd66f0aa7fdf3$var$je(n, 2), $b34bd66f0aa7fdf3$var$sn(e, 0, 2, n), this.l(t);
    }
    na(t, e) {
        return $b34bd66f0aa7fdf3$var$da(this, t, e), this.embeddings;
    }
    oa(t, e, n) {
        return $b34bd66f0aa7fdf3$var$pa(this, t, n, e), this.embeddings;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "embeddings_out");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Ci, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.image_embedder.ImageEmbedderGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "EMBEDDINGS:embeddings_out"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoListener("embeddings_out", (t, e)=>{
            t = $b34bd66f0aa7fdf3$var$Xs(t), this.embeddings = function(t) {
                return {
                    embeddings: $b34bd66f0aa7fdf3$var$rn(t, $b34bd66f0aa7fdf3$var$js, 1).map((t)=>{
                        const e = {
                            headIndex: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$hn(t, 3)) ?? -1,
                            headName: $b34bd66f0aa7fdf3$var$un(t, 4) ?? "" ?? ""
                        };
                        if (void 0 !== $b34bd66f0aa7fdf3$var$tn(t, $b34bd66f0aa7fdf3$var$Ns, $b34bd66f0aa7fdf3$var$Je(t, 1))) t = $b34bd66f0aa7fdf3$var$He(t = $b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$Ns, $b34bd66f0aa7fdf3$var$Je(t, 1)), 1, $b34bd66f0aa7fdf3$var$ae), e.floatEmbedding = t;
                        else {
                            const n = new Uint8Array(0);
                            e.quantizedEmbedding = $b34bd66f0aa7fdf3$var$en(t, $b34bd66f0aa7fdf3$var$Gs, $b34bd66f0aa7fdf3$var$Je(t, 2))?.fa()?.ha() ?? n;
                        }
                        return e;
                    }),
                    timestampMs: $b34bd66f0aa7fdf3$var$ln($b34bd66f0aa7fdf3$var$cn(t))
                };
            }(t), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("embeddings_out", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.cosineSimilarity = function(t, e) {
    if (t.floatEmbedding && e.floatEmbedding) t = $b34bd66f0aa7fdf3$var$no(t.floatEmbedding, e.floatEmbedding);
    else {
        if (!t.quantizedEmbedding || !e.quantizedEmbedding) throw Error("Cannot compute cosine similarity between quantized and float embeddings.");
        t = $b34bd66f0aa7fdf3$var$no($b34bd66f0aa7fdf3$var$eo(t.quantizedEmbedding), $b34bd66f0aa7fdf3$var$eo(e.quantizedEmbedding));
    }
    return t;
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.embedForVideo = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.oa, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.embed = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.na, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.setOptions = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.o, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, e);
};
var $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe = class {
    constructor(t, e, n){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = n;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
function $b34bd66f0aa7fdf3$var$ja(t) {
    t.categoryMask = void 0, t.confidenceMasks = void 0, t.qualityScores = void 0;
}
function $b34bd66f0aa7fdf3$var$Va(t) {
    try {
        const e = new $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe(t.confidenceMasks, t.categoryMask, t.qualityScores);
        if (!t.j) return e;
        t.j(e);
    } finally{
        $b34bd66f0aa7fdf3$var$bo(t);
    }
}
$b34bd66f0aa7fdf3$export$23c2ae92dccdcffe.prototype.close = $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe.prototype.close;
var $b34bd66f0aa7fdf3$export$a6aab52785405573 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !1), this.s = [], this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $b34bd66f0aa7fdf3$var$Ni, this.v = new $b34bd66f0aa7fdf3$var$Ii, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 3, this.v), t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$je(this.h, 2, $b34bd66f0aa7fdf3$var$de(t.displayNamesLocale)) : "displayNamesLocale" in t && $b34bd66f0aa7fdf3$var$je(this.h, 2), "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.l(t);
    }
    P() {
        !function(t) {
            const e = $b34bd66f0aa7fdf3$var$rn(t.W(), $b34bd66f0aa7fdf3$var$qr, 1).filter((t)=>($b34bd66f0aa7fdf3$var$un(t, 1) ?? "").includes("mediapipe.tasks.TensorsToSegmentationCalculator"));
            if (t.s = [], 1 < e.length) throw Error("The graph has more than one mediapipe.tasks.TensorsToSegmentationCalculator.");
            1 === e.length && ($b34bd66f0aa7fdf3$var$en(e[0], $b34bd66f0aa7fdf3$var$Ur, 7)?.l()?.g() ?? new Map).forEach((e, n)=>{
                t.s[Number(n)] = $b34bd66f0aa7fdf3$var$un(e, 1) ?? "";
            });
        }(this);
    }
    X(t, e, n) {
        const r = "function" != typeof e ? e : {};
        return this.j = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$ja(this), $b34bd66f0aa7fdf3$var$da(this, t, r), $b34bd66f0aa7fdf3$var$Va(this);
    }
    Ca(t, e, n, r) {
        const s = "function" != typeof n ? n : {};
        return this.j = "function" == typeof n ? n : r, $b34bd66f0aa7fdf3$var$ja(this), $b34bd66f0aa7fdf3$var$pa(this, t, s, e), $b34bd66f0aa7fdf3$var$Va(this);
    }
    ta() {
        return this.s;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Gi, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.image_segmenter.ImageSegmenterGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), $b34bd66f0aa7fdf3$var$wo(this, t), this.outputConfidenceMasks && ($b34bd66f0aa7fdf3$var$rs(t, "confidence_masks"), $b34bd66f0aa7fdf3$var$$r(n, "CONFIDENCE_MASKS:confidence_masks"), $b34bd66f0aa7fdf3$var$Ao(this, "confidence_masks"), this.g.T("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$b34bd66f0aa7fdf3$var$ga(this, t, !this.j)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $b34bd66f0aa7fdf3$var$_o(this, t);
        })), this.outputCategoryMask && ($b34bd66f0aa7fdf3$var$rs(t, "category_mask"), $b34bd66f0aa7fdf3$var$$r(n, "CATEGORY_MASK:category_mask"), $b34bd66f0aa7fdf3$var$Ao(this, "category_mask"), this.g.S("category_mask", (t, e)=>{
            this.categoryMask = $b34bd66f0aa7fdf3$var$ga(this, t, !this.j), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$_o(this, t);
        })), $b34bd66f0aa7fdf3$var$rs(t, "quality_scores"), $b34bd66f0aa7fdf3$var$$r(n, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.getLabels = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.ta, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.segmentForVideo = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.Ca, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.segment = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.X, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.setOptions = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.o, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$a6aab52785405573, t, e);
};
var $b34bd66f0aa7fdf3$export$100d0e384e102553 = class {
    constructor(t, e, n){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = n;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
$b34bd66f0aa7fdf3$export$100d0e384e102553.prototype.close = $b34bd66f0aa7fdf3$export$100d0e384e102553.prototype.close;
var $b34bd66f0aa7fdf3$var$Xa = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ha = [
    0,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$Ya = [
    0,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$$a = [
    0,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr
], $b34bd66f0aa7fdf3$var$qa = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$$a
], $b34bd66f0aa7fdf3$var$Ka = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$qa,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha
], $b34bd66f0aa7fdf3$var$Ja = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$$a,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha
], $b34bd66f0aa7fdf3$var$Za = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$$a,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar
], $b34bd66f0aa7fdf3$var$Qa = [
    0,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Za,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha
], $b34bd66f0aa7fdf3$var$th = [
    0,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha
], $b34bd66f0aa7fdf3$var$eh = [
    0,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$ur,
    $b34bd66f0aa7fdf3$var$Ar
], $b34bd66f0aa7fdf3$var$nh = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$rh = [
    0,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$sh = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$sh.B = [
    1
];
var $b34bd66f0aa7fdf3$var$ih = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$oh = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    14,
    15
], $b34bd66f0aa7fdf3$var$ah = [
    0,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$$a,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$Ja,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$qa,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$Ka,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$rh,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$eh,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$Ya,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    [
        0,
        $b34bd66f0aa7fdf3$var$pr,
        $b34bd66f0aa7fdf3$var$tr,
        $b34bd66f0aa7fdf3$var$tr,
        $b34bd66f0aa7fdf3$var$tr,
        $b34bd66f0aa7fdf3$var$ur,
        $b34bd66f0aa7fdf3$var$ar,
        $b34bd66f0aa7fdf3$var$ur,
        $b34bd66f0aa7fdf3$var$ur,
        $b34bd66f0aa7fdf3$var$tr,
        3,
        $b34bd66f0aa7fdf3$var$mr,
        $b34bd66f0aa7fdf3$var$Ha
    ],
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$Za,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$Qa,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$tr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$Ha,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$vr,
    $b34bd66f0aa7fdf3$var$th,
    $b34bd66f0aa7fdf3$var$oh,
    $b34bd66f0aa7fdf3$var$vr,
    [
        0,
        $b34bd66f0aa7fdf3$var$yr,
        $b34bd66f0aa7fdf3$var$rh
    ],
    $b34bd66f0aa7fdf3$var$oh
], $b34bd66f0aa7fdf3$var$hh = [
    0,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ar,
    $b34bd66f0aa7fdf3$var$ur
], $b34bd66f0aa7fdf3$var$ch = class extends $b34bd66f0aa7fdf3$var$vn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$ch.B = [
    1
], $b34bd66f0aa7fdf3$var$ch.prototype.g = $b34bd66f0aa7fdf3$var$xr([
    0,
    $b34bd66f0aa7fdf3$var$yr,
    $b34bd66f0aa7fdf3$var$ah,
    $b34bd66f0aa7fdf3$var$pr,
    $b34bd66f0aa7fdf3$var$mr,
    $b34bd66f0aa7fdf3$var$hh
]);
var $b34bd66f0aa7fdf3$export$1911ac08eb46d346 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect_in", !1), this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $b34bd66f0aa7fdf3$var$Ni, this.v = new $b34bd66f0aa7fdf3$var$Ii, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 3, this.v), t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.l(t);
    }
    X(t, e, n, r) {
        const s = "function" != typeof n ? n : {};
        this.j = "function" == typeof n ? n : r, this.qualityScores = this.categoryMask = this.confidenceMasks = void 0, n = this.I + 1, r = new $b34bd66f0aa7fdf3$var$ch;
        const i = new $b34bd66f0aa7fdf3$var$ih;
        var o = new $b34bd66f0aa7fdf3$var$Xa;
        if ($b34bd66f0aa7fdf3$var$pn(o, 1, 255), $b34bd66f0aa7fdf3$var$sn(i, 0, 12, o), e.keypoint && e.scribble) throw Error("Cannot provide both keypoint and scribble.");
        if (e.keypoint) {
            var a = new $b34bd66f0aa7fdf3$var$nh;
            $b34bd66f0aa7fdf3$var$dn(a, 3, !0), $b34bd66f0aa7fdf3$var$gn(a, 1, e.keypoint.x), $b34bd66f0aa7fdf3$var$gn(a, 2, e.keypoint.y), $b34bd66f0aa7fdf3$var$on(i, 5, $b34bd66f0aa7fdf3$var$oh, a);
        } else {
            if (!e.scribble) throw Error("Must provide either a keypoint or a scribble.");
            for (a of (o = new $b34bd66f0aa7fdf3$var$sh, e.scribble))$b34bd66f0aa7fdf3$var$dn(e = new $b34bd66f0aa7fdf3$var$nh, 3, !0), $b34bd66f0aa7fdf3$var$gn(e, 1, a.x), $b34bd66f0aa7fdf3$var$gn(e, 2, a.y), $b34bd66f0aa7fdf3$var$an(o, $b34bd66f0aa7fdf3$var$nh, e);
            $b34bd66f0aa7fdf3$var$on(i, 15, $b34bd66f0aa7fdf3$var$oh, o);
        }
        $b34bd66f0aa7fdf3$var$an(r, $b34bd66f0aa7fdf3$var$ih, i), this.g.addProtoToStream(r.g(), "drishti.RenderData", "roi_in", n), $b34bd66f0aa7fdf3$var$da(this, t, s);
        t: {
            try {
                const t = new $b34bd66f0aa7fdf3$export$100d0e384e102553(this.confidenceMasks, this.categoryMask, this.qualityScores);
                if (!this.j) {
                    var h = t;
                    break t;
                }
                this.j(t);
            } finally{
                $b34bd66f0aa7fdf3$var$bo(this);
            }
            h = void 0;
        }
        return h;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "roi_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect_in");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Gi, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.interactive_segmenter.InteractiveSegmenterGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "ROI:roi_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect_in"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), $b34bd66f0aa7fdf3$var$wo(this, t), this.outputConfidenceMasks && ($b34bd66f0aa7fdf3$var$rs(t, "confidence_masks"), $b34bd66f0aa7fdf3$var$$r(n, "CONFIDENCE_MASKS:confidence_masks"), $b34bd66f0aa7fdf3$var$Ao(this, "confidence_masks"), this.g.T("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$b34bd66f0aa7fdf3$var$ga(this, t, !this.j)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $b34bd66f0aa7fdf3$var$_o(this, t);
        })), this.outputCategoryMask && ($b34bd66f0aa7fdf3$var$rs(t, "category_mask"), $b34bd66f0aa7fdf3$var$$r(n, "CATEGORY_MASK:category_mask"), $b34bd66f0aa7fdf3$var$Ao(this, "category_mask"), this.g.S("category_mask", (t, e)=>{
            this.categoryMask = $b34bd66f0aa7fdf3$var$ga(this, t, !this.j), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$_o(this, t);
        })), $b34bd66f0aa7fdf3$var$rs(t, "quality_scores"), $b34bd66f0aa7fdf3$var$$r(n, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.segment = $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.X, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.setOptions = $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.o, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, e);
};
var $b34bd66f0aa7fdf3$export$f03f381c3c95b342 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "input_frame_gpu", "norm_rect", !1), this.j = {
            detections: []
        }, this.h = new $b34bd66f0aa7fdf3$var$ji, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$je(this.h, 2, $b34bd66f0aa7fdf3$var$de(t.displayNamesLocale)) : "displayNamesLocale" in t && $b34bd66f0aa7fdf3$var$je(this.h, 2), void 0 !== t.maxResults ? $b34bd66f0aa7fdf3$var$pn(this.h, 3, t.maxResults) : "maxResults" in t && $b34bd66f0aa7fdf3$var$je(this.h, 3), void 0 !== t.scoreThreshold ? $b34bd66f0aa7fdf3$var$gn(this.h, 4, t.scoreThreshold) : "scoreThreshold" in t && $b34bd66f0aa7fdf3$var$je(this.h, 4), void 0 !== t.categoryAllowlist ? $b34bd66f0aa7fdf3$var$Ke(this.h, 5, t.categoryAllowlist) : "categoryAllowlist" in t && $b34bd66f0aa7fdf3$var$je(this.h, 5), void 0 !== t.categoryDenylist ? $b34bd66f0aa7fdf3$var$Ke(this.h, 6, t.categoryDenylist) : "categoryDenylist" in t && $b34bd66f0aa7fdf3$var$je(this.h, 6), this.l(t);
    }
    F(t, e) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$da(this, t, e), this.j;
    }
    G(t, e, n) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$pa(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "input_frame_gpu"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "detections");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$Vi, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.ObjectDetectorGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:input_frame_gpu"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "DETECTIONS:detections"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Es(e), this.j.detections.push($b34bd66f0aa7fdf3$var$Zi(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $b34bd66f0aa7fdf3$var$_o(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.G, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.detect = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.F, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.setOptions = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.o, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromModelPath = async function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, e);
};
function $b34bd66f0aa7fdf3$var$fh(t) {
    t.landmarks = [], t.worldLandmarks = [], t.v = void 0;
}
function $b34bd66f0aa7fdf3$var$dh(t) {
    try {
        const e = new class {
            constructor(t, e, n){
                this.landmarks = t, this.worldLandmarks = e, this.g = n;
            }
            close() {
                this.g?.forEach((t)=>{
                    t.close();
                });
            }
        }(t.landmarks, t.worldLandmarks, t.v);
        if (!t.s) return e;
        t.s(e);
    } finally{
        $b34bd66f0aa7fdf3$var$bo(t);
    }
}
var $b34bd66f0aa7fdf3$export$fe95e48202120e29 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$ua(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.outputSegmentationMasks = !1, this.h = new $b34bd66f0aa7fdf3$var$Yi, t = new $b34bd66f0aa7fdf3$var$ti, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t), this.C = new $b34bd66f0aa7fdf3$var$Xi, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 3, this.C), this.j = new $b34bd66f0aa7fdf3$var$zi, $b34bd66f0aa7fdf3$var$sn(this.h, 0, 2, this.j), $b34bd66f0aa7fdf3$var$pn(this.j, 4, 1), $b34bd66f0aa7fdf3$var$gn(this.j, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.C, 2, .5), $b34bd66f0aa7fdf3$var$gn(this.h, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$en(this.h, $b34bd66f0aa7fdf3$var$ti, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$sn(this.h, 0, 1, t);
    }
    o(t) {
        return "numPoses" in t && $b34bd66f0aa7fdf3$var$pn(this.j, 4, t.numPoses ?? 1), "minPoseDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.j, 2, t.minPoseDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.h, 4, t.minTrackingConfidence ?? .5), "minPosePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$gn(this.C, 2, t.minPosePresenceConfidence ?? .5), "outputSegmentationMasks" in t && (this.outputSegmentationMasks = t.outputSegmentationMasks ?? !1), this.l(t);
    }
    F(t, e, n) {
        const r = "function" != typeof e ? e : {};
        return this.s = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$fh(this), $b34bd66f0aa7fdf3$var$da(this, t, r), $b34bd66f0aa7fdf3$var$dh(this);
    }
    G(t, e, n, r) {
        const s = "function" != typeof n ? n : {};
        return this.s = "function" == typeof n ? n : r, $b34bd66f0aa7fdf3$var$fh(this), $b34bd66f0aa7fdf3$var$pa(this, t, s, e), $b34bd66f0aa7fdf3$var$dh(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$ss;
        $b34bd66f0aa7fdf3$var$ns(t, "image_in"), $b34bd66f0aa7fdf3$var$ns(t, "norm_rect"), $b34bd66f0aa7fdf3$var$rs(t, "normalized_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "world_landmarks"), $b34bd66f0aa7fdf3$var$rs(t, "segmentation_masks");
        const e = new $b34bd66f0aa7fdf3$var$Ur;
        $b34bd66f0aa7fdf3$var$yn(e, $b34bd66f0aa7fdf3$var$qi, this.h);
        const n = new $b34bd66f0aa7fdf3$var$qr;
        $b34bd66f0aa7fdf3$var$Hr(n, "mediapipe.tasks.vision.pose_landmarker.PoseLandmarkerGraph"), $b34bd66f0aa7fdf3$var$Yr(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$Yr(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$$r(n, "NORM_LANDMARKS:normalized_landmarks"), $b34bd66f0aa7fdf3$var$$r(n, "WORLD_LANDMARKS:world_landmarks"), n.o(e), $b34bd66f0aa7fdf3$var$es(t, n), $b34bd66f0aa7fdf3$var$wo(this, t), this.g.attachProtoVectorListener("normalized_landmarks", (t, e)=>{
            this.landmarks = [];
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Ms(e), this.landmarks.push($b34bd66f0aa7fdf3$var$Qi(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("normalized_landmarks", (t)=>{
            this.landmarks = [], $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.g.attachProtoVectorListener("world_landmarks", (t, e)=>{
            this.worldLandmarks = [];
            for (const e of t)t = $b34bd66f0aa7fdf3$var$Ls(e), this.worldLandmarks.push($b34bd66f0aa7fdf3$var$to(t));
            $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("world_landmarks", (t)=>{
            this.worldLandmarks = [], $b34bd66f0aa7fdf3$var$_o(this, t);
        }), this.outputSegmentationMasks && ($b34bd66f0aa7fdf3$var$$r(n, "SEGMENTATION_MASK:segmentation_masks"), $b34bd66f0aa7fdf3$var$Ao(this, "segmentation_masks"), this.g.T("segmentation_masks", (t, e)=>{
            this.v = t.map((t)=>$b34bd66f0aa7fdf3$var$ga(this, t, !this.s)), $b34bd66f0aa7fdf3$var$_o(this, e);
        }), this.g.attachEmptyPacketListener("segmentation_masks", (t)=>{
            this.v = [], $b34bd66f0aa7fdf3$var$_o(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.G, $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.detect = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.F, $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.setOptions = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.o, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, e);
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.POSE_CONNECTIONS = $b34bd66f0aa7fdf3$var$aa([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    7
], [
    0,
    4
], [
    4,
    5
], [
    5,
    6
], [
    6,
    8
], [
    9,
    10
], [
    11,
    12
], [
    11,
    13
], [
    13,
    15
], [
    15,
    17
], [
    15,
    19
], [
    15,
    21
], [
    17,
    19
], [
    12,
    14
], [
    14,
    16
], [
    16,
    18
], [
    16,
    20
], [
    16,
    22
], [
    18,
    20
], [
    11,
    23
], [
    12,
    24
], [
    23,
    24
], [
    23,
    25
], [
    24,
    26
], [
    25,
    27
], [
    26,
    28
], [
    27,
    29
], [
    28,
    30
], [
    29,
    31
], [
    30,
    32
], [
    27,
    31
], [
    28,
    32
]);
 //# sourceMappingURL=vision_bundle_mjs.js.map


const $0f592d681121713f$var$demosSection = document.getElementById("demos");
let $0f592d681121713f$var$poseLandmarker;
let $0f592d681121713f$var$webcamRunning = false;
let $0f592d681121713f$var$runningMode = "IMAGE";
const $0f592d681121713f$var$enableWebcamButton = document.getElementById("webcamButton");
const $0f592d681121713f$var$videoHeight = 360;
const $0f592d681121713f$var$videoWidth = 480;
// Before we can use PoseLandmarker class we must wait for it to finish
// loading. Machine Learning models can be large and take a moment to
// get everything needed to run.
const $0f592d681121713f$var$createPoseLandmarker = async ()=>{
    const vision = await (0, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3).forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm");
    $0f592d681121713f$var$poseLandmarker = await (0, $b34bd66f0aa7fdf3$export$fe95e48202120e29).createFromOptions(vision, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task`,
            delegate: "GPU"
        },
        runningMode: "VIDEO",
        numPoses: 2
    });
};
$0f592d681121713f$var$createPoseLandmarker().then(()=>{
    $0f592d681121713f$var$demosSection?.classList.remove("invisible");
});
const $0f592d681121713f$var$video = document.getElementById("webcam");
const $0f592d681121713f$var$canvasElement = document.getElementById("output_canvas");
const $0f592d681121713f$var$canvasCtx = $0f592d681121713f$var$canvasElement.getContext("2d");
const $0f592d681121713f$var$drawingUtils = new (0, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de)($0f592d681121713f$var$canvasCtx);
// Check if webcam access is supported.
const $0f592d681121713f$var$hasGetUserMedia = ()=>!!navigator.mediaDevices?.getUserMedia;
// If webcam supported, add event listener to button for when user
// wants to activate it.
if ($0f592d681121713f$var$hasGetUserMedia()) $0f592d681121713f$var$enableWebcamButton.addEventListener("click", $0f592d681121713f$var$enableCam);
else console.warn("getUserMedia() is not supported by your browser");
// Enable the live webcam view and start detection.
function $0f592d681121713f$var$enableCam(event) {
    if (!$0f592d681121713f$var$poseLandmarker) {
        console.log("Wait! poseLandmaker not loaded yet.");
        return;
    }
    if ($0f592d681121713f$var$webcamRunning === true) {
        $0f592d681121713f$var$webcamRunning = false;
        $0f592d681121713f$var$enableWebcamButton.innerText = "DETECT POSE";
    } else {
        $0f592d681121713f$var$webcamRunning = true;
        $0f592d681121713f$var$enableWebcamButton.innerText = "STOP DETECTION";
    }
    // getUsermedia parameters.
    const constraints = {
        video: true
    };
    // Activate the webcam stream.
    navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
        $0f592d681121713f$var$video.srcObject = stream;
        $0f592d681121713f$var$video.addEventListener("loadeddata", $0f592d681121713f$var$predictWebcam);
    });
}
let $0f592d681121713f$var$lastVideoTime = -1;
async function $0f592d681121713f$var$predictWebcam() {
    $0f592d681121713f$var$canvasElement.style.height = `${$0f592d681121713f$var$videoHeight}px`;
    $0f592d681121713f$var$canvasElement.style.width = `${$0f592d681121713f$var$videoWidth}px`;
    $0f592d681121713f$var$video.style.height = `${$0f592d681121713f$var$videoHeight}px`;
    $0f592d681121713f$var$video.style.width = `${$0f592d681121713f$var$videoWidth}px`;
    // Now let's start detecting the stream.
    if ($0f592d681121713f$var$runningMode === "IMAGE") {
        $0f592d681121713f$var$runningMode = "VIDEO";
        await $0f592d681121713f$var$poseLandmarker.setOptions({
            runningMode: "VIDEO"
        });
    }
    let startTimeMs = performance.now();
    if ($0f592d681121713f$var$lastVideoTime !== $0f592d681121713f$var$video.currentTime) {
        $0f592d681121713f$var$lastVideoTime = $0f592d681121713f$var$video.currentTime;
        $0f592d681121713f$var$poseLandmarker.detectForVideo($0f592d681121713f$var$video, startTimeMs, (result)=>{
            $0f592d681121713f$var$visualizePose(result);
            const framing = $0f592d681121713f$var$analyzeFraming(result, $0f592d681121713f$var$videoWidth, $0f592d681121713f$var$videoHeight);
            console.log("framing:", framing);
            const isFramed = $0f592d681121713f$var$isUserFullyFramed(result);
            console.log("isFramed:", isFramed);
        });
    }
    // Call this function again to keep predicting when the browser is ready.
    if ($0f592d681121713f$var$webcamRunning === true) window.requestAnimationFrame($0f592d681121713f$var$predictWebcam);
}
function $0f592d681121713f$var$visualizePose(result) {
    $0f592d681121713f$var$canvasCtx.save();
    $0f592d681121713f$var$canvasCtx.clearRect(0, 0, $0f592d681121713f$var$canvasElement.width, $0f592d681121713f$var$canvasElement.height);
    for (const landmark of result.landmarks){
        $0f592d681121713f$var$drawingUtils.drawLandmarks(landmark, {
            radius: (data)=>(0, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de).lerp(data.from.z, -0.15, 0.1, 0.5, 1)
        });
        $0f592d681121713f$var$drawingUtils.drawConnectors(landmark, (0, $b34bd66f0aa7fdf3$export$fe95e48202120e29).POSE_CONNECTIONS);
    }
    $0f592d681121713f$var$canvasCtx.restore();
}
function $0f592d681121713f$var$analyzeFraming(result, videoWidth, videoHeight) {
    const landmarks = result.landmarks[0];
    // You can adjust these threshold values based on your requirements
    const edgeThreshold = 0.05; // percentage close to the edge
    const centerThreshold = 0.25; // percentage close to the center
    const headPosition = landmarks[0]; // Assuming the first landmark corresponds to the head
    const footPosition = landmarks[landmarks.length - 1]; // Assuming the last landmark corresponds to the feet
    if (headPosition.y < edgeThreshold || footPosition.y > 1 - edgeThreshold) return "TOO_CLOSE";
    else if (headPosition.y > centerThreshold && footPosition.y < 1 - centerThreshold) return "TOO_FAR";
    return "PERFECT";
}
function $0f592d681121713f$var$isUserFullyFramed(result) {
    console.log("isUserFullyFramed -> result:", result);
    const edgeThreshold = 0.05; // 5% of the frame's height/width for leeway
    for (const landmark of result.landmarks[0])if (landmark.x < edgeThreshold || landmark.x > 1 - edgeThreshold || landmark.y < edgeThreshold || landmark.y > 1 - edgeThreshold) {
        console.log("isUserFullyFramed -> landmark.x:", landmark.x);
        // If any landmark is too close to the frame's edge, user might not be fully framed
        return false;
    }
    return true;
}


//# sourceMappingURL=index.a400a0a1.js.map
